export default {
	"access.organization.name": "Access to organization card",
	"access.user.card": "Access to user card",
	"action.customize.view": "Personalizza vista",
	"action.default.view": "Visualizzazione predefinita",
	"action.viewcart": "Vedi carrello",
	"active": "Active",
	"add-suborg.add-suborg": "Aggiungi organizzazione secondaria",
	"add-suborg.admin-info": "Informazioni sull'amministratore",
	"add-suborg.administrator": "Amministratore",
	"add-suborg.confirmation": "Conferma",
	"add-suborg.email": "E-mail dell'amministratore",
	"add-suborg.firstname": "Nome dell'amministratore",
	"add-suborg.id": "ID organizzazione",
	"add-suborg.intro": "Per l'organizzazione Arcelormittal Europe, seleziona un'organizzazione esistente o crea una nuova organizzazione:",
	"add-suborg.lastname": "Cognome dell'amministratore",
	"add-suborg.matchin-org-intro": "Utilizza i dati dell'organizzazione corrispondente:",
	"add-suborg.matching-organizations": "Organizzazioni corrispondenti",
	"add-suborg.new-org-intro": "Creare una nuova sotto-organizzazione da zero:",
	"add-suborg.org-info": "Informazioni sull'organizzazione",
	"add-suborg.org-name": "Nome organizzazione",
	"add-suborg.organization-details": "Dettagli organizzazione",
	"add-suborg.please-select": "Seleziona un'opzione",
	"add-suborg.quick-search": "Cerca un utente",
	"add-suborg.vat-num-already-exists": "Il numero di partita IVA esiste già. Si prega di indicare un nuovo numero di partita IVA",
	"add-suborg.vat-number": "Numero Partita Iva",
	"add-user.add-user": "Aggiungi utente",
	"add-user.admin-user": "Promuovi come amministratore per questa organizzazione",
	"add-user.confirmation": "Conferma",
	"add-user.email": "E-mail",
	"add-user.email-exist": "L'ID e-mail esiste già",
	"add-user.intro": "Per l'organizzazione Arcelormittal Europe, seleziona un utente esistente o crea un nuovo utente:",
	"add-user.matchin-users-intro": "Utilizza i dati degli utenti corrispondenti:",
	"add-user.matching-users": "Utenti corrispondenti",
	"add-user.name": "Nome",
	"add-user.new-user-intro": "  Crea un nuovo utente da zero:",
	"add-user.please-select": "Seleziona un'opzione",
	"add-user.proceed-to-creation": "Procedi alla creazione",
	"add-user.referal-organization": "Organizzazione di riferimento",
	"add-user.required": "Obbligatorio",
	"add-user.services": "Servizi",
	"add-user.services-management": "Gestione servizi",
	"add-user.user-creation": "Creazione utente",
	"add-user.user-email": "E-mail",
	"add-user.user-exists": "L'utente selezionato esiste già per l'organizzazione",
	"add-user.user-firstname": "Nome",
	"add-user.user-informations": "Informazioni utente",
	"add-user.user-lastname": "Cognome",
	"add-user.user-not-active": "Utente selezionato non attivo",
	"add-user.user-type": "Type of user",
	"add.item.to.cart.error.msg": "Qualcosa è andato storto nell'aggiunta di articoli al carrello, si prega di riprovare dopo qualche tempo.",
	"add.to.cart.label": "Aggiungi al carrello",
	"administrator.message": "è l'amministratore dell'organizzazione:",
	"ag-grid.copy": "Copia",
	"ag-grid.copyWithHeaders": "Copia con le intestazioni",
	"ag-grid.csvExport": "CSV Esportare",
	"ag-grid.excelExport": "Excel Esportare (.xlsx)&lrm;",
	"ag-grid.excelXmlExport": "Excel Esportare (.xlm)&lrm;",
	"ag-grid.export": "Esportare",
	"ag-grid.paste": "Incolla",
	"all.productsFamilies.not.available": "Tutti i prodottiFamiglie non disponibili",
	"application.procurement.supplier.rfqNumber": "Numero RFQ del fornitore",
	"aqdb.N.of.dispatch.note": "N of Dispatch Note",
	"aqdb.ageing.duration": "Duration of ageing",
	"aqdb.ageing.temp": "Temperature of ageing",
	"aqdb.aluminium": "% Al",
	"aqdb.anisotropy.avg.r": "R average",
	"aqdb.anisotropy.direction": "Cutting Direction Compared to Rolling",
	"aqdb.anisotropy.r": "Value R",
	"aqdb.arsenic": "% Ar",
	"aqdb.article.reference": "Article reference",
	"aqdb.aspect.side.1": "Aspect side 1 code",
	"aqdb.aspect.side.2": "Aspect side 2 code",
	"aqdb.av.date": "Available date",
	"aqdb.avg.hardening.ratio": "Coefficient of Average Work Hardening",
	"aqdb.axis": "Axis",
	"aqdb.bakeHardening.with.elongation": "Bake-hardening with 2% elongation",
	"aqdb.bakeHardening.without.elongation": "Bake-hardening without elongation",
	"aqdb.base.product.number": "Base product number",
	"aqdb.base.product.release": "Base product release",
	"aqdb.batch": "Batch",
	"aqdb.batch.reference": "Batch reference",
	"aqdb.bend.indicator": "Code folding",
	"aqdb.boron": "% B",
	"aqdb.calcium": "% Ca",
	"aqdb.carbon": "% C",
	"aqdb.carbon.eq.formula": "Formula carbon-equivalent",
	"aqdb.carbon.equivalent": "Carbon equivalent",
	"aqdb.casting.date": "Casting date",
	"aqdb.casting.mill": "Casting Mill",
	"aqdb.cerium": "% Ce",
	"aqdb.chemical.characteristics": "Chemical characteristics",
	"aqdb.chemical.characteristics.cast.analysis": "Chemical characteristics - Cast analysis",
	"aqdb.chemical.characteristics.product.analysis": "Chemical characteristics - Product analysis",
	"aqdb.chemical.formula": "Another combination",
	"aqdb.chemical.surface.chemical.treatment.avg1": "Average value 1",
	"aqdb.chemical.surface.chemical.treatment.avg2": "Average value 2",
	"aqdb.chemical.surface.chemical.treatment.avg3": "Average value 3",
	"aqdb.chemical.surface.chemical.treatment.avg4": "Average value 4",
	"aqdb.chemical.surface.chemical.treatment.avg5": "Average value 5",
	"aqdb.chemical.surface.chemical.treatment.element1": "Chemical element 1",
	"aqdb.chemical.surface.chemical.treatment.element2": "Chemical element 2",
	"aqdb.chemical.surface.chemical.treatment.element3": "Chemical element 3",
	"aqdb.chemical.surface.chemical.treatment.element4": "Chemical element 4",
	"aqdb.chemical.surface.chemical.treatment.element5": "Chemical element 5",
	"aqdb.chemical.surface.chemical.treatment.type": "Type of chemical coating",
	"aqdb.chemical.surface.treatment": "Coating / Surface characteristics - Inorganic coating",
	"aqdb.chromium": "% Cr",
	"aqdb.coating.surface.face": "Face",
	"aqdb.coating.surface.side": "Side",
	"aqdb.code": "Code",
	"aqdb.combination.value": "Value combination",
	"aqdb.commercial.quality": "Commercial quality",
	"aqdb.complete.message": "Indicator of complete message",
	"aqdb.copper": "% Cu",
	"aqdb.customer.article.ref": "Customer Article Ref.",
	"aqdb.customer.product": "Customer product",
	"aqdb.customer.product.data": "Customer products data",
	"aqdb.datas.transmitted.on.certificate": "Data transmitted on certificate",
	"aqdb.date": "Date",
	"aqdb.date.chemical": "Identification Date",
	"aqdb.delivery.mill": "Delivery mill",
	"aqdb.description": "Technical Quality Label",
	"aqdb.dimensions.form": "Dimensions & Form",
	"aqdb.direction.L": "Longitudinal",
	"aqdb.direction.T": "Transverse",
	"aqdb.dis.elongation": "Lengthening distributed",
	"aqdb.dispatch.advice.number": "Dispatch advice number",
	"aqdb.dispatch.date": "Dispatch Date",
	"aqdb.erichsen.index": "Erichsen index",
	"aqdb.external.diameter": "External diameter of MU",
	"aqdb.face.appearance.code1": "Face appearance code 1",
	"aqdb.face.appearance.code2": "Face appearance code 2",
	"aqdb.family.group.code": "Family group code",
	"aqdb.flag.complete": "Complete",
	"aqdb.flag.incomplete": "Incomplete",
	"aqdb.form": "Form",
	"aqdb.format.actual": "Format (actual/ordered)",
	"aqdb.formula.cal02": "Formula CAL02",
	"aqdb.formula.cal15": "Formula CAL15",
	"aqdb.grade": "Grade",
	"aqdb.gross.weight": "Gross Weight",
	"aqdb.hardness.index": "Hardness number",
	"aqdb.hardness.type": "Condition of the hardness test",
	"aqdb.heat.number": "Heat N°'",
	"aqdb.hydrogen": "% H",
	"aqdb.induction.10000w": "Induction at 10000 W",
	"aqdb.induction.2500w": "Induction at 2500 W",
	"aqdb.induction.5000w": "Induction at 5000 W",
	"aqdb.internal.diameter": "Internal diameter of MU",
	"aqdb.label": "Dati AQDB",
	"aqdb.lead": "% Pb",
	"aqdb.level": "Palier",
	"aqdb.losses.15t": "Losses at 1,5 T",
	"aqdb.losses.1t": "Losses at 1 T",
	"aqdb.magnetic.characteristicList": "Magnetic characteristics",
	"aqdb.manganese": "% Mn",
	"aqdb.marked.identity": "Marked Identity",
	"aqdb.measure.type": "Measure type",
	"aqdb.measured.datas": "Measured data",
	"aqdb.mechanical.characteristics.anisotropy": "Mechanical characteristics - Anisotropy",
	"aqdb.mechanical.characteristics.bake.hardening": "Mechanical characteristics - Bake hardening",
	"aqdb.mechanical.characteristics.bending": "Mechanical characteristics - Bending",
	"aqdb.mechanical.characteristics.erichsen": "Mechanical characteristics - Erichsen",
	"aqdb.mechanical.characteristics.hardness": "Mechanical characteristics - Hardness",
	"aqdb.mechanical.characteristics.impact.resistance": "Mechanical characteristics - Resilience",
	"aqdb.mechanical.characteristics.tensile.test": "Mechanical characteristics - Tensile test",
	"aqdb.metal.coating.aluminium": "% Aluminium",
	"aqdb.metal.coating.average.quantity": "Average quantity",
	"aqdb.metal.coating.characteristics": "Coating / Surface characteristics - Metal coating",
	"aqdb.metal.coating.delta.phase": "Mass Phase Delta",
	"aqdb.metal.coating.dzeta.phase": "Mass Phase Dzeta",
	"aqdb.metal.coating.gamma.phase": "Mass Phase Gamma",
	"aqdb.metal.coating.iron.rate": "Iron rate in galvallia",
	"aqdb.metal.coating.lead": "% Lead",
	"aqdb.metal.coating.measure.type": "Type of measurement",
	"aqdb.metal.coating.nature": "Nature of metallic coating",
	"aqdb.metal.coating.nickel": "% Nickel",
	"aqdb.metal.coating.powdering": "Powdering",
	"aqdb.metal.coating.quantity.centre": "Quantity Centre",
	"aqdb.metal.coating.quantity.edge1": "Quantity Edge 1",
	"aqdb.metal.coating.quantity.edge2": "Quantity Edge 2",
	"aqdb.metal.coating.spangling": "Spangling",
	"aqdb.metal.unit": "Metal unit",
	"aqdb.metal.unit.date": "Metal Unit Identification Date",
	"aqdb.metal.unit.information": "Metal unit informations",
	"aqdb.metal.unit.mill": "Metal Unit Identification Mill",
	"aqdb.mill.cast": "Mill Cast Number",
	"aqdb.mill.cast.number": "Mill Cast Number",
	"aqdb.mill.code": "Receiving mill code",
	"aqdb.mill.description": "Mill",
	"aqdb.mill.internal.ref": "Mill internal reference",
	"aqdb.modelled.data": "Modelled data",
	"aqdb.molybdenum": "% Mo",
	"aqdb.mpa.unit": "megapascal (Mpa)",
	"aqdb.nature": "Nature",
	"aqdb.net.weight": "Net weight (t)",
	"aqdb.nickel": "% Ni",
	"aqdb.niobium": "% Nb",
	"aqdb.nitrogen": "% N2",
	"aqdb.no": "No",
	"aqdb.nominal.thickness": "Nominal thickness",
	"aqdb.nominal.width": "Nominal width",
	"aqdb.notch.average.crystallinity.index": "Average crystallinity index",
	"aqdb.notch.average.ductility.rate": "Average ductility rate",
	"aqdb.notch.average.energy": "Average energy (in Joules)",
	"aqdb.notch.crystallinity.index1": "Crystallinity index 1",
	"aqdb.notch.crystallinity.index2": "Crystallinity index 2",
	"aqdb.notch.crystallinity.index3": "Crystallinity index 3",
	"aqdb.notch.energy1": "Energy 1 (in Joules)",
	"aqdb.notch.energy2": "Energy 2 (in Joules)",
	"aqdb.notch.energy3": "Energy 3 (in Joules)",
	"aqdb.notch.percent.ductility1": "Ductility rate 1",
	"aqdb.notch.percent.ductility2": "Ductility rate 2",
	"aqdb.notch.percent.ductility3": "Ductility rate 3",
	"aqdb.organic.coating.bending": "Bending",
	"aqdb.organic.coating.brilliance": "Brilliance",
	"aqdb.organic.coating.characteristics": "Coating / Surface characteristics - Organic coating",
	"aqdb.organic.coating.colour": "Colour",
	"aqdb.organic.coating.delta.a": "Delta A",
	"aqdb.organic.coating.delta.b": "Delta B",
	"aqdb.organic.coating.delta.e": "Delta E",
	"aqdb.organic.coating.delta.l": "Delta L",
	"aqdb.organic.coating.nature": "Nature of organic coating",
	"aqdb.organic.coating.reticulation": "Reticulation",
	"aqdb.organic.coating.thickness": "Thickness",
	"aqdb.origin.mill": "Origin Mill",
	"aqdb.other.characteristics": "Other Characteristics",
	"aqdb.oui": "Oui",
	"aqdb.phosphorus": "% P",
	"aqdb.pos.across.length": "Position test-tube in the length of the product",
	"aqdb.pos.across.width": "Position test-tube in the width of the product",
	"aqdb.product.family": "Product family",
	"aqdb.quality.code": "Technical Quality Code",
	"aqdb.quality.data": "consulta i dati sulla qualità",
	"aqdb.quality.label": "Technical Quality Label",
	"aqdb.quality.version": "Technical Quality Version",
	"aqdb.quarter": "Quarter",
	"aqdb.recipient": "Recipient",
	"aqdb.release": "Technical Quality Version",
	"aqdb.roughness.characteristics": "Coating / Surface characteristics - Roughness",
	"aqdb.roughness.cut.off": "Cut-Off",
	"aqdb.roughness.obtainment": "Method of obtainment",
	"aqdb.roughness.peaks": "Number of peaks",
	"aqdb.roughness.ra": "Ra",
	"aqdb.roughness.rt": "Rt",
	"aqdb.roughness.rz": "Rz",
	"aqdb.roughness.threshold": "Threshold",
	"aqdb.roughness.w": "W",
	"aqdb.sample.type": "Type of test-tube",
	"aqdb.segment": "Segment",
	"aqdb.segments.no": "Number of Segments",
	"aqdb.serial.number": "Serial number",
	"aqdb.shipping": "Shipping Information",
	"aqdb.silicium": "% Si",
	"aqdb.steel.condition": "State of Metal",
	"aqdb.sulphur": "% S",
	"aqdb.surface.cleanliness.carbon": "Surface carbon",
	"aqdb.surface.cleanliness.characteristics": "Coating / Surface characteristics - Surface cleanliness",
	"aqdb.surface.cleanliness.iron": "Surface iron",
	"aqdb.surface.mu": "Surface of MU",
	"aqdb.technical.grade": "Technical grade",
	"aqdb.temp.notch": "Temperature notch test",
	"aqdb.tensile.direction": "Direction",
	"aqdb.tensile.re.rm": "Re/Rm",
	"aqdb.tensile.total.lengthening": "Total Lengthening",
	"aqdb.tensile.ultimate.tensile.stress": "Ultimate Tensile Stress",
	"aqdb.tensile.work.hardening.coefficient": "Work-hardening coefficient",
	"aqdb.test.condition": "Condition of the test",
	"aqdb.test.number.anisotropy": "Number of the test of anisotropy",
	"aqdb.test.number.bakehardening": "Number of the test Bake Hardening",
	"aqdb.test.number.bending": "Number of the bending test",
	"aqdb.test.number.erichsen": "Number of the test of Erichsen",
	"aqdb.test.number.hardness": "Number of the Hardness test",
	"aqdb.test.number.res": "Number of the reslience test",
	"aqdb.test.number.tensile": "Number of the tensile test",
	"aqdb.test.steel.condition": "State of the test-tube",
	"aqdb.test.temp": "Temperature of the test",
	"aqdb.thickness.mm": "Thickness (mm)",
	"aqdb.tin": "% Sn",
	"aqdb.titanium": "% Ti",
	"aqdb.unit": "Unit",
	"aqdb.user": "User",
	"aqdb.value.cal02": "CAL02",
	"aqdb.value.cal15": "CAL15",
	"aqdb.vanadium": "% V",
	"aqdb.weight.mu": "Net weight/Gross weight",
	"aqdb.width.mm": "Width (mm)",
	"aqdb.yes": "Yes",
	"aqdb.yield.stress": "Yield Stress",
	"aqdb.zinc": "% Zn",
	"aqdb.zirconium": "% Zr",
	"arcelormittal.need4steel.action.next": "Successivo",
	"arcelormittal.need4steel.action.proceed.to.order.button": "Procedi con l'ordine",
	"arcelormittal.need4steel.entry": "ArcelorMittal Need4Steel®",
	"arcelormittal.need4steel.menu.entry": "ArcelorMittal Need4Steel",
	"attachment.limit.description": "PDF, DOC, XLS, PPT or images only. Max 20MB per file and max 3 files.",
	"auction-material.category.subcategory": "Categoria/Sottocategoria",
	"auction-material.details": "Dettagli sul materiale",
	"auction-material.downgrading.reason": "Motivo del declassamento",
	"auction-material.oil.type": "Tipo di olio",
	"auction-offer.now-rows": "Nessuna offerta d'asta aperta disponibile",
	"auction-offer.soldTo.changed.warning": "If you change the corporate name, all the bid details you have entered/modified in current session will be lost.",
	"auction.bid.list": "Aste - Elenco delle offerte",
	"auction.bid.week": "Settimana delle offerte",
	"auction.bidding": "Offerte di aste su",
	"auction.bids": "Offerte",
	"auction.bundle.number": "Numero del pacchetto",
	"auction.confirm.bid": "Conferma offerta",
	"auction.confirmation": "Conferma",
	"auction.dashboard": "Cruscotto azioni",
	"auction.description": "Descrizione dell'asta",
	"auction.ended": "Terminata",
	"auction.entry": "Azioni",
	"auction.main.steelgrade": "Acciaio principale (per volume)",
	"auction.market": "Mercato",
	"auction.mill": "Stabilimento",
	"auction.my.auction.bids": "Le mie offerte d'asta",
	"auction.name": "Nome dell'asta",
	"auction.new.offer.check": "Verifica nuove offerte sulle azioni",
	"auction.offer.bid.awarded": "Awarded",
	"auction.offer.bid.pending": "Pending",
	"auction.offer.bid.rejected": "Rejected",
	"auction.offer.bundle": "Pacchetto",
	"auction.offer.clear.infos": "Cancella informazioni",
	"auction.offer.customer.reference": "Riferimento cliente",
	"auction.offer.customerref.mandatory": "Il campo Riferimento cliente è obbligatorio",
	"auction.offer.delivery.address.mandatory": "Delivery address is mandatory",
	"auction.offer.effective.price": "Prezzo effettivo",
	"auction.offer.exw.price": "Prezzo EXW €/t",
	"auction.offer.exwprice.mandatory": "Il prezzo Exw è obbligatorio",
	"auction.offer.invoicing.in": "Fatturazione tra",
	"auction.offer.lanned.loading.date": "Data di carico programmata",
	"auction.offer.no.bids": "No bids available",
	"auction.offer.payment.condition": "Condizioni di pagamento",
	"auction.offer.tmode.mandatory": "La modalità di trasporto è obbligatoria",
	"auction.offer.transport.cost": "Costo del trasporto",
	"auction.offer.transport.invoiced.conditions": "Condizioni di trasporto fatturate",
	"auction.offer.type.of.maritime.transport": "Tipo di trasporto marittimo",
	"auction.overview": "Panoramica delle tue aste di questa settimana",
	"auction.price.unit.et": "€/t",
	"auction.product.type": "Tipo di prodotto",
	"auction.selection": "Selezione dell'asta",
	"auction.submit.not.authorized.internal": "Invio di un'azione non autorizzata in modalità di simulazione o di delega",
	"auction.timer.days": "giorni",
	"auction.timer.endsin": "Termina tra",
	"auction.timer.hours": "ore",
	"auction.timer.minutes": "minuti",
	"auction.timer.weight.available": "Disponibile",
	"auction.transport.price": "Costo del trasporto (€/t)",
	"auction.weight.unit.gross": "lordo",
	"auctions.menu": "Aste",
	"auctions.opened": "aste aperte",
	"batch-card.all-documents": "Tutti i documenti di questo batch",
	"batch-card.batch-information": "Informazione sul lotto",
	"batch-card.batch-status": "Status del batch",
	"batch-card.certificate-display-all": "Visualizza tutti i certificati",
	"batch-card.create-call-off": "Avvia un nuovo eCall-off",
	"batch-card.current-location": "Posizione attuale",
	"batch-card.customer-article-reference": "Riferimento articolo cliente",
	"batch-card.customer-order-number": "Numero d’ordine cliente",
	"batch-card.data-not-found": "Batch data not found",
	"batch-card.date-available-for-dispatch": "Data disponibile per evasione",
	"batch-card.days-in-stock": "Numero di giorni in scadenza",
	"batch-card.detailed-batch-status": "Status del batch in dettaglio",
	"batch-card.dispatch-advice-display-all": "Visualizza tutti gli avvisi di spedizione",
	"batch-card.document-date": "Data",
	"batch-card.document-number": "Numero documento",
	"batch-card.document-show": "Visualizza documento",
	"batch-card.document-type": "Tipo",
	"batch-card.final-use": "Uso finale",
	"batch-card.followup": "Follow-up",
	"batch-card.gross-weight": "Peso lordo",
	"batch-card.heat-number": "Numero di colata",
	"batch-card.invoice-display-all": "Visualizza tutte le fatture",
	"batch-card.last-certificate": "Certificato più recente",
	"batch-card.last-dispatch-advice": "Ultimi avvisi di spedizione",
	"batch-card.last-documents": "Ultimi documenti",
	"batch-card.last-invoice": "Fattura più recente",
	"batch-card.length": "Lunghezza (mm)",
	"batch-card.mill": "Acciaieria",
	"batch-card.mill-order-number": "Numero d’ordine acciaieria",
	"batch-card.net-weight": "Peso netto",
	"batch-card.package-serial-number": "Numero di serie imballaggio",
	"batch-card.planned-loading-date": "Data pianificata per il carico",
	"batch-card.shipments": "Spedizioni",
	"batch-card.steelgrade": "Grado di acciaio",
	"batch-card.stock-alert": "Avviso giacenza",
	"batch-card.supplier-order-number": "Numero d’ordine fornitore",
	"batch-card.thickness": "Spessore (mm)",
	"batch-card.width": "Larghezza (mm)",
	"batch-list.last-seen": "Ultimi batch visti",
	"batch.card": "Informazione sul lotto",
	"batch.card.article": "Articolo",
	"batch.card.customer": "Cliente",
	"batch.card.dimensions": "Dimensioni",
	"batch.card.final-use": "Uso finale",
	"batch.card.go-to-the-order": "Vai all’ordine",
	"batch.card.information": "Informazione sul lotto",
	"batch.card.invoiced": "Fattura creata",
	"batch.card.mill": "Acciaieria",
	"batch.card.mill-order": "Ordine acciaieria",
	"batch.card.order": "Ordine",
	"batch.card.weight": "Peso",
	"batch.coil-length": "Lunghezza (mm)",
	"batch.current-location": "Località attuale",
	"batch.current.location": "Posizione attuale",
	"batch.date-for-dispatch": "Data disponibile per la spedizione",
	"batch.despatch.advice": "Avvisi evasione",
	"batch.despatch.date": "Data evasione",
	"batch.detailed-batch-status": "Stato lotto dettagliato",
	"batch.ecall-status": "eCall-off status",
	"batch.from.same.invoice": "Solo i lotti dal numero di fattura:",
	"batch.from.same.invoice.available": "sono disponibili per questo reclamo",
	"batch.gross": "Peso lordo",
	"batch.gross-t": "Lordo (t)",
	"batch.heat-number": "Numero di colata",
	"batch.in-stock": "Disponibile",
	"batch.in-transit-detail": "In transito - Dettaglio",
	"batch.invoice.date": "Invoice date",
	"batch.length": "Lunghezza",
	"batch.net": "Peso netto",
	"batch.net-t": "Net (t)",
	"batch.not.invoiced": "Lotto non fatturato",
	"batch.not.invoiced.select.other": "Ti preghiamo di tornare più tardi per sollevare un problema di qualità su questa unità di materiale.",
	"batch.not.invoiced.sorry": "Siamo spiacenti, il lotto scelto non è ancora stato fatturato.",
	"batch.package-serial-number": "Numero di serie imballaggio",
	"batch.planned-loading-date": "Data di carico programmata",
	"batch.reference": "Lotto",
	"batch.requested-delivery-date": "Data di consegna richiesta per chiamata",
	"batch.requested-delivery-date-from": "Requested delivery date from",
	"batch.requested-delivery-date-to": "Requested delivery date to",
	"batch.shipment.date": "Data spedizione",
	"batch.shipto": "Spedisci a",
	"batch.status": "Stato lotto",
	"batch.supplier.invoice.number": "Invoice number",
	"batch.view.all": "Vedi tutti i batch",
	"batch.view.all.at": "Vedi tutti i batch di {{valore}}",
	"batches.detailed.batch.status": "Stato lotto dettagliato",
	"batches.doc": "Doc",
	"batches.gross-t": "Lordo (t)",
	"batches.net-t": "Netto (t)",
	"batches.number.of.day.in.stock": "Nb di giorni in giacenza",
	"blocked-service-alert.plural": "Scusami, questi servizi non sono attualmente disponibili, per favore riprova più tardi: {{services}}",
	"blocked-service-alert.refresh": "Aggiorna",
	"blocked-service-alert.singular": "Scusami, questo servizio non è attualmente disponibile, per favore riprova più tardi: {{service}}",
	"browse.files": "Browse files",
	"cancel.issue": "Cancel your issue",
	"card.no.selected": "nessun prodotto selezionato",
	"card.prototype": "Prototipo",
	"card.prototype.lastModificationdate": "Last modification date",
	"card.prototype.production": "Produzione",
	"card.selected": "{{value}} prodotti selezionati",
	"cdd.in.date": "CDD in giorno",
	"cdd.in.week": "CDD in settimana",
	"chart-title.M1": "Gen",
	"chart-title.M10": "Ott",
	"chart-title.M11": "Nov",
	"chart-title.M12": "Dic",
	"chart-title.M2": "Feb",
	"chart-title.M3": "Mar",
	"chart-title.M4": "Apr",
	"chart-title.M5": "Mag",
	"chart-title.M6": "Giu",
	"chart-title.M7": "Lug",
	"chart-title.M8": "Ago",
	"chart-title.M9": "Set",
	"chart-title.Q1": "Primo trimestre",
	"chart-title.Q2": "Secondo trimestre",
	"chart-title.Q3": "Terzo trimestre",
	"chart-title.Q4": "Quarto trimestre",
	"chart-title.S1": "S1",
	"chart-title.S2": "S2",
	"check.new.offer": "Verifica nuove offerte",
	"choose.customer.last.used": "Ultime selezioni:",
	"choose.customer.restrict": "Restringi la tua ricerca con l’utilizzo della APP SteelUser, in quanto applicazione dedicata al cliente.",
	"choose.customer.select": "In quanto utente interno devi selezionare il cliente per cui richiedi i dati",
	"choose.visibility.select": "Seleziona la visibilità tra le opzioni disponibili:",
	"claim-batch.receipt-date": "Data di ricezione",
	"claim.action.plan.notif": "Ove necessario, telefona al tuo contatto tecnico per ricevere un'azione correttiva",
	"claim.add-batch-to-this-issue": "Aggiungi lotto a questo problema",
	"claim.add.attachment": "Aggiungi allegato",
	"claim.additional.costs.invalid": "L'importo richiesto per altri costi deve essere valido.",
	"claim.additional.costs.mandatory": "L'importo richiesto per altri costi è obbligatorio",
	"claim.additional.costs.requested": "Costi aggiuntivi richiesti",
	"claim.amount.for.other.costs": "Importo richiesto per altri costi",
	"claim.amount.previous.value": "Il tuo valore precedente: {{value}}",
	"claim.amount.unit.error": "La fattura è espressa in:",
	"claim.archived": "Archivio",
	"claim.attach.several.documents": "Allega uno o più documenti",
	"claim.attachment.error": "L'allegato non è stato caricato correttamente. Si prega di riprovare.",
	"claim.attachment.filename.error": "Please make sure that your filename is less than 80 characters",
	"claim.attachment.limit.zl": "Il nome del file deve essere inferiore a 80 caratteri",
	"claim.attachment.limit.zr": "Si prega di fornire tutti i dettagli rilevanti necessari per convalidare l'importo e la quantità reclamati, come i numeri delle bobine interessate, il peso e qualsiasi altra informazione di supporto. Fornire informazioni complete e accurate ci aiuterà a elaborare il suo reclamo in modo rapido ed efficiente. Il nome del file deve essere inferiore a 80 caratteri",
	"claim.attachment.mandatory": "Ti preghiamo di aggiungere almeno un allegato",
	"claim.attachment.uploading.error": "Alcuni allegati sono ancora in corso di caricamento, attendere.",
	"claim.attachments": "Allegati",
	"claim.attachments.description": "Aggiungi almeno una foto o un video che possa aiutare ArcelorMittal a fornire feedback sulla tua richiesta",
	"claim.barcode.number": "Numero codice a barre",
	"claim.batch": "Lotto",
	"claim.batch.reference.mandatory": "Il Riferimento Lotto è obbligatorio",
	"claim.batch.selection": "Selezione lotto",
	"claim.batches": "Lotti",
	"claim.choose.defect": "Seleziona difetto",
	"claim.claimtype.label": "Tipo di reclamo",
	"claim.comment": "Commenta",
	"claim.comment.mandatory": "Il commento è obbligatorio",
	"claim.comment.placeholder": "Inserisci un breve commento per spiegare il problema di qualità. Cerca di essere il più dettagliato e accurato possibile.",
	"claim.contact.type.mandatory": "Il tipo di contatto è un dato obbligatorio.",
	"claim.created": "Creato",
	"claim.created.by": "Creato da",
	"claim.current.status": "Stato attuale",
	"claim.current.statusddot": "Status attuale:",
	"claim.dashboard.services": "I miei servizi",
	"claim.dashboard.services.claims": "Feedback sulla qualità",
	"claim.defect": "Difetto",
	"claim.defect.mandatory": "Il difetto è obbligatorio",
	"claim.display-pending-drafts": "Feedback in sospeso",
	"claim.display-saved-drafts": "Bozza(e) salvate",
	"claim.first.batch.selection": "Selezione primo lotto",
	"claim.full.quantity": "Quantità completa",
	"claim.go-back-to-batch-management": "Torna alla gestione del lotto",
	"claim.guarantee.request": "RICHIESTA NUOVA GARANZIA",
	"claim.impacted.quantity": "Quantità affetta",
	"claim.impacted.quantity.mandatory": "La quantità affetta è obbligatoria",
	"claim.impacted.quantity.minimum": "Immettere una quantità valida maggiore o uguale a 1.",
	"claim.impacted.quantity.t": "Quantità affetta (t)",
	"claim.last.modification": "Ultima modifica",
	"claim.main.batch.remove": "Rimuovi",
	"claim.main.batch.selected": "Lotto selezionato",
	"claim.material.costs": "Costi materiali",
	"claim.material.unit": "Unità materiale",
	"claim.multi.batch.related.order": "Ordine correlato",
	"claim.no.attachment": "Nessun allegato",
	"claim.no.reference": "Nessun riferimento",
	"claim.no.sample.needed": "Per questo difetto non è necessario alcun campione.",
	"claim.not-existing-or-not-permission": "Il reclamo non esiste o non sei autorizzato ad accedere alle informazioni sul reclamo.",
	"claim.optional": "Opzionale",
	"claim.other.amount.cost": "Importo richiesto per altri costi",
	"claim.paid.amount": "Importo pagato",
	"claim.placeholder.reference.number": "Numero di riferimento cliente",
	"claim.quality.issue": "Reclamo",
	"claim.quality.issue.information": "Informazioni di qualità",
	"claim.quality.issue.summary": "Riepilogo qualità",
	"claim.quantity.limit.error": "Quantità richiesta superiore a quella fatturata.",
	"claim.quantity.previous.value": "Il tuo valore precedente: {{value}}",
	"claim.quantity.tons.error": "La quantità interessata deve essere inferiore a 1000 per unità: tonnellate metriche",
	"claim.quantity.unit.error": "La fattura è espressa in:",
	"claim.raise-new-quality-issue": "Riporta un problema di qualità",
	"claim.receipt.date.mandatory": "La data di ricezione è obbligatoria",
	"claim.reference.number": "Numero di riferimento",
	"claim.request.type": "Tipo di richiesta",
	"claim.requested.amount": "Importo richiesto",
	"claim.requested.material.costs": "Costi dei materiali richiesti",
	"claim.sample": "Il campione sarà inviato a:",
	"claim.sample.agency": "Contatto commerciale",
	"claim.sample.cts": "Contatto tecnico",
	"claim.sample.mandatory": "Il campione è obbligatorio",
	"claim.sample.not": "Non invierò un campione",
	"claim.sample.not.recommended": "(non consigliato)",
	"claim.sample.other": "Altro",
	"claim.sample.other.comment": "Inserire la destinazione del campione",
	"claim.status.created": "Creato",
	"claim.total.amount": "Importo totale valutato",
	"claim.total.requested.amount": "Importo totale richiesto",
	"claim.total.requested.calculated": "Importo totale richiesto calcolato",
	"claim.total.weight": "Peso totale",
	"claim.type.filter.label": "Tipo di reclamo",
	"claim.type.zl": "Reclamo del cliente ZL",
	"claim.type.zr": "Regolarizzazione reclamo ZR",
	"claim.visit": "Contatto da ArcelorMittal",
	"claim.visit.text": "Voglio essere contattato da un contatto ArcelorMittal.",
	"claim.warning": "Avvertimento",
	"claim.warning.takenintoaccount": "Avvertimento preso in considerazione",
	"claim.zr.attachment.info": "Si prega di menzionare sempre tutti i lotti interessati e qualsiasi dettaglio rilevante aggiuntivo (ad es., quantità per lotto) per garantire un'elaborazione regolare e efficiente del reclamo.",
	"coil.calculator.additional.data": "Dati aggiuntivi",
	"coil.calculator.all.other.coils": "Tutte le altre bobine",
	"coil.calculator.density.text": "Si basa su una densità costante di \"7,85t/m³\".",
	"coil.calculator.inner.diameter": "Diametro interno bobina",
	"coil.calculator.inner.diameter.label": "Diametro interno bobina (mm)",
	"coil.calculator.inner.diameter.mandatory": "Il diametro interno della bobina è obbligatorio",
	"coil.calculator.input.parameters": "Parametri immessi",
	"coil.calculator.length": "Lunghezza bobina (mm)",
	"coil.calculator.length.label": "Lunghezza bobina (m)",
	"coil.calculator.length.mandatory": "La lunghezza della bobina è obbligatoria",
	"coil.calculator.metallic.coating.thickness.label": "Spessore del rivestimento metallico (g/㎡)",
	"coil.calculator.metallic.coating.type.label": "Tipo di rivestimento metallico",
	"coil.calculator.metallic.coating.type.mandatory": "Il tipo di rivestimento metallico è obbligatorio",
	"coil.calculator.no.result.text": "Compila tutti i campi per visualizzare i risultati.",
	"coil.calculator.nominal.thickness.label": "Spessore nominale (mm)",
	"coil.calculator.nominal.thickness.mandatory": "Lo spessore nominale è obbligatorio",
	"coil.calculator.organic.coated.coils": "Bobine con rivestimento organico",
	"coil.calculator.organic.coated.film.thickness.label": "Spessore del film organico rivestito (μm)",
	"coil.calculator.outer.diameter": "Diametro esterno bobina",
	"coil.calculator.outer.diameter.label": "Diametro esterno bobina (mm)",
	"coil.calculator.outer.diameter.mandatory": "Il diametro esterno della bobina è obbligatorio",
	"coil.calculator.outer.less.than.inner.error": "Campo più piccolo del Ø interno",
	"coil.calculator.product.information": "Informazioni sul prodotto",
	"coil.calculator.result": "Risultato",
	"coil.calculator.specific.weight": "Peso specifico",
	"coil.calculator.specific.weight.label": "Peso specifico (kg/mm)",
	"coil.calculator.specific.weight.mandatory": "Il peso specifico è obbligatorio",
	"coil.calculator.technical.feasibility.text": "Lo strumento non fornisce alcuna fattibilità tecnica presso i nostri stabilimenti delle bobine calcolate.",
	"coil.calculator.tool.text": "Questo calcolatore di bobine è uno strumento che aiuta a calcolare il diametro esterno, il peso della bobina, la lunghezza della bobina o il peso specifico.",
	"coil.calculator.total.paint.thickness.label": "Spessore totale della vernice sopra + sotto (μm)",
	"coil.calculator.weight": "Peso bobina",
	"coil.calculator.weight.label": "Peso bobina (tonnellate)",
	"coil.calculator.weight.mandatory": "Il peso della bobina è obbligatorio",
	"coil.calculator.width.label": "Larghezza (mm)",
	"coil.calculator.width.mandatory": "La larghezza è obbligatoria",
	"comment.offer.set": "Commenti :",
	"commercial-documents-da.enduser": "Utente finale",
	"commercial-documents-da.heat": "Colata",
	"commercial-documents-da.serial": "Seriale",
	"commercial-documents-da.supplier-article-reference": "Riferimento articolo fornitore",
	"commercial-documents.all-my-documents": "Tutti i miei documenti",
	"commercial-documents.amount": "Amount certified",
	"commercial-documents.batch-number": "Numero del lotto",
	"commercial-documents.batches-details": "Dettagli sui lotti",
	"commercial-documents.ce.enduser": "Utente finale",
	"commercial-documents.ce.serial-number": "Numero di serie",
	"commercial-documents.ce.supplier-article-reference": "Riferimento articolo fornitore",
	"commercial-documents.certificate-card": "Scheda del certificato",
	"commercial-documents.certificate-date": "Data del certificato",
	"commercial-documents.certificate-number": "Numero del certificato",
	"commercial-documents.certificate-type": "Tipo di certificato",
	"commercial-documents.customer": "Cliente",
	"commercial-documents.customer-article-reference": "Riferimento articolo cliente",
	"commercial-documents.customer-claim-reference": "Riferimento reclamo cliente",
	"commercial-documents.customer-order-number": "Numero ordine cliente",
	"commercial-documents.date": "Data del documento",
	"commercial-documents.dimensions": "Dimensioni",
	"commercial-documents.discount": "Sconto",
	"commercial-documents.dispatch-advice-date": "Data avvisi di spedizione",
	"commercial-documents.dispatch-advice-number": "Numero avvisi di spedizione",
	"commercial-documents.display-all-orders": "Mostra tutti gli ordini",
	"commercial-documents.docsWithCreationDateGtLastConnectionDate": "Documenti registrati dall'ultimo collegamento",
	"commercial-documents.documents": "documenti",
	"commercial-documents.download-cart": "Scarica il carrello",
	"commercial-documents.emptyHeatNumber": "N/D",
	"commercial-documents.endQuarter": "End Quarter",
	"commercial-documents.enduser": "Utente finale",
	"commercial-documents.final-use": "Uso finale",
	"commercial-documents.general-information": "Informazioni generali",
	"commercial-documents.heat-number": "Numero di colata",
	"commercial-documents.invoice": "Fattura",
	"commercial-documents.invoice-amount": "Importo fattura (totale)",
	"commercial-documents.invoice-amount-without-vat": "Importo fattura senza IVA (totale)",
	"commercial-documents.invoice-card": "Scheda della fattura",
	"commercial-documents.invoice-currency": "Valuta della fattura",
	"commercial-documents.invoice-date": "Data della fattura",
	"commercial-documents.invoice-discount": "Sconto della fattura (totale)",
	"commercial-documents.invoice-number": "Numero di fattura",
	"commercial-documents.invoice-quantity": "QUANTITÀ FATTURA",
	"commercial-documents.invoice-tax-amount": "Importo imposta fattura (totale)",
	"commercial-documents.invoice-type": "Tipo di fattura",
	"commercial-documents.invoiced-quantity": "Quantità fatturata",
	"commercial-documents.invoiced-quantity-unit": "Quantità fatturata (unità)",
	"commercial-documents.line-status": "Stato della linea",
	"commercial-documents.mill": "Stabilimento",
	"commercial-documents.mill-order-number": "Numero ordine stabilimento",
	"commercial-documents.my-commercial-documents": "I miei documenti commerciali",
	"commercial-documents.number": "Numero del documento",
	"commercial-documents.order-acknowledgement-date": "Data di conferma dell'ordine",
	"commercial-documents.order-acknowledgement-number": "Numero di conferma dell'ordine",
	"commercial-documents.order-acknowledgement-type": "Tipo di conferma d’ordine",
	"commercial-documents.order-quantity": "Quantità ordinata",
	"commercial-documents.order-reference": "Riferimento dell'ordine",
	"commercial-documents.orderAcknowledgement-card": "Conferma dell'ordine",
	"commercial-documents.ordered-quantity": "Quantità ordinata (t)",
	"commercial-documents.orders-line-details": "Dettagli dell'ordine",
	"commercial-documents.orders-number": "Numero d'ordine",
	"commercial-documents.payer": "Pagatore",
	"commercial-documents.payer-vat-number": "Partita IVA del pagatore",
	"commercial-documents.payment-due-date": "Scadenza del pagamento",
	"commercial-documents.payment-due-to": "Pagamento dovuto a",
	"commercial-documents.payment-information": "Informazioni sul pagamento",
	"commercial-documents.plant-invoice-number": "Numero di fattura dell'impianto",
	"commercial-documents.product": "Prodotto",
	"commercial-documents.product-descriptions": "Descrizione del prodotto",
	"commercial-documents.proforma": "Proforma",
	"commercial-documents.received-by-steeluser": "Ricevuto da SteelUser",
	"commercial-documents.rrp": "RRP type",
	"commercial-documents.shipto": "Spedire a",
	"commercial-documents.soldto": "Venduto a",
	"commercial-documents.steel-grade": "Acciaio di qualità",
	"commercial-documents.subtype": "Sottotipo",
	"commercial-documents.supplier-claim-reference": "Riferimento reclamo del fornitore",
	"commercial-documents.supplier-order-number": "Numero d'ordine del fornitore",
	"commercial-documents.supplier-vat-number": "Partita IVA del fornitore",
	"commercial-documents.tax": "Imposta",
	"commercial-documents.transport-mode": "Modalità di trasporto",
	"commercial-documents.transport-reference": "Riferimento trasporto",
	"commercial-documents.type": "Tipo di documento",
	"commercial-documents.vat": "IVA",
	"commercial-documents.vat-percentage": "Percentuale IVA",
	"commercial-documents.weight": "Peso",
	"commercial-documents.without-vat": "Senza IVA",
	"commercial-documents.xcarbsubtype": "XCarb® sub-type",
	"confirm.continue": "Continuare?",
	"confirm.modified": "Ultima modifica il",
	"confirm.respectively": "rispettivamente.",
	"confirm.same.material": "È presente un altro reclamo sulla stessa unità di materiale con riferimento a",
	"confirm.thanks": "Grazie, abbiamo ricevuto la tua richiesta.",
	"confirm.thanks.fastlane": "Grazie, abbiamo ricevuto la tua richiesta.",
	"confirmation.message": "Non potrai annullare questa azione dopo la conferma.",
	"contact.us": "Contatta e-Business Support",
	"contactmail.popup.success.msg-line1": "Thanks, we have well received your message.",
	"contactmail.popup.success.msg-line2": "We will provide feedback as soon as possible.",
	"contactmail.submit.attachment.error.msg": "Sorry, something wrong with the attachment, try to reupload it",
	"contactmail.submit.error.msg": "Sorry, something wrong during the process. Try again later.",
	"contactmail.submit.session.error.msg": "Sorry, something wrong with your session, try to log again.",
	"continue.draft": "Continua la tua bozza",
	"corrosion.A": "Atmospheric",
	"corrosion.S": "Soil Corrosion",
	"create.new.order": "Crea un nuovo ordine",
	"create.new.request": "CREA UNA NUOVA RICHIESTA",
	"customer.share.view": "Condividi la tua opinione",
	"customer.simulation": "Seleziona un cliente",
	"dashboard.active.parameters": "Parametri attivi",
	"dashboard.add-widget": "Aggiungi widget",
	"dashboard.add-widget-instruction": "Selezionare il dispositivo che desideri aggiungere",
	"dashboard.cancel": "Cancella",
	"dashboard.card.time-in-stock": "Giorni in stock",
	"dashboard.card.time-in-stock.time-to-call": "È ORA DI CHIAMARE",
	"dashboard.card.time-in-stock.view-details": "Mostra dettagli",
	"dashboard.claims": "Reclami",
	"dashboard.condition": "Condizione:",
	"dashboard.customer-material-reference": "Numero materiale cliente",
	"dashboard.customize-indicator": "Personalizzare",
	"dashboard.customize-information": "Personalizzare",
	"dashboard.delete.confirmation-question": "Vuoi veramente cancellare questo widget?",
	"dashboard.documents-since-last-connection": "Documenti registrati dall'ultima connessione",
	"dashboard.drag-customer-article-here": "Trascina qui il riferimento all'articolo del cliente",
	"dashboard.drag-drop-information": "Trascina e rilascia i valori nella casella a destra",
	"dashboard.drag-steelgrades-here": "Rilasciare Steelgrades qui",
	"dashboard.efeasibility": "eFeasibility",
	"dashboard.efeasibility.add.new": "Ask for a new feasibility",
	"dashboard.indicator": "Indicatore",
	"dashboard.information": "Informazioni",
	"dashboard.key-indicator": "Indicatore chiave",
	"dashboard.key-information": "Informazioni importanti",
	"dashboard.my-business-overview": "Panoramica della mia attività",
	"dashboard.my.data": "I miei dati",
	"dashboard.order-status": "Stato dell'ordine",
	"dashboard.orders": "Ordini",
	"dashboard.rts-widget.title": "In giacenza",
	"dashboard.rts-widget.tooltip": "Quantità pronta per la spedizione disponibile per questo prodotto in tutti gli stock",
	"dashboard.savechanges": "Salva modifiche",
	"dashboard.saving": "Pannello di controllo widgets viene salvato",
	"dashboard.schedule.business.order-status": "Schedule business order status",
	"dashboard.spot.order-status": "Spot order status",
	"dashboard.steelgrade": "Grado di acciaio",
	"dashboard.validate": "Convalida",
	"dashboard.view.more": "Visualizza di più",
	"dashboard.widget-configuration": "Configurazione",
	"dashboard.widget-preview": "Anteprima",
	"dashboard.widget.highest-stocks": "Le prime 5 stock",
	"dashboard.widget.material-ready-to-ship": "Pronto a spedire",
	"dashboard.without-value": "Senza valore",
	"datacenter-filter.LMD": "Modification date",
	"datacenter-filter.PO-Reception-date": "PO Reception date",
	"datacenter-filter.PO-Reception-week": "PO Reception week",
	"datacenter-filter.Proposed-Total-weight": "Proposed total weight",
	"datacenter-filter.Proposed-blank-weight": "Proposed blank weight",
	"datacenter-filter.Proposed-price": "Proposta di prezzo",
	"datacenter-filter.additional-desc": "Additional item information",
	"datacenter-filter.back-office-customer": "Cliente back office",
	"datacenter-filter.back-office-role": "Ruolo back office",
	"datacenter-filter.batch-reference": "Riferimento coils",
	"datacenter-filter.batch-status": "Detailed batch status",
	"datacenter-filter.batches-not-delivered-gross": "Batches not yet delivered to final destination (Gross, t)",
	"datacenter-filter.batches-not-delivered-net": "Batches not yet delivered to final destination (net, t)",
	"datacenter-filter.bill-to": "Fatturare a",
	"datacenter-filter.carrier-name": "Carrier name",
	"datacenter-filter.cdd": "CDD (settimana)",
	"datacenter-filter.cdd-date": "CDD",
	"datacenter-filter.chemical-passivation": "Chemical Passivation",
	"datacenter-filter.choice": "Scelta",
	"datacenter-filter.coating": "Specifica di rivestimento",
	"datacenter-filter.coilAxis": "CoilAxis",
	"datacenter-filter.collate-documents": "Collate Documents",
	"datacenter-filter.color-bottom-side": "Colore lato inferiore",
	"datacenter-filter.color-category-bottom-side": "Color Category Bottom Side",
	"datacenter-filter.color-category-top-side": "Color Category Top Side",
	"datacenter-filter.color-top-side": "Colore lato superiore",
	"datacenter-filter.creation-date": "Data di creazione",
	"datacenter-filter.current-location": "Località attuale",
	"datacenter-filter.customer-article-reference": "Riferimento articolo cliente",
	"datacenter-filter.customer-order-number": "Numero d'Ordine del Cliente",
	"datacenter-filter.customer-order-number-without-item": "Customer order nr w/o item",
	"datacenter-filter.customer-req-name": "Customer request name",
	"datacenter-filter.customerRefusal": "Customer refusal comments",
	"datacenter-filter.data-sheet-bottom-side": "Scheda tecnica film organico inferiore",
	"datacenter-filter.data-sheet-top-side": "Scheda tecnica film organico top",
	"datacenter-filter.date-available-for-dispatch": "Data disponibile per la spedizione",
	"datacenter-filter.delay": "Delay",
	"datacenter-filter.delivery-address": "Indirizzo di consegna",
	"datacenter-filter.delivery-address-order": "Delivery address for order",
	"datacenter-filter.delivery-location": "Delivery location",
	"datacenter-filter.delivery-mode": "Modo di consegna",
	"datacenter-filter.destination-address": "Destination Address",
	"datacenter-filter.destination-by-boat": "Destinazione in barca",
	"datacenter-filter.destination-name": "Destination Name",
	"datacenter-filter.detailed-batch-status": "Stato lotto dettagliato",
	"datacenter-filter.dimension": "Dim (mm)",
	"datacenter-filter.dispatch-advice": "Avvisi di spedizione",
	"datacenter-filter.dispatch-advice-date": "Data avvisi di spedizione",
	"datacenter-filter.dispatch-advice-date-n1": "N-1 Data spedizione",
	"datacenter-filter.dispatch-advice-date-n2": "N-2 Data spedizione",
	"datacenter-filter.dispatch-advice-number": "Numero avvisi di spedizione",
	"datacenter-filter.dispatch-advice-number-n1": "N-1 Numero avvisi di spedizione",
	"datacenter-filter.dispatch-advice-number-n2": "N-2 Numero avvisi di spedizione",
	"datacenter-filter.dispatch-date": "Data spedizione",
	"datacenter-filter.easy-film-bottom": "EasyFilm Bottom",
	"datacenter-filter.easy-film-top": "EasyFilm Top",
	"datacenter-filter.end-user": "Utilizzatore finale",
	"datacenter-filter.final-use": "Utilizzo finale",
	"datacenter-filter.first-name": "Nome",
	"datacenter-filter.form": "Forma",
	"datacenter-filter.grade": "Qualità",
	"datacenter-filter.gross-consignment": "Cons. (lordo t)",
	"datacenter-filter.gross-first-batch": "Primo coil in stock (settimana)",
	"datacenter-filter.gross-in-transit-details": "Dettagli in transito (lordo, tonnellate)",
	"datacenter-filter.gross-last-batch": "Ultimo coil in stock (settimana)",
	"datacenter-filter.heat-number": "Numero di colata",
	"datacenter-filter.hts-code": "hts code",
	"datacenter-filter.incoterm2": "Incoterm 2",
	"datacenter-filter.internal-diameter": "Internal Diameter",
	"datacenter-filter.interpretation-delivery-date": "Interpretazione data di consegna",
	"datacenter-filter.invalid-number": "Numero invalido",
	"datacenter-filter.item-sold-to-party": "Item sold to party",
	"datacenter-filter.last-name": "Cognome",
	"datacenter-filter.length": "Lunghezza",
	"datacenter-filter.loading-program-number": "Loading program number",
	"datacenter-filter.material-not-avilable": "Material not available",
	"datacenter-filter.materialAvailability": "Material Availability",
	"datacenter-filter.mill": "Stabilimento",
	"datacenter-filter.mill-order-number": "Numero ordine stabilimento",
	"datacenter-filter.net-consignment": "Consign (netto)",
	"datacenter-filter.net-in-transit": "In transito",
	"datacenter-filter.net-in-transit-details": "Dettagli in transito (netto, tonnellate)",
	"datacenter-filter.net-ready-to-ship": "RTS (netto",
	"datacenter-filter.nominal-gloss-bottom-side": "Lato inferiore liscio nominale",
	"datacenter-filter.nominal-gloss-top-side": "Lato superiore liscio nominale",
	"datacenter-filter.oil-reference": "Oil Reference",
	"datacenter-filter.order-created-by": "Order created by",
	"datacenter-filter.order-creator": "Order creator",
	"datacenter-filter.order-item-status": "Stato della posizione ordine",
	"datacenter-filter.order-reason": "Ragione dell ordine",
	"datacenter-filter.organic-structure-bottom-side": "Struttura del rivestimento organico bottom",
	"datacenter-filter.organic-structure-top-side": "Struttura del rivestimento organico top",
	"datacenter-filter.organization-city": "Città",
	"datacenter-filter.organization-id": "Id organizzazione",
	"datacenter-filter.organization-name": "Nome organizzazione",
	"datacenter-filter.organization-role": "Ruolo",
	"datacenter-filter.organization-service": "Servizio organizzazione",
	"datacenter-filter.organization-status": "Stato organizzazione",
	"datacenter-filter.organization-suppliers": "Fornitori organizzazione",
	"datacenter-filter.organization-type": "Tipo organizzazione",
	"datacenter-filter.package-serial-number": "Numero seriale imballo",
	"datacenter-filter.paint-marking-for-sh": "Paint Marking (for SH)",
	"datacenter-filter.pattern-for-sh": "Pattern (for SH)",
	"datacenter-filter.planned-shipment-date": "Data di carico pianificata",
	"datacenter-filter.ponumber": "PO Number",
	"datacenter-filter.price-unit": "Price unit",
	"datacenter-filter.produced-length-dimension": "Actual length",
	"datacenter-filter.producedDimension": "Dim prodotta",
	"datacenter-filter.producedLength": "Lunghezza prodotta",
	"datacenter-filter.producedThickness": "Spessore prodotto (mm)",
	"datacenter-filter.producedWidth": "Larghezza del prodotto (mm)",
	"datacenter-filter.product-category": "Categoria prodotto",
	"datacenter-filter.product-description": "Descrizione prodotto",
	"datacenter-filter.proposed-coating": "Proposed coating",
	"datacenter-filter.proposed-inner-diameter": "Proposed inner diameter",
	"datacenter-filter.proposed-length": "Proposed length",
	"datacenter-filter.proposed-oiling": "Proposed oiling",
	"datacenter-filter.proposed-outside-diameter": "Proposed outer diameter",
	"datacenter-filter.proposed-packing": "Proposed packaging",
	"datacenter-filter.proposed-quantity": "Proposed quantity",
	"datacenter-filter.proposed-steelgrade": "Proposed steel grade",
	"datacenter-filter.proposed-thickness": "Proposed thickness",
	"datacenter-filter.proposed-unit": "Proposed quantity unit",
	"datacenter-filter.proposed-weight": "Proposed sheet weight",
	"datacenter-filter.proposed-width": "Proposed width",
	"datacenter-filter.protection": "Protezione",
	"datacenter-filter.proto-name": "Prototype name",
	"datacenter-filter.proto-status": "Prototype status",
	"datacenter-filter.provisional-firm-item": "Previsione/conferma posizione",
	"datacenter-filter.quantity-unit": "Quantity Unit",
	"datacenter-filter.rdd": "RDD",
	"datacenter-filter.rdd-date": "RDD",
	"datacenter-filter.rdd-week": "RDD (week)",
	"datacenter-filter.ready-to-ship-date": "Date available for dispatch",
	"datacenter-filter.readyForDispatch": "Ready for dispatch at PO receipt (week)",
	"datacenter-filter.req-desc": "Request Description",
	"datacenter-filter.sales-quarter": "Trimestre di vendita",
	"datacenter-filter.service-level": "Livello di servizio",
	"datacenter-filter.service-request": "Richiesta di servizio",
	"datacenter-filter.ship-to": "Spedire a",
	"datacenter-filter.ship-to-address": "Delivery address",
	"datacenter-filter.shipment-reference-date": "Dispatch date",
	"datacenter-filter.shipping-date": "Shipping date",
	"datacenter-filter.shipping-week": "Expected shipping week",
	"datacenter-filter.sold-to": "Cliente",
	"datacenter-filter.special-stock-partner": "Stock partner",
	"datacenter-filter.spot-or-schedule": "Spot or schedule",
	"datacenter-filter.standard": "Standard",
	"datacenter-filter.standard-steel-grade": "Qualità standard",
	"datacenter-filter.steeluser-order-number": "Riferimento ordine commercio elettronico",
	"datacenter-filter.stockist": "Stockist",
	"datacenter-filter.supplier-rfq": "SupplierRfqNumber",
	"datacenter-filter.surface": "Superficie",
	"datacenter-filter.thickness": "Spessore",
	"datacenter-filter.total-thickness-coating-bottom": "Spessore totale fondo di rivestimento (G/M2)",
	"datacenter-filter.total-thickness-coating-top": "Spessore totale parte alta rivestimento (G/M2)",
	"datacenter-filter.trademark-name-bottom-side": "Nome commerciale lato fondo",
	"datacenter-filter.trademark-name-top-side": "Nome commerciale lato in alto",
	"datacenter-filter.transport-mode": "Modo di trasporto",
	"datacenter-filter.transport-mode-n1": "N-1 Modo di trasporto",
	"datacenter-filter.transport-mode-n2": "N-2 Modo di trasporto",
	"datacenter-filter.transport-reference": "Riferimento trasporto",
	"datacenter-filter.transport-reference-n1": "N-1 Riferimento trasporto",
	"datacenter-filter.transport-reference-n2": "N-2 Riferimento trasporto",
	"datacenter-filter.transportRef": "Transport reference",
	"datacenter-filter.ultrasonic-testing": "Ultrasonic Testing",
	"datacenter-filter.user-creation-date": "Data di creazione",
	"datacenter-filter.user-email": "E-mail",
	"datacenter-filter.user-first-name": "Nome",
	"datacenter-filter.user-id": "Id",
	"datacenter-filter.user-last-name": "Cognome",
	"datacenter-filter.user-organization-name": "Nome organizzazione",
	"datacenter-filter.user-role": "Ruolo",
	"datacenter-filter.user-status": "Stato",
	"datacenter-filter.users-city": "Città",
	"datacenter-filter.users-countrycode": "Codice Paese",
	"datacenter-filter.width": "Larghezza",
	"datacenter-filter.z-test-certificat": "Z-test Certificat",
	"datacenter-shipment.batch": "Lotto",
	"datacenter-shipment.customer": "Cliente",
	"datacenter-shipment.customer-article-reference": "Riferimento articolo cliente",
	"datacenter-shipment.customer-order-number": "Numero ordine cliente",
	"datacenter-shipment.date-available-for-dispatch": "Data disponibile per la spedizione",
	"datacenter-shipment.dispatch-advice-date": "Data avvisi di spedizione",
	"datacenter-shipment.dispatch-advice-number": "Numero avvisi di spedizione",
	"datacenter-shipment.grade": "Acciaio di qualità",
	"datacenter-shipment.gross-weight": "Peso lordo (t)",
	"datacenter-shipment.mill": "Stabilimento",
	"datacenter-shipment.net-weight": "Peso netto (t)",
	"datacenter-shipment.ship-to": "Spedire a",
	"datacenter-shipment.shipment-quantity-gross": "Quantità di spedizione (lordo, t)",
	"datacenter-shipment.shipment-quantity-net": "Quantità di spedizione (netto, t)",
	"datacenter-shipment.supplier-order-number": "Numero d'ordine del fornitore",
	"datacenter-shipment.thickness": "Spessore (mm)",
	"datacenter-shipment.transport-mode": "Modalità di trasporto",
	"datacenter-shipment.transport-reference": "Riferimento trasporto",
	"datacenter-shipment.width": "Larghezza (mm)",
	"datacenter.add-columns": "Aggiungi colonne",
	"datacenter.all": "Tutto",
	"datacenter.all-columns-added-to-grid": "Tutte le colonne aggiunte alla griglia",
	"datacenter.all-data-center": "Centro elaborazione di tutti i dati",
	"datacenter.annealed": "Ricotto",
	"datacenter.apply": "Applica",
	"datacenter.aqdb": "eAQDB",
	"datacenter.aqdb-view": "Data center: eAQDB",
	"datacenter.at-reshipper-gross": "Al ritrasportatore (Lordo, t)",
	"datacenter.at-reshipper-net": "Al ritrasportatore (Netto, t)",
	"datacenter.balanced-not-produced": "Saldo non prodotto",
	"datacenter.batch": "Coils / batches",
	"datacenter.batches": "Data center: Lotti",
	"datacenter.calloff": "Centro dati: ordine a chiamata",
	"datacenter.calloff-by-batch": "Ordine a chiamata per lotti",
	"datacenter.calloff-by-volume": "Ordine a chiamata per volume",
	"datacenter.cancel": "Cancella",
	"datacenter.click-on-items-on-the-right": "Cliccare sulla posozione a destra per aggiungere il filtro",
	"datacenter.cold-rolled": "Laminato a freddo",
	"datacenter.columns": "Colonne",
	"datacenter.commercial-documents": "Centro di elaborazione dati: documenti commerciali",
	"datacenter.composite": "Composito",
	"datacenter.create-new-view": "Creare nuova visualizzazione",
	"datacenter.current-layout": "Prospetto corrente",
	"datacenter.customize-view": "Visualizzazione personalizzata",
	"datacenter.cutting-beveling": "Taglio e smussatura",
	"datacenter.data-center": "Centro dati",
	"datacenter.data-center-shipments": "\tCentro di elaborazione dati: Spedizioni",
	"datacenter.default": "Predefinito",
	"datacenter.delete": "Cancella",
	"datacenter.do-you-want-remove": "Voi rimuovere questa visualizzazione",
	"datacenter.document": "Documenti commerciali",
	"datacenter.documents": "Documenti",
	"datacenter.download-invoice": "Scarica fattura",
	"datacenter.drag-and-drop-item-hint": "Copia ed incolla una posizione per aggiungere o cancellare una colonna",
	"datacenter.drag-element-here-fixed": "Copia qua per aggiungere una colonna fissa nella griglia",
	"datacenter.drag-element-here-hide": "Copia elemento qua per nascondere le colonne nella griglia",
	"datacenter.drag-element-here-scrollable": "Copia qua per aggiungere colonne scorrevoli",
	"datacenter.edit-view": "Visualizza modifica",
	"datacenter.favorite.added": "View added to favorites",
	"datacenter.favorite.max-reached": "Maximum number of favorites reached. Remove an existing favorite before adding a new one.",
	"datacenter.favorite.removed": "View removed from favorites",
	"datacenter.favorite.update-error": "Unable to update favorite status",
	"datacenter.filter.clear": "Clear",
	"datacenter.filters": "Filtri",
	"datacenter.fixed-columns": "Colonne fisse",
	"datacenter.fixed-columns-scrollable": "Fixed columns (10 maximum)",
	"datacenter.graph.first-bar-label": "Al di sotto - 30 giorni",
	"datacenter.graph.fourth-bar-label": "91 - Oltre",
	"datacenter.graph.second-bar-label": "31 - 60 giorni",
	"datacenter.graph.third-bar-label": "61 - 90 giorni",
	"datacenter.guarantee": "Centro dati: garanzia",
	"datacenter.handed-over-to-planning": "Pianificazione",
	"datacenter.hot-rolled": "Laminato a caldo",
	"datacenter.in-transit-gross": "In transito (lordo)",
	"datacenter.in-transit-to-customer-gross": "In transito verso il cliente (Lordo, tonnellate)",
	"datacenter.in-transit-to-customer-net": "In transito verso il cliente (Netto, tonnellate)",
	"datacenter.land-transit-gross": "Trasporto via terra (Lordo, t)",
	"datacenter.land-transit-net": "Trasporto via terra (Netto, t)",
	"datacenter.layout": "Layout / impostazione",
	"datacenter.layout-sorting": "Layout e suddivisione",
	"datacenter.metallic-coated": "Rivestimento metallico",
	"datacenter.minimal-quantity-for-this-item-is": "La quantità minima per questo articolo è",
	"datacenter.name-your-new-layout": "Nomina il tuo nuovo prospetto",
	"datacenter.nb-days-in-stock": "Numero giorni in stock",
	"datacenter.net-qty-delivered": "Consegnato (Netto t)",
	"datacenter.net-qty-not-delivered": "Not Delivered (Net, t)",
	"datacenter.normalizing": "Normalizzazione",
	"datacenter.offer": "Offerte",
	"datacenter.offer.subcategory": "Sottocategoria",
	"datacenter.offers": "Centro di elaborazione dati: Offerte",
	"datacenter.on-vessel-gross": "Sulla nave (Lordo, t)",
	"datacenter.on-vessel-net": "Sulla nave (Netto, t)",
	"datacenter.open-needs": "Fabbisogni Aperti",
	"datacenter.or-save-as-a-new-view": "Oppure salva come nuova visualizzazione",
	"datacenter.order": "Ordini",
	"datacenter.ordered": "Ordinato",
	"datacenter.orders": "Data center: Ordini",
	"datacenter.organic-coated": "Preverniciato",
	"datacenter.organization": "Organizzazioni",
	"datacenter.organizations": "Centro dati: Organizzazioni",
	"datacenter.overseas-transit-gross": "Trasporto all'estero (Lordo, t)",
	"datacenter.overseas-transit-net": "Trasporto all'estero (Netto, t)",
	"datacenter.oxi-cutting": "Ossitaglio",
	"datacenter.packing": "Imballaggio",
	"datacenter.pickled": "Decapato",
	"datacenter.planned-casting": "Quantità Programmata Colata",
	"datacenter.prematerial-ordered": "Materiale di base ordinato",
	"datacenter.prototypes": "Data center: Prototypes",
	"datacenter.qty-delivered": "Consegnato (Lordo t)",
	"datacenter.qty-gross": "Lordo (t)",
	"datacenter.qty-in-production": "WIP (t)",
	"datacenter.qty-in-transit": "In transito",
	"datacenter.qty-net": "Netto (t)",
	"datacenter.qty-not-delivered": "Not Delivered (Gross, t)",
	"datacenter.qty-ordered": "Ord (t)",
	"datacenter.qty-ready-to-ship": "Pronto alla spedizione",
	"datacenter.quality": "qualità",
	"datacenter.quality-control": "Controllo Qualità (tonn.)",
	"datacenter.quality-issues": "Centro di elaborazione dati: Problemi di qualità",
	"datacenter.requested-quantity-is-greater-than-the-maximum-value": "La quantità richiesta è superiore al valore massimo",
	"datacenter.reset-all-filters": "Reimposta tutti i filtri",
	"datacenter.result": "1 risultato",
	"datacenter.results": "{{value}} risultati",
	"datacenter.rolling-stand": "Piedistallo rotante",
	"datacenter.rts-gross": "RTS (lordo)",
	"datacenter.save": "Salva",
	"datacenter.save-as": "Salva come",
	"datacenter.save-changes-in-the-view": "Salve le modifiche nella visualizzazione",
	"datacenter.save-new-layout-as": "Salva il nuovo prospetto come",
	"datacenter.save-new-view": "Salva la nuova visualizzazione",
	"datacenter.save-the-view": "Salva la visualizzazione",
	"datacenter.schedule-business-order": "Pianifica ordini commerciali",
	"datacenter.schedule-business-orders": "Centro di elaborazione dati: Pianifica gli ordini aziendali",
	"datacenter.scrollable-columns": "Colonne scorrevoli",
	"datacenter.select-a-view": "Seleziona una visualizzazione",
	"datacenter.selected": "Valore selezionato",
	"datacenter.shipment": "Spedizioni",
	"datacenter.shot-blasting": "Granigliatura",
	"datacenter.skin-pass": "Skin pass",
	"datacenter.slab": "Bramma",
	"datacenter.slitting": "Taglio in nastri  - slitting",
	"datacenter.sorting": "Ordinamento",
	"datacenter.stock-blocked-gross": "Stock blocked (Gross, t)",
	"datacenter.stock-blocked-net": "Stock blocked (Net, t)",
	"datacenter.total": "Totale",
	"datacenter.users": "Centro dati: Utenti",
	"datacenter.view-load-error": "Impossibile caricare la visualizzazione del data center",
	"datacenter.view-name": "Nome visualizzazione",
	"datacenter.view-name.duplicate.error": "A view with the name '{{viewName}}' already exists. Please choose a different name.",
	"datacenter.view-name.error": "Nome visualizzazione deve essere univoco",
	"datacenter.view-not-found": "View '{{viewName}}' not found",
	"datacenter.view.add-filters": "Aggiungi filtri",
	"datacenter.you-have-too-many-fixed-columns-to-add-a-new-one": "Le colonne fisse sono troppe per poterne aggiungere una nuova",
	"datacenter.you-have-too-many-scroll-columns-to-add-a-new-one": "You have too many scrollable columns to add a new one",
	"datacenterview.Certificate": "Certificato",
	"datacenterview.DispatchAdvice": "Avvisi evasione",
	"datacenterview.Invoice": "Fattura",
	"datacenterview.OrderAcknowledgment": "Conferma dell'ordine",
	"defect.CDCUS00A": "Dimensioni",
	"defect.CDCUS00B": "Peso",
	"defect.CDCUS00C": "Aspetto superficiale",
	"defect.CDCUS00D": "Problema del Rivestimento",
	"defect.CDCUS00E": "Saldature",
	"defect.CDCUS00F": "Ruggine",
	"defect.CDCUS00G": "Planarità",
	"defect.CDCUS00H": "Analisi proprietà meccaniche/chimiche",
	"defect.CDCUS00I": "Problemi durante la lavorazione del metallo",
	"defect.CDCUS00J": "Imballo",
	"defect.CDCUS00K": "Tempo di Consegna",
	"defect.CDCUS00L": "Trasporto",
	"defect.CDCUS00M": "Errore di etichetta",
	"defect.Z/CDCUS00A/0600": "Dimensioni",
	"defect.Z/CDCUS00B/0100": "Peso bobina",
	"defect.Z/CDCUS00B/0200": "Quantità spedita (troppo/troppo poco, differenza con la quantità fatturata...)",
	"defect.Z/CDCUS00C/0400": "Ruggine e ossidazione",
	"defect.Z/CDCUS00C/1400": "Aspetto superficiale",
	"defect.Z/CDCUS00D/0500": "Problema del rivestimento",
	"defect.Z/CDCUS00E/0400": "Saldature",
	"defect.Z/CDCUS00F/0400": "Protezione superficie (olio, pellicola, ...)",
	"defect.Z/CDCUS00G/0700": "Planarità",
	"defect.Z/CDCUS00H/0600": "Qualità (proprietà meccaniche, analisi chimica, ...)",
	"defect.Z/CDCUS00I/0600": "In elaborazione",
	"defect.Z/CDCUS00J/0900": "Presentazione (imballaggio, etichettatura, bobinatura, ...)",
	"defect.Z/CDCUS00K/0300": "Tempo di consegna",
	"defect.Z/CDCUS00L/0100": "Errori di trasporto (indirizzo, modalità)",
	"defect.Z/CDCUS00L/0600": "Danni durante il trasporto",
	"defect.Z/CDCUS00M/0300": "Documentazione tecnica (certificati, descrizione del prodotto, polizza di carico...)",
	"delete.draft": "Elimina la tua bozza",
	"delete.only-administrator": "Non è possibile eliminare questo utente perché non ce ne sono altri in azienda.",
	"delivery-tracking.at-overseas-stock": "Stock estero",
	"delivery-tracking.delivery-follow-up": "Follow-up della consegna",
	"delivery-tracking.in-land-transit": "Trasporto via terra",
	"delivery-tracking.in-overseas-transit": "Stock estero in transito",
	"delivery-tracking.in-transit-to-customer": "In transito verso il cliente",
	"delivery-tracking.order-and-delivery-overview": "Panoramica dell'ordine e della consegna",
	"delivery-tracking.stock-per-mill": "Scorte per stabilimento",
	"delivery-tracking.to-reshipper-in-land-transit-to-warehouse": "Da rispedire / in transito a terra / in Magazzino",
	"delivery-tracking.total": "Totale",
	"delivery-tracking.view-details": "Mostra dettagli",
	"delivery.status.late": "In ritardo",
	"delivery.status.on-customer-time": "All'ora del cliente",
	"delivery.status.on-supplier-time": "All'ora del fornitore",
	"delivery.status.on-time": "Puntuale",
	"dialog-upload-file": "Please upload a file",
	"dialog.all-column-added-to-grid": "Tutte le colonne aggiunte alla griglia",
	"dialog.apply": "Applica",
	"dialog.customize.view.title": "Scegli le colonne con il \"drag and drop\" ",
	"dialog.delete.description": "Desideri davvero eliminare questo utente?",
	"dialog.delete.title": "Rimuovi utente",
	"dialog.drag-elements-here-hide": "Trascina l'elemento per nascondere le colonne nella griglia",
	"dialog.drag-elements-here-scrollable": "Trascina qui per aggiungere colonne nel layout",
	"dialog.loose-data-message": "Questa azione rimuoverà tutti i dati. Continuare?",
	"dialog.select.batch": "Seleziona lotto",
	"doc-ce-subtype.01": "2.1: Dichiarazione di conformità con l'ordine",
	"doc-ce-subtype.02": "2.1: Declaration of compliance with the order",
	"doc-ce-subtype.17": "3.1: Certificato di ispezione 3.1",
	"doc-ce-subtype.51": "2.2: Report di prova",
	"doc-ce-subtype.52": "3.2: Certificato di ispezione 3.2",
	"doc-ce-subtype.car": "Chemical Analysis Report",
	"doc-ce-subtype.cconf": "Certificato di conformità",
	"doc-ce-subtype.ccpu": "Certificato di prova",
	"doc-ce-subtype.cem": "Marcatura CE",
	"doc-ce-subtype.ceran": "Certificato di prova 2.2 Analisi Chim.",
	"doc-ce-subtype.cerre": "Certificato di ricezione",
	"doc-ce-subtype.cerus": "Certificato di ricezione",
	"doc-ce-subtype.cinsp": "Certificato di ispezione 3.2",
	"doc-ce-subtype.ctl": "Report di ispezione",
	"doc-ce-subtype.fcp": "Scheda caratteristiche prodotto",
	"doc-ce-subtype.ohsas": "Report di sicurezza",
	"doc-in-subtype.AVOIR": "Nota di credito",
	"doc-in-subtype.DEBIT": "Nota di debito",
	"doc-in-subtype.FACTU": "Fattura",
	"doc-oa-subtype.N": "Modificato",
	"doc-oa-subtype.O": "Originale",
	"doc-xcarb-subtype.a": "Green Steel Certificate",
	"doc-xcarb-subtype.b": "Recycled and renewably produced",
	"doc-xcarb-subtype.c": "EcoSheetPilePlus",
	"doc-xcarb-subtype.d": "Steel Certificate",
	"doc-xcarb-subtype.e": "Steel certificate (factor:0.7)",
	"doc-xcarb-subtype.f": "Steel certificate (factor:1.0)",
	"doc-xcarb-subtype.g": "Steel certificate Integral",
	"doc-xcarb.amount": "Amount",
	"doc-xcarb.endquarter": "End quarter",
	"doc-xcarb.rrpDownloadLink": "RRP link",
	"doc-xcarb.rrpType": "RRP type",
	"document-card.data-not-found": "Document data not found",
	"download-detailed-report": "Scarica il rapporto dettagliato",
	"download.pdf-files": "Scarica file PDF",
	"draft.creationdate": "Data di creazione",
	"draft.deleted.successfully": "La tua offerta preliminare è stata eliminata correttamente",
	"draft.lastupdate": "Ultimo aggiornamento",
	"draft.selected.product": "Prodotto selezionato",
	"draft.total.tons": "Tonnellate totali",
	"draft.value": "BOZZA",
	"draftoffer.list": "lista bozza",
	"draftorder.list": "lista bozza",
	"drafts.all.drafts": "Tutte le bozze",
	"drafts.has.been.deleted": "La bozza è stata cancellata",
	"drafts.my.drafts": "Le mie bozze",
	"drafts.no.draft": "Nessuna bozza",
	"drafts.saved": "bozze salvate",
	"drafts.search.drafts": "Cerca bozze",
	"drafts.sort.by.modification": "Ordina per modifica",
	"drafts.sort.by.reference": "Ordina per riferimento",
	"drag.and.drop.files": "Trascina e rilascia",
	"ecall-comment-grid": "Comment",
	"ecall-off-batch-cancellation-date": "Cancelled Date",
	"ecall-off-call-creater": "eCall-off creator",
	"ecall-off-card-gross-quantity": "Gross Quantity",
	"ecall-off-card-net-quantity": "Net Quantity",
	"ecall-off-creation-date": "Creation date",
	"ecall-off-information-box": "eCall-off information",
	"ecall-off.all-batches": "Tutti i lotti",
	"ecall-off.apply-for-all": "Applica per tutti",
	"ecall-off.batch": "lotto",
	"ecall-off.batches": "lotti",
	"ecall-off.call-off": "Ordine a chiamata",
	"ecall-off.call-off-by-batch": "Ordine a chiamata per lotti",
	"ecall-off.call-off-by-volume": "Ordine a chiamata per volume",
	"ecall-off.call-off-date": "Data ordine a chiamata",
	"ecall-off.call-off-follow-up": "Follow-up dell'ordine a chiamata",
	"ecall-off.call-off-header-information": "Annullamento informazioni header",
	"ecall-off.call-off-request": "Richiesta ordine a chiamata",
	"ecall-off.callable-weight": "Materiale totale disponibile (Per)",
	"ecall-off.called-batches": "Lotti richiamati",
	"ecall-off.called-order-items": "Articoli ordine richiamati",
	"ecall-off.called-volume": "Volume richiamato (Per)",
	"ecall-off.canceled": "Cancelled date",
	"ecall-off.change-mills": "Cambia stabilimenti",
	"ecall-off.choose-batches": "Scegliere i lotti da annullare",
	"ecall-off.choose-order-items": "Scegliere gli articoli dell'ordine da annullare",
	"ecall-off.closed-or-called": "Called",
	"ecall-off.comment_instruction": "Please fill in this field only if the eCall-off does not follow the standard process. Kindly, do not include messages such as “urgent”, “asap”, “thanks”, or similar. This field is intended only for exceptions to the normal flow.",
	"ecall-off.comment_placeholder": "This field should only be filled in if the eCall-off deviates from the standard flow and the information provided is new and not yet recorded elsewhere.",
	"ecall-off.copy-to": "Copia a",
	"ecall-off.customer-call-off-reference": "Riferimento annullamento cliente",
	"ecall-off.do-you-really-want-to-change-mills": "Desideri davvero cambiare stabilimenti?",
	"ecall-off.ecall-card": "Scheda Ecall-off",
	"ecall-off.exception": "Exception remark",
	"ecall-off.followup": "You will be able to view it in your My eCall-offs.",
	"ecall-off.information-entry": "Annullamento voce informazione",
	"ecall-off.last-call-off-demand": "Ultima richiesta annullamento",
	"ecall-off.material-picking": "Picking materiale",
	"ecall-off.max": "{{valore}} massimo",
	"ecall-off.mill-section": "Selezione acciaieria",
	"ecall-off.my-ecalls": "Le mie eCall-offs",
	"ecall-off.no-batches-found": "Nessun lotto trovato",
	"ecall-off.no-mills": "Non ci sono acciaierie con lotti richiamabili",
	"ecall-off.no-selected-batches": "Nessun lotto selezionato",
	"ecall-off.open-or-callable": "Callable",
	"ecall-off.order-items": "ordina articoli",
	"ecall-off.personnalize-your-call-off-informations": "Personalizza le tue informazioni di richiamo",
	"ecall-off.rdd-mode": "Modalità RDDC",
	"ecall-off.ready-to-call": "I vostri {{oggetti}} pronti per essere richiamati",
	"ecall-off.requested-date": "Data richiesta",
	"ecall-off.requested-date-weekend-warning": "The selected requested delivery date falls on a weekend",
	"ecall-off.requested-ship-to": "Requested Ship To",
	"ecall-off.required": "obbligatorio",
	"ecall-off.see-card": "Vedi scheda",
	"ecall-off.select-a-mill": "Selezionare un'acciaieria per vedere il materiale pronto alla consegna",
	"ecall-off.select-your-mill": "Seleziona la tua acciaieria",
	"ecall-off.selected": "{{value}} selezionato",
	"ecall-off.selected-batches": "{{value}} lotti selezionati",
	"ecall-off.selected-batches-only": "Solo lotti selezionati",
	"ecall-off.selected-only": "Solo i selezionati",
	"ecall-off.selection-will-be-rest": "La selezione verrà ripristinata",
	"ecall-off.separate-email-addresses": "Separare gli indirizzi email con <<;>> (punto e virgola)",
	"ecall-off.ship-to": "Ship To",
	"ecall-off.start-a-new-call-off": "INIZIA UNA NUOVA RICHIESTA",
	"ecall-off.submit-call-off": "Inviare la richiesta di annullamento",
	"ecall-off.submitted.successfully": "Your eCall-off {{value}} has been submitted successfully.",
	"ecall-off.summary": "Riepilogo annullamento",
	"ecall-off.supplier-call-off-reference": "Supplier eCall-off reference",
	"ecall-off.the": "Il",
	"ecall-off.tons": "Tonnellate",
	"ecall-off.total-called-weight": "Peso richiamato totale",
	"ecall-off.total-material-request": "Richiesta totale materiale",
	"ecall-off.type-your-comment": "Inserire un commento",
	"ecall-off.type-your-exception": "Type your exception remark",
	"ecall-off.unloading-reference": "Riferimento scaricamento",
	"ecall-off.view-batch-card": "Vedi scheda lotto",
	"ecall-off.your-batches-ready-to-call": "I tuoi lotti pronti da chiamare",
	"ecall-requested-deliverydate-from-grid": "Requested date from",
	"ecall-requested-deliverydate-to-grid": "Requested date to",
	"ecall-total-volume-called": "Total volume called",
	"ecall.batch.callCreator": "eCall-off creator",
	"ecall.exct-date-error": "You cannot choose exact date for the selected batches",
	"ecall.row.creation.date": "eCall-off creation date",
	"ecall.searchfield.extendable": "Ricerca rapida...",
	"edit.draft": "Modifica bozze",
	"efeasibility-disclaimer": "While care has been taken regarding the available information about quality or usability of our materials, it only serves as a description. All notices, advices, recommendations, calculations and, more generally, any information you have access from Steel User are given for your guidance, within the framework of a best effort undertaking, and on the basis of our experience and the state of our last knowledge. However, any industrial application/order/implementation based on such content shall have to be validated by your usual contact at ArcelorMittal Group.",
	"efeasibility-disclaimer.end": "ArcelorMittal Group accepts no responsibility or liability for any errors or information which is found to be misleading.  The use of the information contained herein is at the user’s risk and no warranty is implied or expressed by ArcelorMittal Group with respect to the use of the information.\n",
	"efeasibility.excel.file.name": "Feasibility",
	"efeasibility.excel.template": "Get excel template",
	"efeasibility.template.error": "Please upload a file which follows the template provided by SteelUser application",
	"efeasibility.template.product.category.validation": "Product category is mandatory and must be one of the available values. Refer template for values.",
	"efeasibility.template.product.sub.category.validation": "Product sub category is mandatory and must be one of the available values. Refer template for values.",
	"efeasibility.template.soldtoname.validation": "Customer name is mandatory and must be one of the available values. Refer template for values.",
	"efeasibility.template.standard.steelgrade.validation": "Standard steelgrade is mandatory and must be one of the available values. Refer template for values.",
	"efeasibility.template.steelgrade.validation": "Steelgrade is mandatory and must be one of the available values. Refer template for values.",
	"elink.add.attachment": "Aggiungi allegato",
	"elink.category": "Categoria ",
	"elink.comment": "Commento",
	"elink.comment-is-required": "Richiesto commento",
	"elink.contact-mill": "Contatto stabilimento",
	"elink.copy-to": "Copiato da",
	"elink.data-automatically-sent-with-the-mail": "Dato inviato automaticamente con email",
	"elink.delete": "Cancella",
	"elink.dimension": "Dimensioni",
	"elink.from": "Da",
	"elink.invalid-email-format": "Indirizzo email non valido",
	"elink.message": "Messaggio",
	"elink.send": "Invia",
	"elink.subject": "Soggetto",
	"email-message": "Email has been sent to confirm your new mail address",
	"end.date": "Data fine",
	"eoffer-From.month": "Dal mese",
	"eoffer-Period.label": "Periodo",
	"eoffer-Period.type": "Tipo di periodo",
	"eoffer-Period.type.custom": "Per un intervallo personalizzato",
	"eoffer-Period.type.month": "Per un intervallo di mesi",
	"eoffer-Period.type.quarter": "Per un intervallo di trimestri",
	"eoffer-Period.type.semester": "Per un intervallo di semestri",
	"eoffer-Period.type.year": "Per un intervallo di anni",
	"eoffer-Quarter": "Trimestre",
	"eoffer-Semester": "Semestre",
	"eoffer-To.month": "Al mese",
	"eoffer-selected.period": "Periodo selezionato",
	"eoffer.Choose.the.split.of.quantities.by": "Scegli la suddivisione delle quantità per",
	"eoffer.accepted": "Accettato",
	"eoffer.action.default": "Predefinito",
	"eoffer.action.delete": "Cancella",
	"eoffer.action.duplicate": "Duplica",
	"eoffer.action.new": "Nuovo",
	"eoffer.action.new.request": "Richiesta",
	"eoffer.action.new.request.for-a-new": "Per una nuova offerta",
	"eoffer.additional.fields": "Caratteristiche aggiuntive",
	"eoffer.assistant": "Contatto commerciale (assistente)",
	"eoffer.available.fields": "Caratteristiche disponibili",
	"eoffer.cancel": "Cancella",
	"eoffer.cart.finalise": "Completa il tuo carrello",
	"eoffer.cart.input.request": "Inserisci quantità richiesta, data di consegna e altre informazioni",
	"eoffer.cart.volume.request": "Volume richiesto",
	"eoffer.choose.split.quantities.error": "Si prega di scegliere la suddivisione delle quantità",
	"eoffer.choose.split.quantity.error": "Si prega di scegliere la suddivisione delle quantità",
	"eoffer.cockpit": "Pannello di controllo eOffer",
	"eoffer.comment": "Commenti",
	"eoffer.comment.product.is": "Lascia un commento per questo prodotto",
	"eoffer.confirm.thanks": "Grazie, abbiamo ricevuto la tua richiesta.",
	"eoffer.continue": "Continua",
	"eoffer.continue.draft": "Continua questa bozza",
	"eoffer.create.enduser": "Utente finale",
	"eoffer.currency": "Valuta",
	"eoffer.current.step": "Fase attuale",
	"eoffer.customer": "Cliente",
	"eoffer.datacenter.offerLines": "Data center: Linee di offerta",
	"eoffer.delivery.date": "Interpretazione data di consegna",
	"eoffer.dialog.clear.products": "Se cambi Cliente o Indirizzo di consegna o Utente finale, i prodotti nel carrello andranno persi. Vuoi continuare?",
	"eoffer.dialog.month": "Mese",
	"eoffer.dialog.monthweek": "Mese o settimana ",
	"eoffer.dialog.offer.remove.product": "Rimuovere il prodotto selezionato, vuoi continuare?",
	"eoffer.dialog.offer.submission.error": "Si è verificato un errore durante la presentazione dell'offerta",
	"eoffer.dialog.pdm": "Stabilimento di consegna preferito",
	"eoffer.dialog.period": "Scegli il tuo periodo",
	"eoffer.dialog.quantity": "Quantità",
	"eoffer.dialog.requested.delivery.time": "Seleziona il tuo tempo di consegna richiesto",
	"eoffer.dialog.reset.requested.delivery.time": "Modificare il periodo e reimpostare i tempi di consegna richiesti, vuoi continuare?",
	"eoffer.dialog.week": "Settimana",
	"eoffer.dialog.year": "Anno",
	"eoffer.dimension.mm": "Dimensioni (mm)",
	"eoffer.draft": "Bozza",
	"eoffer.draft.edit.message.line": "Per sottoporlo ad ArcelorMittal o per cancellarlo.",
	"eoffer.draft.edit.message.text": "È possibile modificarlo in seguito",
	"eoffer.draft.list.link": "Nella tua lista bozza.",
	"eoffer.draft.saved.successfully": "La tua richiesta di offerta è stata correttamente salvata come bozza",
	"eoffer.drafts": "Bozza",
	"eoffer.enduser": "Utente finale",
	"eoffer.entry": "Voce offerta",
	"eoffer.error.loading": "Impossibile caricare i valori del parametro",
	"eoffer.error.noenduser": "Cliente {{value}} senza utente finale",
	"eoffer.error.noshipto": "Cliente {{value}} senza destinazione",
	"eoffer.error.noshiptoenduser": "Cliente {{value}} senzadestinazione né utente finale",
	"eoffer.error.nosoldto": "Cliente non trovato",
	"eoffer.feasibility": "Fattibilità",
	"eoffer.feasibility.no": "Rigettato",
	"eoffer.feasibility.pending": "In sospeso",
	"eoffer.feasibility.yes": "OK",
	"eoffer.field": "Caratteristiche",
	"eoffer.form": "Modulo",
	"eoffer.header.commercial.contacts": "CONTATTI COMMERCIALI",
	"eoffer.header.commitment.period": "Periodo di impegno:",
	"eoffer.header.custOffNumber": "Numero offerta cliente",
	"eoffer.header.customer": "Cliente",
	"eoffer.header.entity.information": "Informazioni sugli enti",
	"eoffer.header.last.update.date": "Data ultimo aggiornamento",
	"eoffer.header.offer.name": "Nome dell'offerta",
	"eoffer.header.offer.validity.date": "Data validità offerta:",
	"eoffer.header.suppOffNumber": "Numero offerta fornitore",
	"eoffer.header.technical.contacts": "CONTATTI TECNICI",
	"eoffer.header.terms.information": "Informazioni sui termini",
	"eoffer.header.total": "Totale",
	"eoffer.home": "eOffer",
	"eoffer.home.active": "Offerte",
	"eoffer.home.cockpit": "La mia dashboard eOffer",
	"eoffer.home.request": "Nuovo",
	"eoffer.home.tool": "Richiedi un'offerta",
	"eoffer.idd.not.found": "Parametri IDD non trovati",
	"eoffer.in.calculation": "In calcolo",
	"eoffer.incot.not.found": "Parametri incoterm non trovati",
	"eoffer.incoterms": "Incoterm",
	"eoffer.interpretation.delivery.date": "Interpretazione data di consegna",
	"eoffer.mandatory.currency.reference": "La valuta è obbligatoria",
	"eoffer.mandatory.delivery.address": "L'indirizzo di consegna è obbligatorio",
	"eoffer.mandatory.enduser.reference": "L'utente finale è obbligatorio",
	"eoffer.mandatory.idd.reference": "L'IDD è obbligatorio",
	"eoffer.mandatory.incot.reference": "Incoterm è obbligatorio",
	"eoffer.mandatory.priceUnit.reference": "L'unità di prezzo è obbligatoria",
	"eoffer.mandatory.quantity": "La quantità è obbligatoria",
	"eoffer.mandatory.requestedDeliveryTime": "L'RDT è obbligatorio",
	"eoffer.mandatory.rfq.reference": "Il riferimento RFQ è obbligatorio",
	"eoffer.mandatory.soldTo.reference": "Cliente è obbligatorio",
	"eoffer.mandatory.tmode.reference": "La modalità di trasporto è obbligatoria",
	"eoffer.merge.warning": "Alcuni articoli sono stati uniti. Sono stati rilevati come prodotti identici.",
	"eoffer.message.offer.not.saved": "Impossibile salvare l'offerta",
	"eoffer.message.offer.not.submit": "Impossibile inviare l'offerta",
	"eoffer.message.offer.saved": "Offerta salvata",
	"eoffer.mill": "Stabilimento",
	"eoffer.mill.supplier.choice": "A scelta del fornitore",
	"eoffer.minimum.quantity": "È richiesta almeno 1 quantità",
	"eoffer.next": "Successivo",
	"eoffer.offer": "Offerta",
	"eoffer.offer.and.order": "Panoramica dell'offerta",
	"eoffer.offer.card": "Scheda offerta",
	"eoffer.offer.dashboard.not.retrived": "Impossibile recuperare i dati dell'offerta",
	"eoffer.offer.plural": "Offerte",
	"eoffer.offer.request": "Richiesta offerte",
	"eoffer.offer.terms": "Seleziona i termini della richiesta di offerta",
	"eoffer.offerLine": "Linea di offerta",
	"eoffer.offerLine.plural": "Linee di offerta",
	"eoffer.offers.draft": "Offerte - Bozza",
	"eoffer.paymentTerms": "Condizioni di pagamento",
	"eoffer.pc.label.weightDiameterMax": "Max",
	"eoffer.pc.label.weightDiameterMin": "Min",
	"eoffer.pc.label.weightDiameterUnit": "Unità",
	"eoffer.period": "Periodo",
	"eoffer.period.end": "Periodo (fine)",
	"eoffer.period.in.month.value": "{{value}} mese",
	"eoffer.period.month": "Periodo (in mese)",
	"eoffer.period.orderBook": "Periodo per registro delle commesse cronologico",
	"eoffer.period.quarter.initial.letter": "Q",
	"eoffer.period.selection.needed": "Selezione Necessaria",
	"eoffer.period.semester.initial.letter": "H",
	"eoffer.period.start": "Periodo (inizio)",
	"eoffer.prefered.delivery.mill": "Stabilimento di consegna preferito",
	"eoffer.previous": "Precedente",
	"eoffer.price": "Prezzo",
	"eoffer.pricing.unit": "Unità di prezzo",
	"eoffer.product": "Prodotto",
	"eoffer.product.card": "Informazioni sul prodotto",
	"eoffer.product.family": "Famiglia di prodotto ",
	"eoffer.product.family.infos.text": "Selezionare un cliente, un indirizzo di spedizione e un utente finale per accedere all'elenco prodotti",
	"eoffer.product.family.plural": "Famiglie di prodotto",
	"eoffer.product.load.content": "Impossibile caricare il contenuto del prodotto",
	"eoffer.product.not.found": "Descrizione prodotto non disponibile",
	"eoffer.product.plural": "Prodotti",
	"eoffer.quantity": "Quantità",
	"eoffer.quantity.error": "Inserisci una quantità valida",
	"eoffer.quantity.ton": "Quantità (tonn.)",
	"eoffer.quit.with.save": "Salva e chiudi",
	"eoffer.quit.without.save": "Chiudere senza salvare",
	"eoffer.referenceAm": "Riferimento AM",
	"eoffer.refresh": "Aggiornamento",
	"eoffer.remove.product": "Continua e rimuovi il prodotto selezionato",
	"eoffer.request.new.offer": "Richiedi una nuova offerta",
	"eoffer.request.new.offer.from.draft": "Richiedi una nuova offerta da questo",
	"eoffer.requested": "Richiesta",
	"eoffer.requested.delivery.time": "Tempo di consegna richiesto",
	"eoffer.reset.requested.delivery.time": "Continua e reimposta i tempi di consegna",
	"eoffer.review.selections.and.submit": "Controlla la tua selezione e invia",
	"eoffer.rfq.id": "Il tuo RFQ ID unico è",
	"eoffer.rfq.reference": "Il tuo riferimento RFQ",
	"eoffer.save": "Salva",
	"eoffer.save.offer.draft": "Salva la richiesta di offerta come bozza",
	"eoffer.save.offer.question": "Chiudere il wizard senza salvare l'offerta, vuoi continuare?",
	"eoffer.searchfield.extendable": "Ricerca rapida",
	"eoffer.select.period.info": "Clicca qui sotto per selezionare un periodo da 1 mese fino a 1 anno di calendario",
	"eoffer.select.price": "Seleziona il periodo di impegno sul prezzo per questa offerta",
	"eoffer.selector": "Selettore",
	"eoffer.set.entities": "Imposta le entità per questa offerta",
	"eoffer.shipto": "Indirizzo di consegna",
	"eoffer.simulation.shipto.enduser.error": "Errore dovuto alla forzatura di altro [shipto/enduser] dopo la simulazione.",
	"eoffer.soldto": "Indirizzo di consegna",
	"eoffer.status": "Status",
	"eoffer.status.accepted": "Accettato",
	"eoffer.status.accepted.plural": "Accettato",
	"eoffer.status.canceled": "Annullato",
	"eoffer.status.canceled.plural": "Annullato",
	"eoffer.status.draft": "Bozza",
	"eoffer.status.draft.plural": "Bozza",
	"eoffer.status.offered": "Offerto",
	"eoffer.status.offered.plural": "Offerto",
	"eoffer.status.rejected": "Respinto",
	"eoffer.status.requested": "Richiesta",
	"eoffer.status.requested.plural": "Richiesta",
	"eoffer.steelGrade": "Grado di acciaio",
	"eoffer.subcategory": "Sottocategoria",
	"eoffer.submission.feedback": "Puoi tenere traccia dello stato della richiesta di offerta tramite la dashboard delle richieste di offerta",
	"eoffer.submit": "Invia",
	"eoffer.supplier.offer.number": "Numero offerta fornitore",
	"eoffer.table.customer": "Cliente",
	"eoffer.table.enduser": "Utente finale",
	"eoffer.table.header.colTopSide": "Colore lato superiore",
	"eoffer.table.header.custMatRef": "Riferimento articolo cliente",
	"eoffer.table.header.custOffRef": "Riferimento offerta cliente",
	"eoffer.table.header.delivery.mill": "Stabilimento di consegna preferito",
	"eoffer.table.header.dim": "Dim. (mm)",
	"eoffer.table.header.dimension": "Dimensioni (mm)",
	"eoffer.table.header.dimensions": "Dimensions",
	"eoffer.table.header.feasibility": "Fattibilità",
	"eoffer.table.header.last.update": "Data ultimo aggiornamento",
	"eoffer.table.header.orderCount": "Articoli",
	"eoffer.table.header.period": "Periodo",
	"eoffer.table.header.price": "Prezzo",
	"eoffer.table.header.qttOrdered": "Quantità",
	"eoffer.table.header.quantity": "Quantità (tonn.)",
	"eoffer.table.header.rfqRef": "Riferimento RFQ",
	"eoffer.table.header.standsteelGrade": "Acciaio di alta qualità standard",
	"eoffer.table.header.status": "Stato",
	"eoffer.table.header.steelGrade": "Qualità",
	"eoffer.table.item.number": "Codice articolo",
	"eoffer.table.morw": "Mese o settimana",
	"eoffer.table.price.unit": "Prezzo (unitario)",
	"eoffer.table.price.value": "Prezzo (valore)",
	"eoffer.table.quantity.unit": "Quantità (unità)",
	"eoffer.table.quantity.value": "Quantità (valore)",
	"eoffer.table.shipto": "Spedire a",
	"eoffer.title.my.offers": "Le mie offerte",
	"eoffer.title.productlist.filter": "Scegli il prodotto per il quale desideri effettuare la richiesta",
	"eoffer.title.section.coilWeightInPercent": "Peso bobina in %",
	"eoffer.title.section.dimensionUnit": "Unità di misura",
	"eoffer.title.section.length": "Lunghezza",
	"eoffer.title.section.organicCoating": "Rivestimento organico",
	"eoffer.tonnes": "Tonnellate",
	"eoffer.total.quantity.for.period.draft": "Quantità totale per il periodo",
	"eoffer.track.status": "Puoi tracciare lo stato del tuo RFQ tramite il tuo",
	"eoffer.transport.mode": "Modalità di trasporto",
	"eoffer.validityDate": "Validità",
	"eoffer.weightAndInvoicing": "Peso e fatture",
	"eoffer.wizard.cart": "Carrello",
	"eoffer.wizard.delivery.address": "Indirizzo di consegna",
	"eoffer.wizard.end": "Controlla-invia",
	"eoffer.wizard.error.products.families": "Famiglie di prodotto non trovate",
	"eoffer.wizard.header.entity.information": "Informazioni sugli enti",
	"eoffer.wizard.header.terms.information": "Informazioni sui termini",
	"eoffer.wizard.parameters.error": "Impossibile caricare i parametri dell'offerta",
	"eoffer.wizard.period.error": "La data è stata reimpostata",
	"eoffer.wizard.period.selection.error": "Seleziona una data futura e valida per il periodo selezionato",
	"eoffer.wizard.request": "Richiedi offerta",
	"eoffer.wizard.specs": "Specifiche di prodotto",
	"eoffer.wizard.step.status": "Fase {{step}} di 4",
	"eoffer.wizard.submit": "Invia la tua richiesta di offerta",
	"eoffer.wizard.table.header.quantity": "Quantità (t)",
	"eoffer.wizard.terms": "Termini dell'offerta",
	"eorder.action.next": "Successivo",
	"eorder.action.save.draft": "Salva l'ordine come bozza",
	"eorder.add.item.confirm.action": "Volete confermare questa azione?",
	"eorder.add.item.confirm.change": "Si desidera confermare questa modifica?",
	"eorder.add.item.different.family.warning": "L'articolo o gli articoli selezionati non appartengono alla stessa famiglia di quelli presenti nel carrello. Cancelleremo il carrello prima di aggiungere i nuovi articoli richiesti.",
	"eorder.add.item.different.form.warning": "L'articolo o gli articoli selezionati non sono della stessa forma di quelli presenti nel carrello. Cancelleremo il carrello prima di aggiungere i nuovi articoli richiesti.",
	"eorder.add.item.empty.customer.warning": "Il campo cliente è vuoto. Non è possibile aggiungere alcun articolo al carrello.",
	"eorder.add.item.limit.exeeds.warning": "Aggiungendo [X] articoli al carrello, l'ordine sarà troppo grande per il processo attuale (>100 articoli). Ridurre il contenuto del carrello o il numero di articoli da aggiungere e riprovare.",
	"eorder.add.item.success": "[X] articolo/i aggiunto/i correttamente al carrello",
	"eorder.confirm.message": "Conferma",
	"eorder.create.order.title": "Informazioni sull’ordine",
	"eorder.customer.change.warning": "La modifica del campo Cliente cancella il carrello corrente. Un determinato ordine non può mescolare articoli di clienti diversi.",
	"eorder.draft.deleted.successfully": "La bozza dell'ordine stata eliminata correttamente",
	"eorder.draft.edit.message.text": "Potrai modificarla",
	"eorder.draft.last.update.date": "Data ultimo aggiornamento",
	"eorder.draft.list.link": "nella tua lista bozza.",
	"eorder.draft.norequest": "Nessuna richiesta bozza.",
	"eorder.draft.order-card.edit": "Modifica questa bozza",
	"eorder.draft.order-card.no-item.text": "Nessun elemento in bozza",
	"eorder.draft.order-card.placed.text": "Dettagli dell'ordine preliminare",
	"eorder.draft.order-card.title": "Dettagli dell'ordine preliminare",
	"eorder.draft.product.family": "Famiglia",
	"eorder.draft.product.number": "N° prodotti",
	"eorder.draft.requested.quantity": "Quantità richiesta",
	"eorder.draft.saved.successfully": "La bozza è stata salvata.",
	"eorder.fixed-columns": "Fixed columns",
	"eorder.grid.header.view.label": "View",
	"eorder.line.select.family.product": "To add an item into cart, choose the number of copy of a product, and click on the corresponding button Add to cart",
	"eorder.mandatory.currency": "La valuta è obbligatoria",
	"eorder.mandatory.end.user": "L'utente finale è obbligatorio",
	"eorder.mandatory.idd": "L'interpretazione data di consegna è obbligatoria",
	"eorder.mandatory.pricingUnit": "L'unità di prezzo è obbligatoria",
	"eorder.mandatory.shipTo.reference": "La destinazione della spedizione è obbligatoria",
	"eorder.message.order.not.saved": "Impossibile salvare l'ordine",
	"eorder.no.product.family": "No products found for the selected customer",
	"eorder.order": "Richiesta ordine",
	"eorder.order.creation": "Creazione ordine",
	"eorder.orders.request": "Richiesta ordini",
	"eorder.product.color.bottom": "Colour (Bottom)",
	"eorder.product.colour.top": "Colour (Top)",
	"eorder.product.custmaterialnum": "Customer Material Number",
	"eorder.product.data.commercial.steelgrade.id": "ID grado acciaio commerciale",
	"eorder.product.data.customer.article": "Articolo cliente",
	"eorder.product.dimension": "Dimensioni",
	"eorder.product.empty.row": "No active product linked to this template",
	"eorder.product.family.infos.title": "Selezionare un cliente, un indirizzo di spedizione e un utente finale per accedere all'elenco prodotti",
	"eorder.product.fc.products.label": "Fully configured products",
	"eorder.product.grid.note.fc": "[Y] product(s).",
	"eorder.product.grid.note.nfc": "[X] template(s) and [Y] product(s). A template is an item with empty variables to let you create a new product",
	"eorder.product.lastused": "Last used",
	"eorder.product.lastused.default": "Mai",
	"eorder.product.metalliccoating": "Metallic Coating",
	"eorder.product.organiccoating.datasheet.top": "Organic Coating Data Sheet (Top)",
	"eorder.product.organicdatasheet.bottom": "Organic Coating Data Sheet (Bottom)",
	"eorder.product.removablefilm": "Removable Protective Film",
	"eorder.product.steelgrade": "Steel Grade",
	"eorder.product.surfaceaspect": "Surface Aspect",
	"eorder.product.template.add.to.cart": "Add as empty product to cart",
	"eorder.product.type.fc": "Catalog product",
	"eorder.product.type.fm": "To be configured (with default values)",
	"eorder.product.type.nfc": "To be configured",
	"eorder.product.variables": "variables(s)",
	"eorder.product.variables.title": "Variables on this template:",
	"eorder.save.draft.confirmation": "Vuoi salvare [X] come bozza?",
	"eorder.save.draft.error.message": "Ci dispiace, si è verificato un errore durante il processo di salvataggio della bozza del tuo ordine. Riprova più tardi o invia un messaggio al tuo referente AM.",
	"eorder.save.draft.success.message": "Una bozza della tua richiesta d'ordine è stata salvata correttamente.",
	"eorder.select.product.spec": "Products list",
	"eorder.submit.error.msg.bad.data": "Dati errati nella richiesta.",
	"eorder.submit.error.msg.rqd.data.missing": "Mancano i dati obbligatori",
	"eorder.submit.order.success.follow.up.link": "FOLLOW-UP ORDINE E CONSEGNA.",
	"eorder.submit.order.success.follow.up.text": "È possibile seguire l'evoluzione del suo stato nel",
	"eorder.submit.order.success.text1": "La sua richiesta ordine",
	"eorder.submit.order.success.text2": "è stata elaborata.",
	"eorder.wizard.header.customer": "Il campo Cliente è obbligatorio",
	"eorder.wizard.header.customer-order-number": "Numero d’ordine cliente",
	"eorder.wizard.header.customer-order-number.error.invalid": "Numero d'ordine cliente non valido",
	"eorder.wizard.header.customer-order-number.error.mandatory": "Il numero d'ordine cliente è obbligatorio",
	"eorder.wizard.header.purchase-order-contract.error.invalid": "Numero di contratto non valido",
	"eorder.wizard.header.purchase-order-contract.error.mandatory": "Il contratto ordine acquisto è obbligatorio",
	"eorder.wizard.order.currency": "Valuta",
	"eorder.wizard.order.enduser": "Utente finale",
	"eorder.wizard.order.idd": "Interpretazione data di consegna",
	"eorder.wizard.order.pricingUnit": "Unità di prezzo",
	"eorder.wizard.order.purchase.contract": "Contratto di acquisto ordine",
	"eorder.wizard.order.shipto.name": "Indirizzo di consegna",
	"eorder.wizard.order.soldto.name": "Cliente",
	"eorder.wizard.parameters.error": "Impossibile caricare parametri ordine elettronico",
	"eorder.wizard.product.action.delete": "Elimina",
	"eorder.wizard.product.action.duplicate": "Duplicato",
	"eorder.wizard.product.card.error": "⚠ This item is no more valid or has issues to be loaded",
	"eorder.wizard.product.itemnumber": "Numero articolo",
	"eorder.wizard.product.modification.no.products": "N° prodotto.",
	"eorder.wizard.product.modification.order.title": "Ordine",
	"eorder.wizard.product.modification.title.cart": "Il tuo carrello",
	"eorder.wizard.product.modification.title.item": "articolo",
	"eorder.wizard.product.modification.title.items": "articolo/i",
	"eorder.wizard.product.quantity": "Quantità (t)",
	"eorder.wizard.product.rdd": "Data di consegna richiesta",
	"eorder.wizard.product.rdd.error": "Data nel passato",
	"eorder.wizard.product.rdd.type": "Tipo data consegna richiesta",
	"eorder.wizard.product.service.level": "Livello di servizio",
	"eorder.wizard.product.steelgrade": "Grado di acciaio",
	"eorder.wizard.product.thickness": "Spessore",
	"eorder.wizard.product.width": "Larghezza",
	"eorder.wizard.quantity.error": "Immettere una quantità valida maggiore o uguale a 1.",
	"eorder.wizard.stepper.step.order.information": "Informazioni sull'ordine e selezione prodotto",
	"eorder.wizard.stepper.step.product.modification": "Modifica del prodotto",
	"eorder.wizard.stepper.step.summary": "Riepilogo ordine",
	"eorder.wizard.summary.header.contract.po": "Contratto (PO)",
	"eorder.wizard.summary.header.currency.po": "Valuta di fatturazione",
	"eorder.wizard.summary.header.order.title": "Informazioni sull’ordine",
	"eorder.wizard.summary.order.placed.text": "Ordine inviato - ",
	"eorder.wizard.summary.terms.conditions.text": "Cliccando su Procedere all'ordine, si accettano i termini e le condizioni della voce di ordine web",
	"eorder.wizard.summary.total.quantity": "Quantità totali (t)",
	"epassivefilm.P": "E-Passivation®",
	"epassivefilm.S": "Easyfilm®",
	"error.cancelling.issue": "Error while cancelling issue",
	"error.choose.pdf.manager": "Installa un gestore pdf manager sul telefono",
	"error.deleting.draft": "Errore durante l'eliminazione della bozza",
	"error.file.download": "Si è verificato un errore durante il download",
	"error.file.not.found": "Il file non esiste",
	"error.inavlid.transport.cost": "Costo di trasporto non valido",
	"error.place.atleast.one.bid": "Fai almeno un'offerta prima di salvare",
	"exception-report.amlno": "AMLNo",
	"exception-report.comment-by-am": "Historical exception report Arcelormittal comment",
	"exception-report.comment-by-customer": "Historical exception report customer comment",
	"exception-report.delete": "La sua richiesta di segnalazione delle eccezioni è stata eliminata correttamente",
	"exception-report.dialog.add-comment.title": "Aggiunga un commento per finalizzare la sua richiesta di segnalazione sull'ordine",
	"exception-report.dialog.current-status.title": "Lo stato attuale della sua richiesta sull'ordine",
	"exception-report.dialog.processing": "In elaborazione",
	"exception-report.docNo": "Documento n°",
	"exception-report.edit-request": "Modifica commento",
	"exception-report.last.comment-by-am": "Exception report Arcelormittal last comment",
	"exception-report.last.comment-by-customer": "Exception report customer last comment",
	"exception-report.make-new-request": "Request exception report",
	"exception-report.order-card-header": "Richiesta speciale",
	"exception-report.save": "La richiesta di segnalazione delle eccezioni è stata inviata. Può seguire la sua richiesta settimanale nella LISTA DEGLI ORDINI",
	"exception-report.status": "Stato dei commenti",
	"exception-report.yearweek": "AnnoSettimana",
	"fabrication.process.H": "Tubing + HF",
	"fabrication.process.L": "Tubing + Laser",
	"fabrication.process.R": "Roll Forming",
	"fabrication.process.S": "Stamping",
	"fast.lane.entry": "Fast Lane",
	"fastlane.attachments": "Allegati",
	"fastlane.create.details.field.currency": "Scegli la tua valuta",
	"fastlane.delivery.address": "L'indirizzo di consegna è obbligatorio!",
	"fastlane.delivery.infos.title": "Please choose the delivery address for your items in the predefined list or customize one. In case of custom destination, you will have to provide some details.",
	"fastlane.error.nosoldto": "Cliente non trovato",
	"fastlane.file.import.button": "Import",
	"fastlane.file.import.note": "Prefill all items by using a file",
	"fastlane.file.import.progressMessage": "Import in progress.",
	"fastlane.file.import.result.label": "Result",
	"fastlane.file.import.result.text": "Please upload a file",
	"fastlane.file.import.validate": "Validate",
	"fastlane.file.template.download.note": "Use proper format for file by downloading the template by clicking here",
	"fastlane.header.customer-request-name.error.mandatory": "Request name is mandatory!",
	"fastlane.header.wizard.customer-request-name": "Request name",
	"fastlane.import.popup.text.1": "Upload an XLS file to prefill in one run all your items. Please follow the template in order to allow automatic detection.",
	"fastlane.import.popup.text.2": "If some fields are too long for text fields, they will be cut (ex: Name for an item: limit = 80 chars)",
	"fastlane.import.popup.text.3": "If some fields require a list of values and the file contains a non existing value, it will be ignored.",
	"fastlane.import.popup.text.4": "A given item must have all mandatory fields provided",
	"fastlane.import.popup.text.5": "The list of all defects will be provided at the end of the process to let you validate or retry.",
	"fastlane.import.popup.title": "Prefill all items",
	"fastlane.info.commercial.data": "Dati commerciali",
	"fastlane.info.request.details": "Request details",
	"fastlane.itemlist.coil.inner.diameter": "Diametro interno",
	"fastlane.itemlist.coil.inner.diameter.508mm": "508 mm",
	"fastlane.itemlist.coil.inner.diameter.610mm": "610 mm",
	"fastlane.itemlist.coil.inner.diameter.NA": "N/A",
	"fastlane.itemlist.coil.inner.diameter.default": "Vertical",
	"fastlane.itemlist.coil.max_outer_diameter": "Max outer diameter",
	"fastlane.itemlist.global.quantity": "Quantità",
	"fastlane.itemlist.global.quantity.error": "Quantity is mandatory!",
	"fastlane.itemlist.global.select_unit.error": "Please select a unit",
	"fastlane.itemlist.global.unit": "Unità",
	"fastlane.itemlist.global.unit.error": "L'unità è obbligatoria",
	"fastlane.itemlist.item.additional.info": "Additional item information",
	"fastlane.itemlist.navig.duplicate": "Duplica",
	"fastlane.itemlist.navig.reset": "Ripristina",
	"fastlane.itemlist.order.thickness": "Spessore",
	"fastlane.itemlist.product.blankWeight.error.invalid": "Il peso deve essere maggiore di 0",
	"fastlane.itemlist.product.blank_weight": "Blank weight",
	"fastlane.itemlist.product.blank_weight.error": "The weight of one unit is mandatory!",
	"fastlane.itemlist.product.coating.error.invalid": "Il rivestimento deve essere maggiore di 0",
	"fastlane.itemlist.product.coating.mandatory": "Coating is mandatory!",
	"fastlane.itemlist.product.coil_axis": "Coil axis",
	"fastlane.itemlist.product.coil_axis.default": "-- None --",
	"fastlane.itemlist.product.coil_axis.horizontal": "Horizontal",
	"fastlane.itemlist.product.coil_axis.vertical": "Vertical",
	"fastlane.itemlist.product.form_blank": "Form Blank",
	"fastlane.itemlist.product.item_form": "Modulo",
	"fastlane.itemlist.product.item_form.error": "La forma è obbigatoria",
	"fastlane.itemlist.product.item_name": "Name",
	"fastlane.itemlist.product.item_name.error": "Name for the item is mandatory!",
	"fastlane.itemlist.product.item_number": "Numero articolo",
	"fastlane.itemlist.product.length.error": "Length is mandatory!",
	"fastlane.itemlist.product.length.error.invalid": "La lunghezza deve essere maggiore di 0",
	"fastlane.itemlist.product.maxOuterDiameter.error.invalid": "Il diametro esterno massimo deve essere maggiore di 0",
	"fastlane.itemlist.product.quantity.error.invalid": "La quantità deve essere maggiore di 0",
	"fastlane.itemlist.product.select_form.error": "Please select a form",
	"fastlane.itemlist.product.slitting_coil": "Slitting Coil",
	"fastlane.itemlist.product.steel_grade": "Grado di acciaio",
	"fastlane.itemlist.product.steel_grade.error": "Steel grade is mandatory!",
	"fastlane.itemlist.product.thickness.error": "Thickness is mandatory!",
	"fastlane.itemlist.product.thickness.error.invalid": "Lo spessore deve essere compreso tra 0.1 e 999",
	"fastlane.itemlist.product.width.error": "Width is mandatory!",
	"fastlane.itemlist.product.width.error.invalid": "La larghezza deve essere maggiore di 0",
	"fastlane.itemlist.productcharacteristic.oilquantity": "Oliatura",
	"fastlane.itemlist.quality.calculator.coil": "Bobina",
	"fastlane.itemlist.quality.calculator.sheet": "Foglio",
	"fastlane.itemlist.unit.blanks": "Blanks",
	"fastlane.itemlist.unit.sheets": "Fogli",
	"fastlane.itemlist.unit.tons": "Tonnellate",
	"fastlane.mandatory.delivery.address": "L'indirizzo di consegna è obbligatorio",
	"fastlane.prototype.dialog.week": "settimana",
	"fastlane.prototype.not.found": "Not found",
	"fastlane.prototyperequest.request": "Fast Lane request",
	"fastlane.request.title": "Request information",
	"fastlane.soldto.shipto.error": "Sorry, there is an issue in your service settings, please contact SteelUser administrator",
	"fastlane.submit.error.msg": "Something went wrong. Please contact your SteelUser administrator.",
	"fastlane.submit.error.msg.mandatoryfield": "Some mandatory fields are missing.",
	"fastlane.submit.error.msg.nosoldtoshipto": "Something is wrong with your settings for this service",
	"fastlane.submit.error.msg.notoken": "Your session is expired. Please log in the application.",
	"fastlane.submit.request.error.msg.title": "Error during validation of your request",
	"fastlane.template.addinfo.validation": "Additional Information cannot exceed 255 chars ([X] detected)",
	"fastlane.template.blankweight.validation": "Blank Weight is mandatory for Form Blank and must be a valid number greater or equal to 1 with 2 digits (truncated if more). ([X] detected)",
	"fastlane.template.coating.validation": "Coating is mandatory and cannot exceed 50 chars ([X] detected)",
	"fastlane.template.coilaxis.validation": "Coil Axis is mandatory and must be one of the followed values: -- None --, Horizontal, Vertical (“[X]” detected). “-- None --” will be set by default",
	"fastlane.template.currency.validation": "Currency is mandatory and must be one of the followed values: EUR, GPB, USD (“[X]” detected). EUR will be set by default",
	"fastlane.template.deliveryaddress.validation": "Delivery address is not mandatory, but if filled in, cannot exceed 150 chars ([X] detected)",
	"fastlane.template.description.validation": "Description is mandatory and cannot exceed 255 chars ([X] detected)",
	"fastlane.template.detected.items": "[X] items detected in the file",
	"fastlane.template.form.validation": "Form is mandatory and must be one of the followed values: Coil, Sheet, Slitting Coil, Form Blank (“[X]” detected). Coil will be set by default",
	"fastlane.template.format.error": "The file should be a template provided by ArcelorMittal. We are not able to analyse it, it may be a wrong file or a corrupted one. If you have doubt on it, communicate with your AM contact by sending them the file.",
	"fastlane.template.global.data.issue": "Global data with issues",
	"fastlane.template.global.error": "Global error(s) preventing any analysis of the document",
	"fastlane.template.incoterms.validation": "Incoterms is mandatory and must be one of the followed values: -- None --, DAP, CIF, CIP, FCA, DDP (“[X]” detected). “-- None --” will be set by default",
	"fastlane.template.innerdiameter.validation": "Inner Diameter is mandatory and must be one of the followed values: N/A, 508 mm, 610 mm (“[X]” detected). “N/A” will be set by default",
	"fastlane.template.item.issue.header": "[X] items with issues",
	"fastlane.template.itemname.validation": "Item Name is mandatory and cannot exceed 80 chars ([X] detected)",
	"fastlane.template.length.validation": "Length is mandatory for Sheet and must be a valid number greater or equal to 1 with 0 digits (truncated if any). ([X] detected)",
	"fastlane.template.line": "Line",
	"fastlane.template.mill.validation": "Mill is mandatory and must be one of the valid values. (“[X]” detected). “-- None --” will be set by default",
	"fastlane.template.oiling.validation": "Oiling cannot exceed 50 chars ([X] detected)",
	"fastlane.template.outerdiameter.validation": "Max Outer Diameter must be a valid number greater or equal to 1 with 0 digits (truncated if any). ([X] detected)",
	"fastlane.template.packing.validation": "Packing cannot exceed 50 chars ([X] detected)",
	"fastlane.template.quantity.validation": "Quantity is mandatory and must be a valid positive number with max 2 or 0 digits based on unit selected (truncated if more). ([X] detected)",
	"fastlane.template.rddday.validation": "A Delivery Date has been provided in Day, but not in proper pattern (dd/mm/yyyy, ex: 02/02/2024). (“[X]” detected)",
	"fastlane.template.rddweek.validation": "A Delivery Date has been provided in Week, but not in proper pattern (Www/YYYY, ex: W01/2024). (“[X]” detected)",
	"fastlane.template.rddwnd.validation": "The day provided for Delivery Date should correspond to the week. (“[Y]” is not part of “[X]” Week)",
	"fastlane.template.request": "Request",
	"fastlane.template.requestname.validation": "Request name is mandatory and cannot exceed 120 chars ([X] detected)",
	"fastlane.template.steelgrade.validation": "Steelgrade is mandatory and cannot exceed 255 chars ([X] detected)",
	"fastlane.template.thickness.validation": "Thickness is mandatory and must be a valid positive number with max 2 digits (truncated if more). Should be less than or equal to 999. ([X] detected)",
	"fastlane.template.tmode.validation": "Transport Mode is mandatory and must be one of the followed values: -- None --, Train, Boat, Truck, Plane (“[X]” detected). “-- None --” will be set by default",
	"fastlane.template.unitbasic.validation": "Unit is mandatory and must be one of the followed values: Tons, Sheets, m², Blanks. (“[X]” detected). Default value will be set linked to Form.",
	"fastlane.template.unitform.validation": "“[X]” Quantity value is not valid for “[Y]” Form.",
	"fastlane.template.upload.confirmation.text1": "File properly imported in session.",
	"fastlane.template.upload.confirmation.text2": "Please recheck all items in session before confirming the request.",
	"fastlane.template.upload.warning.text": "You can validate this partial result or try to reupload the file by fixing issues",
	"fastlane.template.valid.items": "[X] items without any issue",
	"fastlane.template.width.validation": "Width is mandatory and must be a valid number greater or equal to 1 with 0 digits (truncated if any). ([X] detected)",
	"fastlane.template.xls.mime.type": "The file must be an Excel file. Please use the proper template provided by SteelUser application.",
	"fastlane.wizard.contact.person.mandatory": "Person of contact is mandatory!",
	"fastlane.wizard.contact.phone.number": "Phone number of this contact",
	"fastlane.wizard.currency": "Valuta",
	"fastlane.wizard.custom.destination": "Custom destination",
	"fastlane.wizard.custom.destination.contact.person": "Person of contact at custom destination",
	"fastlane.wizard.decide.later": "-- Decide Later --",
	"fastlane.wizard.delivery.address": "Predefined delivery address",
	"fastlane.wizard.header.customer": "Il campo Cliente è obbligatorio",
	"fastlane.wizard.header.customer-request-name": "Request name",
	"fastlane.wizard.header.customer-request-name.error.invalid": "Invalid Request name",
	"fastlane.wizard.header.global.description": "Description",
	"fastlane.wizard.header.no.item.list": "No item in this request",
	"fastlane.wizard.header.request.data": "Request data",
	"fastlane.wizard.items.details.addanitem": "Add an item",
	"fastlane.wizard.items.details.datetype": "Date type",
	"fastlane.wizard.items.details.datetype.errormsg": "Il tipo di data è obbligatorio!",
	"fastlane.wizard.items.details.datetype.rdd": "Data di consegna richiesta",
	"fastlane.wizard.items.details.day": "Giorno",
	"fastlane.wizard.items.details.itemrequest": "Item requests",
	"fastlane.wizard.items.details.sheet.weight": "Peso foglio (in kg)",
	"fastlane.wizard.items.details.total.weight": "Peso totale (in tonnellate)",
	"fastlane.wizard.items.details.week": "Settimana",
	"fastlane.wizard.parameters.error": "Impossibile caricare i parametri fastlane",
	"fastlane.wizard.phone.number.mandatory": "Phone number is mandatory!",
	"fastlane.wizard.product.transport.desired.arcelormittal.plant": "Desired ArcelorMittal plant",
	"fastlane.wizard.product.transport.desired.arcelormittal.plant.errmsg": "Plant is mandatory!",
	"fastlane.wizard.product.transport.mode.errormsg": "La modalità di trasporto è obbligatoria",
	"fastlane.wizard.shipto.name": "Indirizzo di consegna",
	"fastlane.wizard.soldto.name": "Cliente",
	"fastlane.wizard.stepper.step.items.details": "Items details",
	"fastlane.wizard.stepper.step.main.data": "Main data",
	"fastlane.wizard.stepper.step.transport.details": "Transport details",
	"fastlane.wizard.stepper.step.transport.summary": "Summary",
	"fastlane.wizard.summary.header.currency.po": "Valuta di fatturazione",
	"fastlane.wizard.summary.submitBtn": "Submit your Fast Lane request",
	"fastlane.xlx.template": "XLS Template",
	"favorite-orders.title": "I miei ordini segnalati",
	"feasibility-status": "Feasibility",
	"feasibility.product-category": "Product category",
	"feasibiliy-characteristics": "Characteristics",
	"feasible-results": "Feasibility Results",
	"fields.number.error": "Thickness and width should be in number format",
	"filter.abandon": "Abbandona",
	"filter.add": "Aggiungi",
	"filter.add.dimension": "Dimensioni (in mm)",
	"filter.all": "Tutti",
	"filter.apply": "Applica",
	"filter.atConsignment": "In consegna",
	"filter.batchid": "ID Lotto",
	"filter.bottom-color": "Colore inferiore",
	"filter.cancel": "Cancella",
	"filter.cdd": "Data di consegna confermata",
	"filter.cddGtRdd": "CDD > RDD (data di consegna richiesta)",
	"filter.coating": "Specifica del rivestimento",
	"filter.confirmation.deleteall": "Vuoi davvero rimuovere tutti i filtri?",
	"filter.contractNumber": "Numero di contratto",
	"filter.criteria.applied": "Filtro applicato",
	"filter.criteria.no.applied": "Nessun filtro applicato",
	"filter.customerArticleReference": "Riferimento articolo cliente",
	"filter.customerOrderNumber": "Numero d’ordine cliente",
	"filter.date": "Data",
	"filter.date.from": "Da",
	"filter.date.invalid": "La data deve avere un formato valido",
	"filter.date.to": "A",
	"filter.deleteall": "Cancella tutto",
	"filter.delivered": "Consegnato",
	"filter.deliveryMode": "Modalità di consegna",
	"filter.dimension": "Dimensioni",
	"filter.dimensions.length": "Lunghezza",
	"filter.dimensions.thickness": "Spessore",
	"filter.dimensions.width": "Larghezza",
	"filter.dispatchAdviceNumber": "Numero dell’avvisi di spedizione",
	"filter.dispatchDate": "Data di spedizione",
	"filter.enddate.inferior": "La data deve essere maggiore della precedente",
	"filter.field.invalid": "Valore non valido",
	"filter.field.required": "Questo campo è obbligatorio",
	"filter.filters": "Filtri",
	"filter.format.day": "Formato giorno",
	"filter.format.week": "Formato settimana",
	"filter.grossOrdersWithMaterial": "Peso lordo del materiale",
	"filter.inTransit": "In transito",
	"filter.is-not-a-number": "Il valore deve esser un numero",
	"filter.is-not-a-positive-number": "Il valore deve esser un numero positivo",
	"filter.length": "Lunghezza",
	"filter.less-than": "Uguale o minore di",
	"filter.mill": "Acciaieria",
	"filter.more-than": "Uguale o maggiore di",
	"filter.multiple-values": "Valori multipli...",
	"filter.netOrdersWithMaterial": "Peso netto del materiale",
	"filter.no-matching-value": "Nessun valore corrispondente",
	"filter.no-value": "Nessun valore",
	"filter.no.predefined": "Non predefinito",
	"filter.number.from": "Da",
	"filter.number.to": "A",
	"filter.ok": "Ok",
	"filter.operator.exact": "Esatta",
	"filter.operator.range": "Gamma",
	"filter.order-number.item": "Item",
	"filter.order-number.reference": "Riferenza",
	"filter.order.item.number": "Numero d’ordine",
	"filter.order.reference": "Riferimento ordine",
	"filter.orderWithCddGtRdd": "RDD < CDD",
	"filter.ordersWithMaterial": "Ordini con materiali",
	"filter.placeholder.list": "Seleziona nella lista",
	"filter.placeholder.suggestive.list": "Cerca un valore",
	"filter.predefined": "Predefinito",
	"filter.readyToShip": "Pronto per la spedizione",
	"filter.reset": "Cancella",
	"filter.schedule-business-order": "Schedule business order",
	"filter.scheduleBusinessOrdersWithMaterial": "Schedule Business Orders with material",
	"filter.shipment-section-n1": "Attività in corso (WIP)",
	"filter.shipment-section-n2": "Attività in corso (WIP)",
	"filter.spot-order": "Spot order",
	"filter.standardsteelgrade": "Grado di acciaio standard",
	"filter.supplierOrderNumber": "Numero d’ordine fornitore",
	"filter.text": "Usa ; come indicatore di separazione, * come jolly",
	"filter.thickness": "Spessore",
	"filter.top-color": "Colore superiore",
	"filter.week.to": "A",
	"filter.width": "Larghezza",
	"filter.workInProgress": "Attività in corso (WIP)",
	"filter.x-filter-applied": "Filtro applicato {{valore}}",
	"filter.x-filters-applied": "Filtri applicati {{valore}}",
	"filter.x-selected-values": "Valori selezionati {{valore}}",
	"filter.yes": "Sì",
	"footer.alerts": "Avvisi",
	"footer.home": "Home",
	"footer.message": "Messaggio",
	"footer.search": "Cerca",
	"form.blanks": "Blanks",
	"form.coil": "Coil",
	"form.heavy.plate": "Heavy Plate",
	"form.indif.04": "Slab",
	"form.indif.06": "Coil",
	"form.indif.07": "Sheet",
	"form.indif.08": "Blanks",
	"form.indif.09": "Heavy Plate",
	"form.indif.10": "Thick Plate",
	"form.indif.12": "Slit coil",
	"form.indif.15": "Scrolled sheet",
	"form.indif.16": "Mixed Coil",
	"form.indif.17": "Welded Coil",
	"form.mixed.coil": "Mixed Coil",
	"form.scrolled.sheet": "Scrolled Sheet",
	"form.sheet": "Sheet",
	"form.slab": "Slab",
	"form.slit.coil": "Slit Coil",
	"form.thick.plate": "Thick Plate",
	"form.welded.coil": "Welded Coil",
	"full.product.catalogue": "Catalogo completo prodotti",
	"global-subcategory.BL": "Hot rolled black",
	"global-subcategory.CR": "Cold rolled",
	"global-subcategory.MS": "Metal studs",
	"global-subcategory.PI": "Hot rolled pickled and oiled",
	"global-subcategory.Z": "Hot dip galvanized",
	"global.action.cancelled": "Azione annullata",
	"global.business-type": "Business Type",
	"global.cancelled": "Annullato",
	"global.clickhere": "Clicca qui",
	"global.closed": "Chiuso",
	"global.copyto": "Copy to",
	"global.error": "An error occured while trying to get your list of products",
	"global.error.unexpected": "Errore imprevisto",
	"global.internal.server.error": "Errore interno del server",
	"global.internal.soldto.error": "Errore di impostazione sul vostro account, non potete effettuare questa richiesta d'ordine (cliente). Si prega di contattare il proprio referente AM.",
	"global.message": "Message",
	"global.message-error": "Message is mandatory!",
	"global.next": "Successivo",
	"global.no": "No",
	"global.none": "Nessuno",
	"global.open": "Aperto",
	"global.or": "O",
	"global.search-filter": "Global Search",
	"global.search.fastlane-entry": "FastLane",
	"global.search.fastlane-requests": "FastLane requests",
	"global.send": "Invia",
	"global.servicelevel": "Livello del Servizio",
	"global.subject": "Subject",
	"global.subject-error-msg": "Subject is mandatory!",
	"global.submit.error.unexpected": "Si è verificato un errore imprevisto durante il processo di invio, si prega di riprovare più tardi o di mettersi in contatto con il proprio contatto AM.",
	"global.submit.service.error": "Il vostro account non dispone dei permessi necessari per inviare una richiesta d'ordine. Rivolgetevi al vostro contatto AM.",
	"global.unexpected.error.identified": "unexpected error identified",
	"global.warning": "Avvertimento",
	"global.yes": "Sì",
	"guaranatee.aluminium.parts": "Alluminio per componenti",
	"guarantee.Others": "Altri",
	"guarantee.Poultry": "Pollame",
	"guarantee.acoustic": "Barriere acustiche",
	"guarantee.acoustic.concrete": "È presente una base di calcestruzzo che separi gli elementi rivestiti con Magnelis® dal terreno?",
	"guarantee.acoustic.railroad": "Barriere acustiche per ferrovia",
	"guarantee.acoustic.road.traffic": "Dispositivo fonoassorbente stradale / barriere acustiche per le strade",
	"guarantee.activity.building": "Attività all'interno dell'edificio",
	"guarantee.activity.specify": "Specificare l'attività",
	"guarantee.add.parts": "Aggiungi componenti",
	"guarantee.additional.comments": "Informazioni o commenti aggiuntivi",
	"guarantee.additional.documents": "Documenti aggiuntivi",
	"guarantee.address": "Città / Paese",
	"guarantee.age.material": "Età del materiale da sostituire",
	"guarantee.agricultural": "Agricolo",
	"guarantee.agricultural.questions": "Domanda per edifici agricoli",
	"guarantee.agricultural.specify": "Specificare:",
	"guarantee.air.renewal": "specificare la capacità di ricambio dell'aria (in m3/h/animale)",
	"guarantee.allocation.building": "Assegnazione d'uso e destinazione dell'edificio",
	"guarantee.altitude.above.900m": "Sopra i 900 m",
	"guarantee.altitude.below.900m": "Sotto i 900 m",
	"guarantee.aluminium": "Alluminio",
	"guarantee.ambiance": "Ambiente all'interno dell'edificio",
	"guarantee.ammonia": "specificare la concentrazione di ammoniaca all'interno (in ppm)",
	"guarantee.animals.density": "Densità degli animali al m²?",
	"guarantee.animals.inside.building": "Quali animali vengono tenuti dentro all'edificio?",
	"guarantee.animals.shed": "Specificare il numero di animali presenti nel capannone",
	"guarantee.area": "Nome area",
	"guarantee.atmospheric.corrosion": "Corrosione atmosferica",
	"guarantee.attachment": "Documento allegato",
	"guarantee.attachment.categorize.title": "Etichetta ciascun documento con l'analisi a cui corrisponde:",
	"guarantee.attachment.category.label": "Tipo di documento",
	"guarantee.attachment.category.other": "Altro",
	"guarantee.attachment.category.soil": "Analisi del suolo",
	"guarantee.attachment.category.water": "Analisi dell'acqua",
	"guarantee.attachment.column.actions": "Azioni",
	"guarantee.attachment.column.file": "Nome del file",
	"guarantee.attachment.column.size": "Dimensione",
	"guarantee.attachment.description": "Carica ed etichetta i tuoi documenti. Ogni file deve essere etichettato con l'analisi a cui corrisponde.",
	"guarantee.attachment.limit": "La dimensione massima del file è di 115 MB.",
	"guarantee.attachment.missing.soil": "Mancante: documento per l'analisi del suolo",
	"guarantee.attachment.missing.title": "Documento richiesto mancante",
	"guarantee.attachment.missing.water": "Mancante: documento per l'analisi dell'acqua",
	"guarantee.attachment.size": "Le dimensioni dell'allegato non devono superare i 115mb",
	"guarantee.attachment.title": "Allegati",
	"guarantee.attachment.uploaded.title": "Documenti caricati",
	"guarantee.between.2kmand10km": "Situato tra 2km e 10km dalla costa",
	"guarantee.between.300mand2km": "Situato tra 300m e 2km dalla costa",
	"guarantee.breeding.animals": "Allevamento di animali",
	"guarantee.building.altitude": "Altitudine",
	"guarantee.building.heated": "L'edificio è riscaldato?",
	"guarantee.cancelled": "Annulla",
	"guarantee.card.client.project.name": "Nome progetto cliente",
	"guarantee.card.details": "Dettagli richiesta di garanzia",
	"guarantee.card.info": "Informazioni di garanzia",
	"guarantee.card.title": "Scheda di garanzia - Richiesta di garanzia",
	"guarantee.cattle": "Bestiame",
	"guarantee.certificate.issued": "Certificato emesso",
	"guarantee.certificate.request": "Richiedi certificato",
	"guarantee.certificate.request.confirmation": "Confermi di voler richiedere il certificato per questa richiesta di garanzia",
	"guarantee.certificate.request.failed": "Si è verificato un errore imprevisto durante il processo. Riprova più tardi.",
	"guarantee.certificate.request.success": "La richiesta del certificato è stata inviata con successo.",
	"guarantee.certificate.request.unavailable": "Questa garanzia non è più disponibile per la richiesta di un certificato.",
	"guarantee.certificate.requested": "Certificato richiesto",
	"guarantee.characteristics": "Caratteristiche del progetto",
	"guarantee.chimney": "Canna fumaria",
	"guarantee.choose.applicationtype": "Scegliere il tipo di garanzia da richiedere",
	"guarantee.cladding": "Rivestimento",
	"guarantee.cladding.double.skin": "Doppio rivestimento",
	"guarantee.cladding.single.skin": "Singolo rivestimento",
	"guarantee.cladding.specify.material.type": "Nel rivestimento (specificare il tipo di materiale e la superficie coperta)",
	"guarantee.client.project.name": "Nome progetto",
	"guarantee.coastal.marine": "In ambiente costiero o marino",
	"guarantee.cold.structure": "Elementi strutturali modellati a freddo di edifici (travi, guide, …)",
	"guarantee.composite.floor": "Pavimento composito",
	"guarantee.concrete.foundations": "Cemento per fondamenta",
	"guarantee.condensation.rink": "All'interno dell'edificio esiste il rischio di condensa?",
	"guarantee.condition.material": "Stato del materiale da sostituire",
	"guarantee.construction.new.building": "Completare la costruzione di un nuovo edificio",
	"guarantee.construction.site": "Sito di costruzione",
	"guarantee.construction.site.mandatory": "La posizione GPS (Latitudine e Longitudine) è obbligatoria",
	"guarantee.contact": "(ad es. acciaio galvanizzato a caldo in continuo, acciaio galvanizzato in lotti, legno, ecc.)",
	"guarantee.contact.orther.parts": "Quali altri materiali saranno usati con i componenti rivestiti in Magnelis®? Specificare, se applicabile!",
	"guarantee.contact.parts": "Quali rivestimenti saranno usati per i componenti a contatto con i componenti rivestiti con Magnelis®? Specificare, se applicabile!",
	"guarantee.coordinates.decimal": "Coordinate in gradi decimali",
	"guarantee.coordinates.dms": "Coordinate in gradi, minuti e secondi",
	"guarantee.coordinates.pair.mandatory": "Inserire sia la Latitudine sia la Longitudine",
	"guarantee.corporate.name.mandatory": "Il campo Cliente è obbligatorio",
	"guarantee.current.status": "Stato attuale",
	"guarantee.customer.information": "Informazioni sul cliente",
	"guarantee.customer.name": "Cliente",
	"guarantee.customer.rejected": "Respinto dal cliente",
	"guarantee.desert": "Nel deserto",
	"guarantee.designation": "Designazione",
	"guarantee.direction.of.cladding.installation": "Direzione di installazione del rivestimento",
	"guarantee.distance.3KM.seafront": "Se la distanza è inferiore a 3km dalla costa, specificare la distanza",
	"guarantee.distance.lake": "Distanza da lago o fiume (km)",
	"guarantee.distance.less than 300m": "Situato a meno di 300m dalla costa",
	"guarantee.distance.seafront": "Se la distanza è inferiore a 10km dalla costa, specificare la distanza",
	"guarantee.distance.seafrontkm": "Distanza dalla costa (km)",
	"guarantee.distance.site": "Distanza dal sito (km)",
	"guarantee.documents": "Documenti di garanzia",
	"guarantee.documents.title": "Documenti",
	"guarantee.double.skin.roof": "Tetto a doppio rivestimento",
	"guarantee.draft": "Bozza",
	"guarantee.draft.edit": "Può modificarlo nella bozza di follow-up.",
	"guarantee.draft.saved.successfully": "La bozza è stata salvata",
	"guarantee.duckboard": "Attraverso grigliato di cemento/passerella in legno",
	"guarantee.duration.year": "{{value}} anno",
	"guarantee.duration.years": "{{value}} anni",
	"guarantee.duration.years.indoor": "Durata prevista garanzia interna (in anni)",
	"guarantee.duration.years.outdoor": "Durata prevista garanzia esterna (in anni)",
	"guarantee.emission.type": "Tipo di emissioni",
	"guarantee.epassivation.type": "Tipo di e-passivation",
	"guarantee.epc": "Ingegneria, approvvigionamento e costruzione (EPC)",
	"guarantee.epc.company.name": "Nome azienda",
	"guarantee.equipment": "Quali dispositivi sono disponibili per lo scarico di fumo, esalazioni, vapore e umidità?",
	"guarantee.extension.existing.building": "Estensione fino a un edificio preesistente",
	"guarantee.extension.solar.plant": "Estensione fino a un impianto fotovoltaico preesistente",
	"guarantee.extractor": "Estrattore",
	"guarantee.fabrication": "Processo di fabbricazione",
	"guarantee.fastners": "Materiali per elementi di fissaggio",
	"guarantee.fertilizer": "Stoccaggio del fertilizzante",
	"guarantee.floating.solar.installation": "Installazione solare galleggiante",
	"guarantee.floating.solar.magnelis": "Garanzia per gli impianti solari galleggianti con Magnelis®",
	"guarantee.fodder": "Stoccaggio dei foraggi",
	"guarantee.forced": "ventilazione forzata",
	"guarantee.forced.ventilation": "Ventilazione forzata",
	"guarantee.gas.building": "È presente gas o vapore rilasciato all'interno dell'edificio?",
	"guarantee.gratings": "Sulle inferriate",
	"guarantee.ground.mounted": "Montato sul terreno / impianto fotovoltaico utility scale",
	"guarantee.heating.type": "Tipo di riscaldamento",
	"guarantee.horizontal.rails": "Guide orizzontali barriere antiurto",
	"guarantee.humidity.high": "Alto",
	"guarantee.humidity.low": "Basso",
	"guarantee.humidity.medium": "Medio",
	"guarantee.humidity.rate.inside.building": "Tasso di umidità all'interno dell'edificio",
	"guarantee.humidity.saturated": "Saturo",
	"guarantee.humidity.specify": "Specificare il tasso di umidità",
	"guarantee.humidity.very.high": "Molto alto",
	"guarantee.hydrogen.sulphide": "specificare la concentrazione di idrogeno solforato all'interno (in ppm)",
	"guarantee.industrial": "Industriale",
	"guarantee.industrial.questions": "Domanda per edifici industriali",
	"guarantee.industry.type": "Tipo di settore",
	"guarantee.inside-building.activity": "Please specify the activity inside the building",
	"guarantee.installation.direction.horizontal": "Orizzontale",
	"guarantee.installation.direction.vertical": "Verticale",
	"guarantee.last.modified.date": "Ultimo aggiornamento",
	"guarantee.lat.degree": "Gradi (0-89)",
	"guarantee.lat.degrees": "Lat gradi",
	"guarantee.lat.max": "Latitudine (da -90 a 90)",
	"guarantee.lat.minutes": "Lat minuti",
	"guarantee.lat.seconds": "Lat secondi",
	"guarantee.latitude": "Latitudine",
	"guarantee.latlong.degree.pattern": "Le cifre decimali massime sono fino a 6",
	"guarantee.latlongmin.max": "Minuti (0-59)",
	"guarantee.latlongsec.max": "Secondi (0-59.9999)",
	"guarantee.latlongsec.pattern": "Le cifre decimali massime sono fino a 4",
	"guarantee.launch.analysis": "Lancia analisi",
	"guarantee.long.degrees": "Gradi long",
	"guarantee.long.max": "Longitudine (da -180 a 180)",
	"guarantee.long.minutes": "Minuti long",
	"guarantee.long.seconds": "Secondi long",
	"guarantee.longdegress.max": "Gradi (0-179)",
	"guarantee.longitude": "Longitudine",
	"guarantee.magnelis": "Massa di rivestimento Magnelis®",
	"guarantee.magnelis.other": "Altro",
	"guarantee.magnelis.poles": "Massa di rivestimento Magnelis® per pali",
	"guarantee.magnelis.upper.structure": "Massa di rivestimento Magnelis® per struttura superiore",
	"guarantee.magnelis.zm310": "Magnelis® ZM310 con rivestimento metallico da 310 g/m² su entrambi i lati",
	"guarantee.magnelis.zm430": "Magnelis® ZM430 con rivestimento metallico da 430 g/m² su entrambi i lati",
	"guarantee.magnelis.zm620": "Magnelis® ZM620 con rivestimento metallico da 620 g/m² su entrambi i lati",
	"guarantee.magnelis.zm800": "Magnelis® ZM800 con rivestimento metallico da 800 g/m² su entrambi i lati",
	"guarantee.magnelisbuilding.long": "Magnelis® per applicazioni edili",
	"guarantee.magnelisbuilding.short": "Edificio Magnelis®",
	"guarantee.magnelisothers.long": "Magnelis® per altre applicazioni",
	"guarantee.magnelisothers.short": "Magnelis® Altro",
	"guarantee.magnelissolar.long": "Magnelis® per applicazione fotovoltaico",
	"guarantee.magnelissolar.short": "Magnelis® fotovoltaico",
	"guarantee.manure.management": "Gestione letame per strutture con animali",
	"guarantee.mineral.wool.insulation": "Lana minerale",
	"guarantee.mounting.system.producer": "Produttore sistema di montaggio",
	"guarantee.msp.company.name": "Nome azienda",
	"guarantee.name.copy": "Copia",
	"guarantee.name.unique.error": "Si è verificato un errore imprevisto durante il processo ({{errordetails}})",
	"guarantee.name.unique.reason.duplicate": "unicità del nome",
	"guarantee.name.unique.reason.network": "impossibile raggiungere il server",
	"guarantee.natural.ventilation": "Ventilazione naturale",
	"guarantee.nature.content": "Natura e contenuto e dell'ambiente interno",
	"guarantee.nature.material": "Natura del materiale da sostituire",
	"guarantee.new.solar.plant": "Costruzione completa di un nuovo impianto fotovoltaico",
	"guarantee.no.duckboard": "Nessuna passerella in legno",
	"guarantee.no.parts.magnelis": "Nessun componente con rivestimento Magnelis®",
	"guarantee.notypes.available": "Tipo di garanzia non disponibile",
	"guarantee.open.building": "Edificio aperto",
	"guarantee.open.building.specify": "Specificare",
	"guarantee.organiccoating.long": "Acciai con rivestimento organico per applicazioni edili",
	"guarantee.other": "Altre applicazioni",
	"guarantee.other.application": "Indicare l'applicazione",
	"guarantee.other.building": "Altro (ad es. ufficio, salute, hotel, sport e tempo libero, parcheggio, ecc.)",
	"guarantee.other.coatings": "Acciaio rivestito con altri materiali",
	"guarantee.other.materials": "Altri materiali usati a contatto diretto con Magnelis®",
	"guarantee.other.materials.used": "Altri materiali utilizzati",
	"guarantee.others.animals": "Altri",
	"guarantee.others.please.specify": "Specificare:",
	"guarantee.part.corrosion": "Tipo di corrosione",
	"guarantee.part.magnelis": "Massa di rivestimento Magnelis® (g/m2)",
	"guarantee.parts.magnelis": "Componenti con rivestimento Magnelis®",
	"guarantee.pdf.page": "Pagina",
	"guarantee.per.app": "In quale applicazione sarà usata la lamiera perforata?",
	"guarantee.per.rich": "Indicare lo schema di perforazione",
	"guarantee.perforated.sheet": "Lamiera perforata",
	"guarantee.pigs": "Suini",
	"guarantee.pir.insulation": "PIR",
	"guarantee.planned.operations": "Operazione/i programmata/e",
	"guarantee.poles.magnelis": "Garanzia per pali fabbricati con progetti Magnelis® con pali nel terreno",
	"guarantee.poles.soil": "Progetti con pali nel terreno",
	"guarantee.power.generation": "Generazione di potenza",
	"guarantee.presence.animals": "Presenza di animali nell'edificio",
	"guarantee.prevailing.wind": "Il gas o il fumo o gli scarichi polverosi vengono trasportati dai venti prevalenti?",
	"guarantee.project.characteristics": "Caratteristiche del progetto",
	"guarantee.project.environment": "Ambiente di progetto",
	"guarantee.project.for.floating.solar": "Progetto per solare galleggiante",
	"guarantee.project.location": "Ubicazione progetto",
	"guarantee.project.name": "Nome progetto",
	"guarantee.project.name.mandatory": "Il nome progetto è obbligatorio",
	"guarantee.project.size": "Dimensioni progetto",
	"guarantee.project.type": "Tipo progetto",
	"guarantee.proposal.ongoing": "Proposta in corso",
	"guarantee.proposals": "Proposta e documenti aggiuntivi",
	"guarantee.proximity.buildings": "In prossimità di uno o più edifici che ospitano animali per lo stoccaggio di prodotti della fermentazione",
	"guarantee.pu.insulation": "PU",
	"guarantee.purpose.building": "Specificare la destinazione d'uso dell'edificio",
	"guarantee.questions": "Domande per edifici industriali e agricoli",
	"guarantee.radio.na": "NA",
	"guarantee.radio.no": "No",
	"guarantee.radio.yes": "Sì",
	"guarantee.rainwater.systems": "Sistemi acqua piovana / Grondaia",
	"guarantee.reason": "Motivo",
	"guarantee.refineries.factories": "Comprendenti per lo più raffinerie, fabbriche di incenerimento, centrali termoelettriche a carbone o a petrolio, industrie della distilleria, opere in cemento, impianti di lavorazione carta, impianti chimici, ecc.",
	"guarantee.register": "Prodotto - richiesta certificato di garanzia",
	"guarantee.register.magnelisbuilding": "Prodotto - richiesta certificato di garanzia -  Magnelis® per applicazioni edili",
	"guarantee.register.magnelisothers": "Richiesta certificato di garanzia prodotto  -  Magnelis® per altre applicazioni",
	"guarantee.register.magnelissolar": "Prodotto - richiesta certificato di garanzia - Magnelis® per applicazione su fotovoltaico",
	"guarantee.relative.humidity": "Specificare l'umidità relativa",
	"guarantee.remarks": "Specificare eventuali altre note o dettagli del progetto:",
	"guarantee.request.author": "Autore",
	"guarantee.request.certificate.id": "Certificato",
	"guarantee.request.date": "Data",
	"guarantee.request.drafts": "Richiesta di garanzia - elenco delle bozze",
	"guarantee.request.duplicate": "Duplicato",
	"guarantee.request.followup": "Potrà vederlo nelle sue \"Le mie richieste di garanzia\".",
	"guarantee.request.id": "ID della garanzia",
	"guarantee.request.list": "Le mie richieste di garanzia",
	"guarantee.request.requested.date": "Data richiesta",
	"guarantee.request.submitted.successfully": "La sua richiesta di garanzia è stata inviata con successo",
	"guarantee.request.type": "Tipo",
	"guarantee.requested": "Garanzia richiesta",
	"guarantee.requested.type.indoor": "Interni",
	"guarantee.requested.type.indoor.label": "Garanzia per interni richiesta",
	"guarantee.requested.type.outdoor": "Esterni",
	"guarantee.requested.type.outdoor.label": "Garanzia per esterni richiesta",
	"guarantee.residential": "Per uso residenziale",
	"guarantee.retrofitting.existing.building": "Retrofitting/Riparazione di un edificio preesistente",
	"guarantee.retrofitting.solar.plant": "Retrofitting/Riparazione di un impianto fotovoltaico preesistente",
	"guarantee.road.restraint": "Barriere stradali",
	"guarantee.roofing": "Tetti",
	"guarantee.roofing-cladding.anti-condensation.felt": "Feltro anticondensa",
	"guarantee.roofing-cladding.color": "Colore",
	"guarantee.roofing-cladding.desired.back.coat": "Rivestimento posteriore desiderato",
	"guarantee.roofing-cladding.desired.coating": "Rivestimento desiderato",
	"guarantee.roofing-cladding.external.skin": "Rivestimento esterno",
	"guarantee.roofing-cladding.insulation": "Isolamento",
	"guarantee.roofing-cladding.internal.skin": "Rivestimento interno",
	"guarantee.roofing-cladding.made.with.product": "Coperture e/o rivestimenti realizzati interamente con il prodotto",
	"guarantee.roofing-cladding.metallic.coating.weight": "Peso del rivestimento metallico",
	"guarantee.roofing-cladding.overlapping": "Sovrapposizione",
	"guarantee.roofing-cladding.perforation": "Perforazione",
	"guarantee.roofing-cladding.pv.solar.roof": "Tetto fotovoltaico/solare",
	"guarantee.roofing-cladding.substrate.thickness": "Spessore del substrato",
	"guarantee.roofing-cladding.surface": "Superficie",
	"guarantee.roofing.decking.roof": "Calpestio del tetto",
	"guarantee.roofing.roofslope": "Pendenza del tetto (%)",
	"guarantee.roofing.specify.material.type": "Nella costruzione del tetto (specificare il tipo di materiale e la superficie coperta)",
	"guarantee.rooftop.installation": "Installazione su tetto",
	"guarantee.rrs.miscellaneous": "Componenti miste di sistemi di restrizione stradale, soggetti a corrosione atmosferica",
	"guarantee.rrs.poles": "Pali per barriere stradali",
	"guarantee.rrs.welded": "I componenti che saranno fabbricati con Magnelis® sono saldati?",
	"guarantee.rural.area": "In un'area rurale a oltre 10 km dalla costa",
	"guarantee.rural.area.20KM": "In un'area rurale a oltre 20 km dalla costa",
	"guarantee.sandwich.panel": "Pannelli sandwich o sistema componibile",
	"guarantee.satisfied": "Soddisfatto",
	"guarantee.save.failed": "Invio garanzia fallito.",
	"guarantee.save.failed.message": "Riprovare più tardi oppure contattare ebusiness.support@arcelormittal.com",
	"guarantee.service.requests": "Le mie richieste di garanzia",
	"guarantee.sheet.thickness": "Spessore lamiera (mm)",
	"guarantee.silo": "Silo",
	"guarantee.silo.cylinder": "Cilindro del silo",
	"guarantee.silo.liner": "Il silo avrà una camicia?",
	"guarantee.silo.parts": "Quali componenti del silo saranno fabbricati con Magnelis®",
	"guarantee.silo.products": "Quali prodotti saranno stoccati nel silo?",
	"guarantee.silo.roof": "Tetto del silo",
	"guarantee.silo.soil": "Base del silo, in contatto con il terreno o con il calcestruzzo",
	"guarantee.single.skin.roof": "Tetto a rivestimento singolo",
	"guarantee.soil.analysis": "È disponibile un'analisi completa del terreno?",
	"guarantee.soil.document": "Se sì, allegare il documento di analisi del terreno:",
	"guarantee.soil.information": "L'analisi del terreno deve contenere almeno le seguenti informazioni: granulometria, valore pH, tenore umidità, tenore di cloruro, tenore di solfato, resistività, presenza di falde acquifere. Sarà utile qualunque altra informazione sul terreno in conformità don DIN 50929-3:2018.",
	"guarantee.soil.requirements.title": "Requisiti dell'analisi del suolo",
	"guarantee.specific.environment": "In un ambiente specifico (combinazione tra esposizione di cui sopra e alcuni effetti aggiuntivi, alta temperatura, alta igrometria, depositi di polvere significativi, ecc.)",
	"guarantee.specify": "Specificare:",
	"guarantee.specify.perforation.scheme": "Specificare lo schema di perforazione",
	"guarantee.stainless.steel": "Acciaio inossidabile",
	"guarantee.steel.parts": "Acciaio inossidabile per componenti",
	"guarantee.storage.chemicals": "Presenza e/o uso e/o stoccaggio di prodotti chimici",
	"guarantee.storage.fermentation": "Presenza e/o stoccaggio di prodotti della fermentazione",
	"guarantee.structure": "La struttura è interamente fabbricata con Magnelis®",
	"guarantee.suggested.coating.mass": "Massa di rivestimento da suggerire da parte di ArcelorMittal sulla base della durata di garanzia attesa",
	"guarantee.summary": "Riepilogo",
	"guarantee.supplier.rejected": "Respinto dal fornitore",
	"guarantee.surface.building": "Per applicazioni su edifici: superficie (m²):",
	"guarantee.tonnage.magnelis": "Tonnellaggio di acciaio inossidabile Magnelis®",
	"guarantee.type": "TIpo di garanzia",
	"guarantee.type.application": "Tipo di applicazione",
	"guarantee.type.of.installation": "Tipo di installazione",
	"guarantee.types.of.guarantee": "Tipi di garanzia",
	"guarantee.unknown": "Unknown",
	"guarantee.upper.structure": "Garanzia per la struttura superiore fabbricata con Magnelis®",
	"guarantee.urban.agglomeration": "In un agglomerato urbano e/o in un ambiente industriale",
	"guarantee.use.of.other.materials": "Uso di altri materiali, in particolare cemento, blocchi di cemento",
	"guarantee.ventilation.roof": "ventilazione naturale attraverso le tende da tetto",
	"guarantee.ventilation.walls": "ventilazione naturale attraverso tende da parete",
	"guarantee.wall.facade": "Muro / Facciata",
	"guarantee.water.analysis": "È disponibile un'analisi dell'acqua?",
	"guarantee.water.document": "Si prega di inviare l'analisi dell'acqua insieme alla richiesta di garanzia.",
	"guarantee.water.information": "L'analisi dell'acqua deve contenere almeno le seguenti informazioni: Contenuto di cloruri, contenuto di solfati, contenuto di calcio, contenuto di magnesio, alcalinità Ks4,3, valore del pH, struttura/potenziale idrico UH, conducibilità. Qualsiasi altra informazione sull'acqua, conforme alla norma DIN 50929-3:2018, sarà utile.",
	"guarantee.water.requirements.title": "Requisiti dell'analisi dell'acqua",
	"guarantee.with.partial.momentary.wetting": "Soggetto a contatto parziale o temporaneo con acqua marina e/o azione diretta degli aerosol marini",
	"guarantee.without.direct.wetting": "Senza contatto diretto con acqua marina e/o azione diretta degli aerosol marini",
	"guarantee.without.gratings": "Senza inferriata",
	"guarantee.zinc": "Acciaio zincato",
	"gurantee.duration.years": "Durata prevista garanzia (in anni)",
	"gurantee.other.coating.mass": "Altra massa per rivestimenti",
	"help.data.documents": "Documenti",
	"help.documents": "Documenti di guida",
	"highest.stocks.widget.title": "Le prime 5 stock",
	"home.batch-list": "I miei lotti",
	"home.customer.feedback": "Feedback cliente",
	"home.dashboard": "Pannello di controllo",
	"home.deliveryschedule": "Programmazione consegna",
	"home.diplay.last.batches": "Visualizza gli ultimi 20 batch consultati",
	"home.identify.batch": "Identifica un batch",
	"home.last.seen.batch": "Ultimi batch visti",
	"home.no.service": "Il tuo profilo non può gestire alcun servizio. Contatta il tuo Relè SteelUser per accedere senza limiti al servizio Quality App",
	"home.no.service.alert": "Nessun servizio",
	"home.order-tracking.commercial-documents": "I miei documenti commerciali",
	"home.order-tracking.my-schedule-business-order": "Il mio ordine aziendale",
	"home.order-tracking.orders": "I miei ordini",
	"home.ordertracking": "Tracciamento ordine",
	"home.quality-issues.issues": "I miei problemi di qualità",
	"import.data": "Import data",
	"import.excel": "Import excel",
	"import.file.message": "Upload an XLS file to import data from existing file. Please follow the template in order to allow automatic detection.",
	"import.file.message.all.fields.mandatory": "All the fields are mandatory.",
	"incoterm.22": "CFR landed duty unpaid",
	"incoterm.23": "CFR liner terms duty unpaid",
	"incoterm.24": "CFR free out duty unpaid",
	"incoterm.25": "CIF landed duty unpaid",
	"incoterm.26": "CIF LINER TERMS DUTY UNPAID",
	"incoterm.27": "CIF FREE OUT",
	"incoterm.28": "CFR sotto Gru",
	"incoterm.33": "CFR FO Quick custom desp",
	"incoterm.CFR": "CFR (Cost and Freight)",
	"incoterm.CIF": "CIF (Cost, Insurance, Freight)",
	"incoterm.CIP": "CIP (Carriage and insurance paid to)",
	"incoterm.CPT": "CPT (Carriage paid to)",
	"incoterm.DAF": "Delivered at frontier",
	"incoterm.DAT": "DPU (Delivered at Place Unloaded)",
	"incoterm.DDP": "DDP (Delivered duty paid)",
	"incoterm.DDU": "Delivered duty unpaid",
	"incoterm.DEQ": "Carriage paid to quay",
	"incoterm.DES": "Delivered ex ship",
	"incoterm.FAS": "FAS (Free alongside ship)",
	"incoterm.MAD": "Reso disponibile in fabbrica",
	"incoterm.RC": "Compreso il trasporto presso la sede del cliente",
	"incoterm.dap": "DAP (Delivered at place)",
	"incoterm.exw": "Ex works",
	"incoterm.fca": "FCA (Free carrier)",
	"incoterm.fob": "FOB (Free on board)",
	"inner.greater.than.outer.error": "Campo maggiore del Ø esterno.",
	"internal.placeholder.choose.customer": "Inserisci il nominativo cliente",
	"issue.acceptedquantity": "Quantità accettata",
	"issue.acceptedquantity.value": "Quantità accettata (valore)",
	"issue.action.data.center": "Centro elaborazione dei dati",
	"issue.action.filters": "Filtri",
	"issue.attach.documents": "Aggiungi allegato",
	"issue.batch.cdd": "CDD",
	"issue.batch.commercial.documents": "Documenti commerciali",
	"issue.batch.customer.order.number": "Numero d’ordine cliente",
	"issue.batch.dimension": "Dimensioni (mm)",
	"issue.batch.invoiced": "Invoiced",
	"issue.batch.no.result": "Nessun risultato",
	"issue.batch.number": "Numero del lotto",
	"issue.batch.quick.search": "Ricerca rapida",
	"issue.batch.status": "Status",
	"issue.batch.steelgrade": "Grado di acciaio",
	"issue.batch.view-details": "Mostra dettagli",
	"issue.batchesassociated": "Lotti associati con questo problema",
	"issue.calimed.quantity": "Quantità reclamata",
	"issue.calimed.quantity.value": "Quantità reclamata (valore)",
	"issue.cancel": "Your claim has been cancelled successfully",
	"issue.claim": "Reclamo",
	"issue.closingdate": "Data di chiusura",
	"issue.contact.info": "Informazioni di contatto",
	"issue.contact.label": "Voglio essere contattato da un contatto ArcelorMittal.",
	"issue.contact.type": "Tipo di contatto",
	"issue.creditnote": "Credit note",
	"issue.creditnotedate": "Data della nota di credito",
	"issue.currency": "Valuta",
	"issue.customer.defect": "Difetto cliente",
	"issue.customer.reference": "Riferimento problema qualità cliente",
	"issue.decision": "Decisione",
	"issue.defect.type": "Tipo di difetto",
	"issue.do.you.want.to.be.contacted": "Desidera essere contattato/a?",
	"issue.draft": "Bozza",
	"issue.draft.deleted": "La sua bozza è stata eliminata con successo.",
	"issue.drag.and.drop.files": "Trascina qui i file",
	"issue.filterbystatus": "Filtra per stato",
	"issue.followup.widget.title": "Feedback sulla qualità",
	"issue.inprocess": "In sospeso",
	"issue.invoiced.batch": "Invoiced batches only",
	"issue.issuecard": "Carta problema di qualità",
	"issue.issuedocuments": "Documenti",
	"issue.issueinformation": "Emissione informazioni",
	"issue.ok.value": "OK",
	"issue.origin": "Origine",
	"issue.origin.ach": "Sistema di inserimento reclami ArcelorMittal",
	"issue.origin.sta": "SteelUser",
	"issue.pending": "Pending",
	"issue.qualityfeedback": "Dashboard sulla qualità del prodotto - elenco dei problemi",
	"issue.qualityissues": "Problemi di qualità",
	"issue.qualityissues.drafts": "Problema di qualità - lista di bozze",
	"issue.register": "Registra un problema di qualità",
	"issue.requested.total.amount": "Importo totale richiesto",
	"issue.requested.total.amount.value": "Importo totale rihiesto (valore)",
	"issue.save.as.drafts": "Salva come bozza",
	"issue.select.batches.action.next": "Successivo",
	"issue.select.current.batch": "Il tuo lotto attualmente selezionato:",
	"issue.select.first.batch": "Seleziona il primo lotto per la registrazione del problema di qualità",
	"issue.select.other.batch": "Oppure seleziona un altro lotto",
	"issue.send.claim": "Invia",
	"issue.sending.sample": "Invio campioni",
	"issue.shipments": "Spedizioni",
	"issue.submit.quality.feedback": "Invia feedback sulla qualità",
	"issue.supplierdefect": "Difetto fornitore",
	"issue.supplierissuenumber": "Numero emissione Arcelor Mittal",
	"issue.total.amount.accepted": "importo totale accettato",
	"issue.total.amount.accepted.value": "Importo totale accettato (valore)",
	"issue.type.of.request": "Tipo di richiesta",
	"issue.unit": "Unità",
	"issue.widget.overviewofqi": "Descrizione dei problemi di qualità",
	"issue.widget.selector.feedbackselected": "è stato selezionato: Qualità e Feedback Follow-up",
	"issue.widget.selector.validateadvice": "Clicca su convalida per confermare la tua scelta",
	"label.calculation": "Esegui il calcolo",
	"label.coil.calculator": "Calcolatrice bobina",
	"last.guarantee.requests": "Ultime richieste di garanzia",
	"latitude.N": "N",
	"latitude.S": "S",
	"legal-document.needforsteel.sales.framework": "Quadro di vendita di ArcelorMittal Need4Steel®",
	"legal-documents.agree.to.sales.conditions": "Accetta il nostro",
	"legal-documents.and": "e",
	"legal-documents.confirm.cart.with.sales.conditions": "Quando conferma il carrello, accetti le nostre",
	"legal-documents.general.sales.conditions": "condizioni generali di vendita",
	"legal-documents.non.prime.sales.framework": "quadro di vendita seconde scelte",
	"legal.data.header": "Termini, condizioni and policies",
	"line.select.family.period": "Scegli un periodo da analizzare",
	"line.select.family.product": "Scegli una famiglia di prodotti da analizzare",
	"line.select.period.fiveyears": "5 anni",
	"line.select.period.oneyear": "1 anno",
	"line.select.period.sixmonths": "6 mesi",
	"line.select.period.threemonths": "3 mesi",
	"line.select.period.twoyear": "2 anni",
	"line.select.tab.layout": "Scegli il layout della tua scheda",
	"linked.soldto": "Cliente collegato",
	"loader.text": "Products are loading",
	"longitude.E": "E",
	"longitude.W": "W",
	"manage.services.add-services": "Aggiungi servizi",
	"manage.services.drag-and-drop-items-on-the-right": "Trascina gli elementi da destra per aggiungere un servizio.",
	"manual.data.customer": "Numero d'ordine del cliente",
	"manual.data.enter.reference": "Per favore, inserisci il riferimento di un ordine",
	"manual.data.not.found": "Nessun lotto trovato.",
	"manual.data.num": "Articolo",
	"manual.data.reference": "Riferimento",
	"manual.data.supplier": "Numero d'ordine del fornitore",
	"manual.data.supplier.or.customer": "Per favore, inserisci il numero d'ordine del fornitore o il numero d'ordine del cliente.",
	"materials.rts.widget.title": "Materiale pronto per la spedizione",
	"menu.closed.issues": "Problemi di qualità chiusi",
	"menu.declare.choose.customer": "Scegli un cliente",
	"menu.declare.order-tracking": "Tracciamento dell’ordine online",
	"menu.declare.order-tracking.deliveryschedule": "Tempi di consegna",
	"menu.declare.order-tracking.ordertracking": "Tracciamento dell’ordine",
	"menu.declare.quality.issue": "Dichiara un problema di qualità",
	"menu.drafts": "Bozze",
	"menu.logout": "DISCONNESSIONE",
	"menu.modify.quality.issue": "Modifica un problema di qualità",
	"menu.order-services": "Ordina servizi",
	"menu.pending.issues": "Problemi di qualità in sospeso",
	"menu.product-services": "Servizi di prodotto",
	"menu.profile": "Profilo",
	"menu.sales-services": "Servizi commerciali",
	"menu.settings": "Impostazioni",
	"menu.sign.in": "Accedi",
	"modification.error.message": "La tua modifica non verrà salvata",
	"n4steel.contact-add-attachment": "Add attachment",
	"n4steel.contact-attachment-help": "Drag and drop your files here",
	"n4steel.contact-mail": "Contact ArcelorMittal Need4Steel®",
	"n4steel.contact-mail-from": "From",
	"n4steel.contact-mail-invalid-email": "Invalid format of e-mail address",
	"n4steel.contact-mail-mill": "Mill",
	"n4steel.contact-mail-offer": "Related offer",
	"n4steel.contact-mail-prefill-data": "Data automatically sent with the mail",
	"n4steel.upload.file.size.error.message": "Max 10MB per file and max 3 files.",
	"navig.confirm": "Conferma",
	"need4steel-logistic-routes.errormsg": "Max coil weight or Packing not compatible due to selected delivery address.",
	"need4steel-logistic-routes.packaging.errormsg": "Packaging is not compatible with delivery address.",
	"need4steel-order.history.errormsg": "No historical order from your ArcelorMittal Need4Steel® orderbook is matching the current offer options",
	"need4steel-order.history.import": "Import",
	"need4steel-order.history.notfound": "No order found",
	"need4steel-order.history.subtitle": "Please select products to import",
	"need4steel-order.history.title": "Order History",
	"need4steel-product-details-tooltip.no-price-msg": "Dati sul prodotto non disponibili",
	"need4steel-product-details-tooltip.price-msg": "Visualizza i dati del prodotto",
	"need4steel-product-details.chemical-treatment": "Chemical Treatment",
	"need4steel-product-details.effectivedelivered": "€/t effective delivered",
	"need4steel-product-details.header-msg": "Dettagli del prodotto -",
	"need4steel-product-details.max-outside-Diameter": "Max Outside Diameter (mm)",
	"need4steel-product-details.min-coil-weight": "Min coil weight (t)",
	"need4steel-product-details.proposed-price": "Prezzo proposto",
	"need4steel-product-details.unrolledWelds": "Unrolled Welds",
	"need4steel-product-offers.additional-fields": "Campi aggiuntivi",
	"need4steel-product-section-details.min-coil-weight": "Min Coil Weight (t)",
	"need4steel-schedule.button": "Import from history",
	"need4steel-summary-details.effectivedelivered": "effective delivered",
	"need4steel.dialog.coil.weight": "Peso max bobina (t)",
	"need4steel.dialog.coil.weight.range": "da {{minValue}} a {{maxValue}} t",
	"need4steel.dialog.coil.weight.range.title": "Intervallo peso max bobina",
	"need4steel.dialog.max.coilweight.range.content": "Peso max bobina disponibile",
	"need4steel.dialog.max.specific.weight.range.content": "Peso specifico massimo disponibile",
	"need4steel.dialog.range.steelgrade": "Per grado",
	"need4steel.dialog.specific.weight.range": "da {{minValore}} a {{maxValore}} kg/mm",
	"need4steel.dialog.specific.weight.range.title": "Intervallo di peso specifico massimo",
	"need4steel.dialog.thickness.content": "Si prega di selezionare un SteelGrade",
	"need4steel.dialog.thickness.list.content": "se ovvio dover selezionare un valore",
	"need4steel.dialog.thickness.range.content": "Le dimensioni disponibili per lo spessore sono",
	"need4steel.dialog.thickness.range.title": "Intervallo spessore",
	"need4steel.dialog.width.content": "Inserisci un valore corretto per Spessore",
	"need4steel.dialog.width.list.content": "Si prega di selezionare un valore adeguato per Spessore",
	"need4steel.dialog.width.range.content": "Dimensioni disponibili per la larghezza",
	"need4steel.dialog.width.range.title": "Intervallo larghezza",
	"need4steel.dialog.width.range.title.content": "e spessore",
	"need4steel.offer.error.message": "Siamo spiacenti, si sono verificati alcuni errori durante l'accesso a questa offerta. Riprovi o invii un messaggio al suo contatto ArcelorMittal.",
	"need4steel.offer.finishingline": "Linea fine",
	"need4steel.offer.simulation.error.message": "Siamo spiacenti, si sono verificati degli errori. Riprova o invia un messaggio al tuo contatto ArcelorMittal.",
	"need4steel.offers.order.button": "Ordine",
	"need4steel.offers.title": "Offerte ArcelorMittal Need4Steel®",
	"need4steel.product.details.product.coilweight": "Peso max bobina (t)",
	"need4steel.product.details.specific.weight": "Peso specifico massimo (kg/mm)",
	"need4steel.product.thickness.tolerance": "Tolleranza spessore",
	"need4steel.soldto.shipto.error.message": "Siamo spiacenti, si è verificato un problema nelle impostazioni del servizio. La preghiamo di contattare l'amministratore di SteelUser.",
	"need4steel.submit.credit.limit.error.msg": "☹ ArcelorMittal Need4Steel® order request impossible: not sufficient credit limit available. Please contact us at need4steel@arcelormittal.com",
	"need4steel.submit.error.msg": "Qualcosa è andato storto, contattare l'amministratore SteelUser",
	"need4steel.submit.exchange.rate.mandatory.error.msg": "Il tasso di cambio è obbligatorio",
	"need4steel.submit.exchange.rate.refreshed.error.msg": "Il tasso di cambio è stato aggiornato durante il processo di ordine. Verificalo prima di inviare nuovamente l'ordine",
	"need4steel.submit.order.error.msg.title": "Errore durante la convalida dell'ordine",
	"need4steel.submit.order.success.msg.row1": "L'ordine è stato elaborato",
	"need4steel.submit.order.success.msg.row2": "Può seguire lo stato dell'ordine in",
	"need4steel.submit.order.success.msg.row2.link": "FOLLOW-UP ORDINE E CONSEGNA.",
	"need4steel.trademark": "®",
	"need4steel.wizard.coil.error": "Inserisci un valore valido inferiore o uguale a 1000.",
	"need4steel.wizard.estimated": "Stimato:",
	"need4steel.wizard.exchange-rate.rate": "Tasso di cambio",
	"need4steel.wizard.exchange-rate.reference-date": "Data di riferimento",
	"need4steel.wizard.header.Delivery-address": "L'indirizzo di consegna è obbligatorio",
	"need4steel.wizard.header.customer": "Il campo Cliente è obbligatorio",
	"need4steel.wizard.header.customer-order-number": "Numero d’ordine cliente",
	"need4steel.wizard.header.customer-order-number.error.invalid": "Numero d'ordine cliente non valido",
	"need4steel.wizard.header.customer-order-number.error.mandatory": "Il numero d'ordine cliente è obbligatorio",
	"need4steel.wizard.header.delivery.date": "Data di consegna",
	"need4steel.wizard.header.mill": "Acciaieria",
	"need4steel.wizard.header.shipto": "Indirizzo di consegna",
	"need4steel.wizard.header.soldto": "Cliente",
	"need4steel.wizard.header.transport-mode": "Modalità di trasporto",
	"need4steel.wizard.maxcoilweight.range.error": "Inserisci un peso massimo della bobina valido.",
	"need4steel.wizard.maxspecificweight.range.error": "Inserisci un peso specifico massimo valido",
	"need4steel.wizard.no.weight.option.error.message": "Problema nelle impostazioni del template: nessuna opzione di peso",
	"need4steel.wizard.product.coil.weight": "Peso max bobina (t)",
	"need4steel.wizard.product.max.specific.weight": "kg/mm peso specifico massimo",
	"need4steel.wizard.product.price.calculate.offline": "Assicuratevi di avere un accesso a internet per richiedere un prezzo",
	"need4steel.wizard.product.specific.weight": "Peso specifico massimo (kg/mm)",
	"need4steel.wizard.product.weight.type.label": "Selezione del tipo di peso",
	"need4steel.wizard.step.product.title": "Specifica prodotto",
	"need4steel.wizard.stepper.product.action.delete": "Elimina",
	"need4steel.wizard.stepper.product.action.duplicate": "Duplicato",
	"need4steel.wizard.stepper.product.action.reset": "Ripristina",
	"need4steel.wizard.stepper.product.add": "Aggiungi prodotto",
	"need4steel.wizard.stepper.product.coil": "# (bobina)",
	"need4steel.wizard.stepper.product.coilweight": "Peso max bobina (t)",
	"need4steel.wizard.stepper.product.itemnumber": "Numero articolo",
	"need4steel.wizard.stepper.product.steelgrade": "Grado di acciaio",
	"need4steel.wizard.stepper.product.thickness": "Spessore (mm)",
	"need4steel.wizard.stepper.product.total.weight": "Peso totale",
	"need4steel.wizard.stepper.product.width": "Larghezza (mm)",
	"need4steel.wizard.stepper.step.product.specification": "Specifiche di prodotto",
	"need4steel.wizard.stepper.step.summary": "Riepilogo",
	"need4steel.wizard.summary.confirm.to.order.button": "Conferma ordine",
	"need4steel.wizard.summary.proceed.order.button": "Procedere all'ordine",
	"need4steel.wizard.summary.product.coils": "N° di bobine",
	"need4steel.wizard.summary.product.dimension": "Dimensioni (mm)",
	"need4steel.wizard.summary.product.price": "Prezzo (€/t)",
	"need4steel.wizard.summary.product.selection": "Selezione prodotto",
	"need4steel.wizard.summary.product.total.weight": "Peso totale (t)",
	"need4steel.wizard.summary.terms.conditions.text": "Facendo clic su Procedere all'ordine si accettano i termini e le condizioni di ArcelorMittal Need4Steel®",
	"need4steel.wizard.thickness.range.error": "Inserisci uno spessore valido.",
	"need4steel.wizard.thickness.tolerance.field": "Tolleranza spessore",
	"need4steel.wizard.width.range.error": "Inserisci una larghezza valida.",
	"new.offer.request.message": "Conosce la quantità necessaria per ogni specifica degli articoli?",
	"news.detail": "Mostra dettagli",
	"news.last-news": "Ultime notizie",
	"news.news-list": "Elenco notizie",
	"news.view-all": "Guarda tutto",
	"no.data.error": "No data found in the feasibility sheet",
	"no.guarantee.documents": "Nessun documento di garanzia",
	"no.legal.documents": "Nessun documento trovato",
	"no.product.family": "Nessuna famiglia di prodotti trovata.",
	"no.result": "nessun risultato trovato",
	"notifications.daily": "Giornaliero",
	"notifications.immediatly": "Immediatamente",
	"notifications.management": "Gestione delle notifiche",
	"notifications.monthly": "Mensilmente",
	"notifications.weekly": "Settimanalmente",
	"number.of.items.in.order": "Troppi articoli da aggiungere a quest'ordine.",
	"number.of.items.infos.message": "Immettere il numero di copie di questo prodotto che si desidera come articolo in questo ordine",
	"number.of.items.label": "Numero di articoli",
	"number.of.items.limit.in.order": "Possiamo accettare soltanto 100 articoli in un ordine dato. Ricontrollare la selezione.",
	"offer-dashboard-card.accepted": "Accettato",
	"offer-dashboard-card.annually": "Annualmente",
	"offer-dashboard-card.monthly": "Mensilmente",
	"offer-dashboard-card.offered": "Offerto",
	"offer-dashboard-card.order": "Ordine",
	"offer-dashboard-card.other-period": "Altro periodo",
	"offer-dashboard-card.quarterly": "Trimestrale",
	"offer-dashboard-card.remaining-to-order": "Rimanente all'ordine",
	"offer-dashboard-card.requested": "Richiesto",
	"offer-dashboard-card.semesterly": "Semestrale",
	"offer-dashboard-card.view-details": "Mostra dettagli",
	"offer-period.from": "A partire dal",
	"offer-period.reset": "Ripristina",
	"offer-period.to": "Al",
	"offer.card.table.header.quantity": "Quantità (t)",
	"offer.current.total.tons": "t",
	"offer.dashboard.services": "I miei servizi",
	"offer.end.date": "Data fine",
	"offer.enduser.update.cart.warning": "Questo utente finale non è compatibile con alcuni prodotti selezionati. Verranno automaticamente rimossi dal carrello.",
	"offer.multiple.families": "Multiplo",
	"offer.new.request.title": "Nuova richiesta",
	"offer.product.disabled.tooltip": "ThisQuesto prodotto non è compatibile con l'indirizzo di consegna o l'utente finale correntemente selezionato",
	"offer.product.family": "Famiglia di prodotto",
	"offer.quantity.framework": "Scegli le quantità per famiglia, sulle quali vuoi ricevere un'offerta ",
	"offer.quantity.spot": "Scegli le quantità per articolo, su cui vuoi ricevere un'offerta ",
	"offer.shipto.update.cart.warning": "Questo indirizzo di consegna non è compatibile con alcuni prodotti selezionati. Verranno automaticamente rimossi dal carrello.",
	"offer.sub.family": "Sottofamiglia",
	"offer.template.disabled.tooltip": "ThisQuesto template non è compatibile con l'indirizzo di consegna o l'utente finale correntemente selezionato",
	"offer.transport.condition": "Condizioni di trasporto",
	"offer.type.no": "No",
	"offer.type.yes": "Sì",
	"offer.weight": "Peso",
	"offers.action.next": "Successivo",
	"offers.commercial.terms": "Condizioni commerciali",
	"offers.commitment.period": "Periodo di impegno",
	"offers.create.details.customer.offer-name": "Numero RFQ del cliente",
	"offers.create.details.customer.offer-name.error.mandatory": "Il numero di richiesta di offerta del cliente è obbligatorio",
	"offers.create.details.field.currency": "Scegli la tua valuta",
	"offers.create.details.field.offer-name": "Nome della richiesta di offerta",
	"offers.create.details.field.offer-name.error.mandatory": "Il nome della richiesta di offerta è obbligatorio",
	"offers.create.details.section.entities": "Entità",
	"offers.create.details.section.offer-period": "Termini dell'offerta e periodo di impegno",
	"offers.create.path.cart": "imposta la tua quantità",
	"offers.create.path.confirmation": "invia la tua richiesta di offerta",
	"offers.create.request.offer": "Richiedi un'offerta",
	"offers.create.section.offer-period": "Termini e periodo di impegno",
	"offers.product.list": "Elenco dei prodotti",
	"offers.proposals.price.nooffer": "Nessuna offerta disponibile",
	"offers.proposals.price.period": "Periodo correlato",
	"offers.proposals.price.title": "Ultime proposte di prezzo",
	"offers.request.info": "Informazioni sulla richiesta di offerta",
	"offers.soldTo.selection.text": "Selezionare il cliente corretto per questa richiesta di offerta, per iniziare a visualizzare l'elenco dei prodotti disponibili. Tutti gli articoli nel carrello devono essere relativi allo stesso cliente.",
	"offers.sqmeters": "Metri quadrati",
	"offers.wizard.stepper.customization": "Personalizzazione",
	"offers.wizard.stepper.request.and.selection": "Richiesta e selezione dell'offerta",
	"offers.wizard.stepper.step.offer-summary": "Riepilogo",
	"offers.wizard.stepper.step.quantity": "Quantità",
	"offline.alert": "Avviso",
	"ok.value": "OK",
	"order-card.batches-at-reshipper": "Al ritrasportatore",
	"order-card.batches-available": "Lotti - Disponibili",
	"order-card.batches-blocked": "Lotti - Giacenza bloccata",
	"order-card.batches-called": "Called",
	"order-card.batches-consignment-stock": "Merce in conto deposito",
	"order-card.batches-delivered": "Lotti - Consegnati",
	"order-card.batches-land-transit": "Trasporto via terra",
	"order-card.batches-on-vessel": "Sulla nave",
	"order-card.batches-overseas-transit": "Trasporto all'estero",
	"order-card.batches-ready-to-ship": "Pronto a spedire",
	"order-card.batches-transit-to-customer": "In transito verso il cliente",
	"order-card.commercial-documents": "Documenti commerciali",
	"order-card.data-not-found": "Order data not found",
	"order-card.document": "Documento",
	"order-card.due-to-technical-issue": "A causa di un problema tecnico, non siamo in grado di visualizzare questi dati.",
	"order-card.gross": "Lordo: {{value}}",
	"order-card.name": "Nome",
	"order-card.net": "Netto: {{value}}",
	"order-card.no-rows-to-show": "Nessuna riga da mostrare",
	"order-card.proforma": "Proforma",
	"order-card.type": "Tipo",
	"order-card.we-are-actively-working": "Stiamo lavorando attivamente per ripristinare il servizio.",
	"order-card.wip-quantity": "Quantità (t)",
	"order-card.work-in-progress": "In lavorazione",
	"order-item-status.completely-produced": "Totalmente prodotto",
	"order-tracking.card.batches-in-stock": "Lotti in magazzino",
	"order-tracking.card.callables-batches.days": "{{value}} giorni",
	"order-tracking.card.callables-batches.view-details": "Mostra dettagli",
	"order-tracking.card.delivery-date.cdd": "CDD",
	"order-tracking.card.delivery-date.first-batch": "1° LOTTO IN MAGAZZINO",
	"order-tracking.card.delivery-date.last-batch": "ULTIMO LOTTO IN MAGAZZINO",
	"order-tracking.card.delivery-date.rdd": "RDD",
	"order-tracking.card.delivery-date.view-details": "Mostra dettagli",
	"order-tracking.card.delivery-status": "Stato della consegna",
	"order-tracking.cdd": "CDD",
	"order-tracking.choice": "Scelta",
	"order-tracking.customerArticleReference": "Riferimento articolo cliente",
	"order-tracking.delivered": "Consegnato",
	"order-tracking.delivered-t": "Consegnato (t)",
	"order-tracking.dimension": "Dimensioni (mm)",
	"order-tracking.final.use": "Utilizzo finale",
	"order-tracking.form": "Modulo",
	"order-tracking.in.production": "In produzione",
	"order-tracking.in.production-t": "In produzione (t)",
	"order-tracking.in.stock": "In stock",
	"order-tracking.in.stock-t": "In giacenza (t)",
	"order-tracking.in.transit": "In transito",
	"order-tracking.in.transit-t": "In transito (t)",
	"order-tracking.list": "Elenco",
	"order-tracking.no.connection": "Il servizio di tracciamento dell’ordine online non è disponibile",
	"order-tracking.no.result": "Nessun risultato",
	"order-tracking.overview": "Riepilogo",
	"order-tracking.product": "Prodotto",
	"order-tracking.product.category": "Categoria prodotto",
	"order-tracking.product.description": "Descrizione prodotto",
	"order-tracking.running.orders": "Ordini in corso",
	"order-tracking.standard-steel-grade": "Qualità standard",
	"order-tracking.standard.steelgrade": "Grado di acciaio standard",
	"order-tracking.steelgrade": "Grado di acciaio",
	"order.avail-t": "Utilità (t)",
	"order.bill.to": "Fattura a",
	"order.book.only": "Solo registro ordini",
	"order.callable.gross.weight": "Callable gross weight",
	"order.called.gross.weight": "Called gross weight",
	"order.card": "Carta d'ordine",
	"order.card.all.documents": "Tutti i documenti di quest’ordine",
	"order.card.certificate.display.all": "Visualizza tutti i certificati",
	"order.card.dates": "Date",
	"order.card.detail.information": "Visualizza i dettagli dell’ordine",
	"order.card.dispatch.advice.display.all": "Visualizza tutti gli avvisi di evasione",
	"order.card.document.certificates": "Certificati",
	"order.card.document.date": "Data",
	"order.card.document.dispatch.advices": "Avvisi di spedizione",
	"order.card.document.display.batches": "Visualizza tutti i batch",
	"order.card.document.invoices": "Fatture",
	"order.card.document.number": "Numero documento",
	"order.card.document.order.acknowledgments": "Conferme d’ordine",
	"order.card.document.show": "Mostra documento",
	"order.card.document.type": "Tipo",
	"order.card.followup": "Monitoraggio ordine",
	"order.card.in-consignment": "In consegna",
	"order.card.in-consignment-t": "In consegna (t)",
	"order.card.information": "Informazioni sull’ordine",
	"order.card.invoice.display.all": "Visualizza tutte le fatture",
	"order.card.last.certificate": "Certificato più recente",
	"order.card.last.dispatch.advice": "Avvisi di evasione più recente",
	"order.card.last.documents": "Ultimi documenti",
	"order.card.last.invoice": "Fattura più recente",
	"order.card.last.order.acknowledgment": "Ultime conferme d’ordine",
	"order.card.order.acknowledgment.display.all": "Visualizza tutte le conferme d’ordine",
	"order.card.product": "Prodotto",
	"order.card.xcarb": "XCarb®",
	"order.cdd-week": "CDD (settimana)",
	"order.certificate": "Certificato",
	"order.chemical.passivation": "Chemical Passivation",
	"order.choice": "Scelta",
	"order.coating": "Rivestimento",
	"order.coating-side": "Lato rivestimento",
	"order.color-bottom-side": "Lato inferiore colorato",
	"order.color-top-side": "Lato superiore colorato",
	"order.color.category.bottom.side": "Color Category Bottom Side",
	"order.color.category.top.side": "Color Category Top Side",
	"order.confirmed.delivery.date": "Data di consegna confermata",
	"order.contract.number": "Numero di contratto",
	"order.creation.date": "Data di creazione",
	"order.customer": "Cliente",
	"order.customer-template-reference": "Riferimento modello cliente",
	"order.customer.article.reference": "Riferimento articolo cliente",
	"order.customer.order.number": "Numero d’ordine cliente",
	"order.daysInStock": "Numero di giorni in stock",
	"order.delivered-t": "Consegnato (t)",
	"order.delivery": "Consegna",
	"order.delivery.address": "Indirizzo di consegna",
	"order.delivery.mode": "Modalità di consegna",
	"order.dim-mm": "Dim (mm)",
	"order.easy-film-bottom": "Parte inferiore Easy-film",
	"order.easy-film-top": "Parte superiore Easy-film",
	"order.easy.film.bottom": "EasyFilm Bottom",
	"order.easy.film.top": "EasyFilm Top",
	"order.ebusiness.order.number": "Riferimento ordine commercio elettronico",
	"order.end.user": "Utente finale",
	"order.enduser": "Utente finale",
	"order.entry": "Inserimento ordini",
	"order.final-use": "Uso finale",
	"order.firm": "Fisso",
	"order.first.batch.available": "Primo batch disponibile",
	"order.first.batch.in.stock": "Primo lotto in giacenza",
	"order.form": "Modulo",
	"order.grade": "Qualità",
	"order.incoterm": "Incoterm",
	"order.incoterm2": "Incoterm2",
	"order.internal-diameter": "Diametro interno (mm)",
	"order.interpretation.delivery.date": "Data di consegna stimata",
	"order.item.reference.soldto.party": "Articolo venduto a terzi",
	"order.item.status": "Stato articolo dell'ordine",
	"order.last.batch.available": "Ultimo batch disponibile",
	"order.last.batch.in.stock": "Ultimo lotto in giacenza",
	"order.last.updated": "Ultimo aggiornamento",
	"order.maximum-outside-diameter": "Diametro esterno massimo (mm)",
	"order.mill": "Acciaieria",
	"order.mill.order.number": "Numero ordine acciaieria",
	"order.minimum-outside-diameter": "Diametro esterno minimo (mm)",
	"order.no-documents": "Nessun documento disponibile",
	"order.oil-reference": "Riferimento olio",
	"order.oil-side": "Lato olio",
	"order.oil.reference": "Oil Reference",
	"order.ord-t": "Ord (t)",
	"order.order-status": "Stato dell'ordine",
	"order.ordered": "Ordinato",
	"order.ordered-t": "Ordinato (t)",
	"order.orders": "Ordini",
	"order.packing": "Imballaggio",
	"order.paint.marking.for.sh": "Paint Marking",
	"order.pattern.for.sh": "Pattern",
	"order.place.delivery": "Luogo di consegna",
	"order.prevision.item": "Voce accantonamenti (specifiche ritardate)",
	"order.protection": "Protezione",
	"order.provisional": "Provvisorio",
	"order.provisional.item": "Articolo provvisorio / aziendale",
	"order.rdd": "Data di consegna richiesta",
	"order.reason": "Motivo dell’ordine",
	"order.responsible.order.manager": "Manager responsabile dell’ordine",
	"order.sales.quarter": "Trimestre di fatturazione",
	"order.service.level": "Livello di servizio",
	"order.service.request": "Richiesta di servizio",
	"order.ship.to": "Spedisci a",
	"order.sortby": "Ordinato in base a",
	"order.spangle": "Fioritura",
	"order.standard": "Standard",
	"order.status": "Stato dell’ordine",
	"order.steelgrade": "Grado di acciaio",
	"order.stock-alert": "Avviso giacenza",
	"order.sub.category": "Sub Category",
	"order.submit": "Invia",
	"order.supplier": "Fornitore",
	"order.supplier-rfq-number": "Supplier RFQ number",
	"order.supplier.order.number": "Numero d’ordine fornitore",
	"order.surface-aspect": "Aspetto superficiale",
	"order.thickness": "Spessore",
	"order.transport-mode": "Modalità di trasporto",
	"order.transport.mode": "Modalità di trasporto",
	"order.ultrasonic.testing": "Ultrasonic Testing",
	"order.width": "Larghezza",
	"order.wip": "In produzione",
	"order.wip-t": "WIP (t)",
	"order.wip.forecast.stock": "Ingresso in giacenza previsto",
	"order.wip.quantity": "Quantità",
	"order.woe.version": "Versione WOE",
	"order.z.test.certificat": "Z-test Certificat",
	"orderview.sort.cdd": "Cdd",
	"orderview.sort.order": "Ordine",
	"orderview.sort.product": "Prodotto",
	"organization-type.agency": "Agenzia",
	"organization-type.buyer": "Compratore",
	"organization-type.lab": "Laboratorio",
	"organization-type.selag": "Venditore Agenzia",
	"organization-type.seller": "Venditore",
	"organization-type.super-user": "Super User",
	"organization-users.one-admin": "One administrator should be selected",
	"organization-users.one-admin-only": "Only one administrator should be selected",
	"organization-users.roles-error": "An error occurred during the update of the user, changes are not saved",
	"organization-users.roles-saved": "Roles have been correctly updated",
	"organization.card.administrator.comment": "Responsabile attuale per questa organizzazione",
	"organization.card.administrator.email": "Email",
	"organization.card.administrator.name": "Nome",
	"organization.card.details": "Dettagli",
	"organization.card.details.administrator": "Amministratore",
	"organization.card.details.identity": "Identità",
	"organization.card.identity.address": "Indirizzo",
	"organization.card.identity.city": "Città",
	"organization.card.identity.country": "Paese",
	"organization.card.identity.country.AD": "Andorra",
	"organization.card.identity.country.AE": "Emirati Arabi Uniti",
	"organization.card.identity.country.AF": "Afghanistan",
	"organization.card.identity.country.AG": "Antigua/Barbuda",
	"organization.card.identity.country.AI": "Anguilla",
	"organization.card.identity.country.AL": "Albania",
	"organization.card.identity.country.AM": "Armenia",
	"organization.card.identity.country.AN": "Antille Olandesi",
	"organization.card.identity.country.AO": "Angola",
	"organization.card.identity.country.AQ": "Antartide",
	"organization.card.identity.country.AR": "Argentina",
	"organization.card.identity.country.AS": "Samoa",
	"organization.card.identity.country.AT": "Austria",
	"organization.card.identity.country.AU": "Australia",
	"organization.card.identity.country.AW": "Aruba",
	"organization.card.identity.country.AZ": "Azerbaijan",
	"organization.card.identity.country.BA": "Bosnia Erzegovina",
	"organization.card.identity.country.BB": "Barbados",
	"organization.card.identity.country.BD": "Bangladesh",
	"organization.card.identity.country.BE": "Belgio",
	"organization.card.identity.country.BF": "Burkina Faso",
	"organization.card.identity.country.BG": "Bulgaria",
	"organization.card.identity.country.BH": "Bahrein",
	"organization.card.identity.country.BI": "Burundi",
	"organization.card.identity.country.BJ": "Benin",
	"organization.card.identity.country.BM": "Bermuda",
	"organization.card.identity.country.BN": "Brunei",
	"organization.card.identity.country.BO": "Bolivia",
	"organization.card.identity.country.BR": "Brasile",
	"organization.card.identity.country.BS": "Bahamas",
	"organization.card.identity.country.BT": "Bhutan",
	"organization.card.identity.country.BU": "Birmania",
	"organization.card.identity.country.BV": "Isola Bouvet",
	"organization.card.identity.country.BW": "Botswana",
	"organization.card.identity.country.BY": "Bielorussia",
	"organization.card.identity.country.BZ": "Belize",
	"organization.card.identity.country.CA": "Canada",
	"organization.card.identity.country.CC": "Isole Cocos",
	"organization.card.identity.country.CD": "Repubblica democratica del Congo",
	"organization.card.identity.country.CF": "Repubblica Centrafricana",
	"organization.card.identity.country.CG": "Congo",
	"organization.card.identity.country.CH": "Svizzera",
	"organization.card.identity.country.CI": "Costa d'Avorio",
	"organization.card.identity.country.CK": "Isole Cook",
	"organization.card.identity.country.CL": "Cile",
	"organization.card.identity.country.CM": "Camerun",
	"organization.card.identity.country.CN": "Cina",
	"organization.card.identity.country.CO": "Colombia",
	"organization.card.identity.country.CR": "Costa Rica",
	"organization.card.identity.country.CS": "non usare (S/M) ",
	"organization.card.identity.country.CU": "Cuba",
	"organization.card.identity.country.CV": "Capo Verde",
	"organization.card.identity.country.CX": "Isola di Natale",
	"organization.card.identity.country.CY": "Cipro",
	"organization.card.identity.country.CZ": "Repubblica Ceca",
	"organization.card.identity.country.DE": "Germania",
	"organization.card.identity.country.DJ": "Gibuti",
	"organization.card.identity.country.DK": "Danimarca",
	"organization.card.identity.country.DM": "Dominica",
	"organization.card.identity.country.DO": "Repubblica Dominicana",
	"organization.card.identity.country.DZ": "Algeria",
	"organization.card.identity.country.EC": "Ecuador",
	"organization.card.identity.country.EE": "Estonia",
	"organization.card.identity.country.EG": "Egitto",
	"organization.card.identity.country.EH": "Sahara occidentale",
	"organization.card.identity.country.ER": "Eritrea",
	"organization.card.identity.country.ES": "Spagna",
	"organization.card.identity.country.ET": "Etiopia",
	"organization.card.identity.country.FI": "Finlandia",
	"organization.card.identity.country.FJ": "Repubblica di Figi",
	"organization.card.identity.country.FK": "Isole Falkland",
	"organization.card.identity.country.FM": "Micronesia",
	"organization.card.identity.country.FO": "Isole Faroe",
	"organization.card.identity.country.FR": "Francia",
	"organization.card.identity.country.GA": "Gabon",
	"organization.card.identity.country.GB": "Regno Unito",
	"organization.card.identity.country.GD": "Grenada",
	"organization.card.identity.country.GE": "Georgia",
	"organization.card.identity.country.GF": "Guyana francese",
	"organization.card.identity.country.GH": "Ghana",
	"organization.card.identity.country.GI": "Gibilterra",
	"organization.card.identity.country.GL": "Groenlandia",
	"organization.card.identity.country.GM": "Gambia",
	"organization.card.identity.country.GN": "Guinea",
	"organization.card.identity.country.GP": "Guadalupa",
	"organization.card.identity.country.GQ": "Guinea equatoriale",
	"organization.card.identity.country.GR": "Grecia",
	"organization.card.identity.country.GS": "S. Isole Sandwich Australi",
	"organization.card.identity.country.GT": "Guatemala",
	"organization.card.identity.country.GU": "Guami",
	"organization.card.identity.country.GW": "Guinea-Bissau",
	"organization.card.identity.country.GY": "Guyana",
	"organization.card.identity.country.HK": "Hong Kong",
	"organization.card.identity.country.HM": "Isole Heard e McDonald",
	"organization.card.identity.country.HN": "Honduras",
	"organization.card.identity.country.HR": "Croazia",
	"organization.card.identity.country.HT": "Haiti",
	"organization.card.identity.country.HU": "Ungheria",
	"organization.card.identity.country.ID": "Indonesia",
	"organization.card.identity.country.IE": "Irlanda",
	"organization.card.identity.country.IL": "Israele",
	"organization.card.identity.country.IN": "India",
	"organization.card.identity.country.IO": "Territorio britannico dell'Oceano Indiano",
	"organization.card.identity.country.IQ": "Iraq",
	"organization.card.identity.country.IR": "Iran",
	"organization.card.identity.country.IS": "Islanda",
	"organization.card.identity.country.IT": "Italia",
	"organization.card.identity.country.JM": "Giamaica",
	"organization.card.identity.country.JO": "Giordania",
	"organization.card.identity.country.JP": "Giappone",
	"organization.card.identity.country.KE": "Kenya",
	"organization.card.identity.country.KG": "Kirghizistan",
	"organization.card.identity.country.KH": "Cambogia",
	"organization.card.identity.country.KI": "Kiribati",
	"organization.card.identity.country.KM": "Comore",
	"organization.card.identity.country.KN": "Saint-Christophe",
	"organization.card.identity.country.KP": "Corea del Nord",
	"organization.card.identity.country.KR": "Corea del Sud",
	"organization.card.identity.country.KW": "Kuwait",
	"organization.card.identity.country.KY": "Isole Cayman",
	"organization.card.identity.country.KZ": "Kazakistan",
	"organization.card.identity.country.LA": "Laos",
	"organization.card.identity.country.LB": "Libano",
	"organization.card.identity.country.LC": "Santa Lucia",
	"organization.card.identity.country.LI": "Liechtenstein",
	"organization.card.identity.country.LK": "Sri Lanka",
	"organization.card.identity.country.LR": "Liberia",
	"organization.card.identity.country.LS": "Lesotho",
	"organization.card.identity.country.LT": "Lituania",
	"organization.card.identity.country.LU": "Lussemburgo",
	"organization.card.identity.country.LV": "Lettonia",
	"organization.card.identity.country.LY": "Libia",
	"organization.card.identity.country.MA": "Marocco",
	"organization.card.identity.country.MC": "Monaco",
	"organization.card.identity.country.MD": "Moldavia",
	"organization.card.identity.country.ME": "Montenegro",
	"organization.card.identity.country.MF": "Saint Martin",
	"organization.card.identity.country.MG": "Madagascar",
	"organization.card.identity.country.MH": "Isola Marshall",
	"organization.card.identity.country.MK": "Macedonia del Nord",
	"organization.card.identity.country.ML": "Mali",
	"organization.card.identity.country.MM": "Birmania",
	"organization.card.identity.country.MN": "Mongolia",
	"organization.card.identity.country.MO": "Macao",
	"organization.card.identity.country.MP": "Mariana del Nord",
	"organization.card.identity.country.MQ": "Martinica",
	"organization.card.identity.country.MR": "Mauritania",
	"organization.card.identity.country.MS": "Montserrat",
	"organization.card.identity.country.MT": "Malta",
	"organization.card.identity.country.MU": "Mauritius",
	"organization.card.identity.country.MV": "Maldive",
	"organization.card.identity.country.MW": "Malawi",
	"organization.card.identity.country.MX": "Messico",
	"organization.card.identity.country.MY": "Malaysia",
	"organization.card.identity.country.MZ": "Mozambico",
	"organization.card.identity.country.NA": "Namibia",
	"organization.card.identity.country.NC": "Nuova Caledonia",
	"organization.card.identity.country.NE": "Niger",
	"organization.card.identity.country.NF": "Isola Norfolk",
	"organization.card.identity.country.NG": "Nigeria",
	"organization.card.identity.country.NI": "Nicaragua",
	"organization.card.identity.country.NL": "Olanda",
	"organization.card.identity.country.NO": "Norvegia",
	"organization.card.identity.country.NP": "Nepal",
	"organization.card.identity.country.NR": "Nauru",
	"organization.card.identity.country.NU": "Niue",
	"organization.card.identity.country.NZ": "Nuova Zelanda",
	"organization.card.identity.country.O1": "Altro NON-CORE",
	"organization.card.identity.country.O2": "Altro TASIA",
	"organization.card.identity.country.O3": "Altro TAEX",
	"organization.card.identity.country.O4": "Altro TANY",
	"organization.card.identity.country.OM": "Oman",
	"organization.card.identity.country.OT": "Altri Paesi",
	"organization.card.identity.country.PA": "Panama",
	"organization.card.identity.country.PE": "Perù",
	"organization.card.identity.country.PF": "Polinesia Francese",
	"organization.card.identity.country.PG": "Papua Nuova Guinea",
	"organization.card.identity.country.PH": "Filippine",
	"organization.card.identity.country.PK": "Pakistan",
	"organization.card.identity.country.PL": "Polonia",
	"organization.card.identity.country.PM": "Saint-Pierre e Miquelon",
	"organization.card.identity.country.PN": "Isole Pitcairn",
	"organization.card.identity.country.PR": "Porto Rico",
	"organization.card.identity.country.PS": "Territorio della Palestina",
	"organization.card.identity.country.PT": "Portogallo",
	"organization.card.identity.country.PW": "Palau",
	"organization.card.identity.country.PY": "Paraguay",
	"organization.card.identity.country.QA": "Qatar",
	"organization.card.identity.country.RE": "Reunion",
	"organization.card.identity.country.RO": "Romania",
	"organization.card.identity.country.RS": "Serbia",
	"organization.card.identity.country.RU": "Federazione Russa",
	"organization.card.identity.country.RW": "Ruanda",
	"organization.card.identity.country.SA": "Arabia Saudita",
	"organization.card.identity.country.SB": "Isole Salomone",
	"organization.card.identity.country.SC": "Seychelles",
	"organization.card.identity.country.SD": "Sudan",
	"organization.card.identity.country.SE": "Svezia",
	"organization.card.identity.country.SG": "Singapore",
	"organization.card.identity.country.SH": "Sant'Elena",
	"organization.card.identity.country.SI": "Slovenia",
	"organization.card.identity.country.SJ": "Svalbard",
	"organization.card.identity.country.SK": "Slovacchia",
	"organization.card.identity.country.SL": "Sierra Leone",
	"organization.card.identity.country.SM": "San Marino",
	"organization.card.identity.country.SN": "Senegal",
	"organization.card.identity.country.SO": "Somalia",
	"organization.card.identity.country.SR": "Suriname",
	"organization.card.identity.country.ST": "S.Tome",
	"organization.card.identity.country.STL": "Apolide",
	"organization.card.identity.country.SV": "El Salvador",
	"organization.card.identity.country.SY": "Siria",
	"organization.card.identity.country.SZ": "Swaziland",
	"organization.card.identity.country.TC": "Turks e Caicos",
	"organization.card.identity.country.TD": "Chad",
	"organization.card.identity.country.TF": "Terre australi e antartiche francesi",
	"organization.card.identity.country.TG": "Togo",
	"organization.card.identity.country.TH": "Tailandia",
	"organization.card.identity.country.TJ": "Tadschikistan",
	"organization.card.identity.country.TK": "Isole Tokelau",
	"organization.card.identity.country.TL": "Timor Est",
	"organization.card.identity.country.TM": "Turkmenistan",
	"organization.card.identity.country.TN": "Tunisia",
	"organization.card.identity.country.TO": "Tonga",
	"organization.card.identity.country.TP": "Timor Est",
	"organization.card.identity.country.TR": "Turchia",
	"organization.card.identity.country.TT": "Trinidad",
	"organization.card.identity.country.TV": "Tuvalu",
	"organization.card.identity.country.TW": "Taiwan",
	"organization.card.identity.country.TZ": "Tanzania",
	"organization.card.identity.country.UA": "Ucraina",
	"organization.card.identity.country.UG": "Uganda",
	"organization.card.identity.country.UM": "Isole minori esterne degli Stati Uniti d'America",
	"organization.card.identity.country.US": "Stati Uniti d'America",
	"organization.card.identity.country.UY": "Uruguay",
	"organization.card.identity.country.UZ": "Uzbekistan",
	"organization.card.identity.country.VA": "Città del Vaticano",
	"organization.card.identity.country.VC": "St. Vincent",
	"organization.card.identity.country.VE": "Venezuela",
	"organization.card.identity.country.VG": "Isole Vergini Britanniche",
	"organization.card.identity.country.VI": "Isole Vergini Americane",
	"organization.card.identity.country.VN": "Vietnam",
	"organization.card.identity.country.VU": "Vanuatu",
	"organization.card.identity.country.WF": "Wallis",
	"organization.card.identity.country.WS": "Isole Samoa",
	"organization.card.identity.country.XK": "Kosovo",
	"organization.card.identity.country.YE": "Yemen",
	"organization.card.identity.country.YT": "Mayotte",
	"organization.card.identity.country.YU": "Jugoslavia",
	"organization.card.identity.country.ZA": "Sud Africa",
	"organization.card.identity.country.ZM": "Zambia",
	"organization.card.identity.country.ZR": "Zaire",
	"organization.card.identity.country.ZW": "Zimbabwe",
	"organization.card.identity.name": "Nome",
	"organization.card.identity.postCode": "Codice Postale",
	"organization.card.identity.state": "Nazione o Stato",
	"organization.card.identity.suppliers": "Fornitori",
	"organization.card.identity.vat": "Partita Iva",
	"organization.card.manage-transactional-visibilities": "Gestisci visibilità transazionali",
	"organization.card.organizationcard": "Carta organizzazione",
	"organization.card.services": "Servizi",
	"organization.card.services.no-data": "Non hai alcun servizio",
	"organization.card.services.tab.desc": "Descrizione",
	"organization.card.services.tab.name": "Nome",
	"organization.card.services.title": "Lista dei servizi",
	"organization.card.services.title.desc": "Elenco di tutti i servizi disponibili per questa organizzazione nel contesto del relativo fornitore",
	"organization.card.transactional-visibilities": "Visibilità transazionali",
	"organization.card.users": "Utenti",
	"organization.card.visibilities": "Visibilità",
	"organization.details-card.flow-chart": "Schma flusso",
	"organization.details-card.flow-chart.current-organization": "Organizzazione corrente",
	"organization.details-card.flow-chart.customer": "Cliente",
	"organization.details-card.flow-chart.desc": "Luogo di questa organizzazione ",
	"organization.details-card.flow-chart.supplier": "Fornitore",
	"organization.is-payer": "È pagatore",
	"organization.is-shipto": "È spedire a",
	"organization.is-soldto": "È venduto a",
	"organization.status.deactivated": "Disattivato",
	"organization.status.deleted": "Eliminato",
	"organization.user-accept": "Accetta",
	"organization.user-id": "Id",
	"organization.user-manage": "Gestisci",
	"organization.user-reject": "Rifiuta",
	"organization.user-status-in-organization": "Stato nell'organizzazione",
	"organization.users.list.desc": "Elenco di tutti gli utenti disponibili in questa organizzazione",
	"organizationrole.api": "API",
	"organizationrole.dsu": "Amministratore",
	"organizationrole.hlpdk": "Help Desk",
	"organizationrole.subscription": "Notification",
	"organizationrole.user": "Utente",
	"overview.survey-answer": "Rispondo",
	"overview.survey-no-answer": "No, grazie",
	"overview.survey.please": "Per favore",
	"overview.survey.questions": "rispondi a queste 3 domande dopo aver navigato i prodotti (tempo stimato 20 sec)",
	"overview.viewby": "Visto da",
	"product.added.to.cart": "i prodotti sono stati correttamente aggiunti al carrello",
	"product.card.new.specification": "Nuova specifica",
	"product.error": "unexpected error while trying to look for the product",
	"product.feasibility.not-feasible": "not feasible",
	"product.feasibility.ok": "OK",
	"product.feasibility.pending": "In sospeso",
	"product.feasibility.refused": "Rifiutato",
	"product.feasibility.technical-error": "Technical Error",
	"product.message.product.not.saved": "Impossibile salvare il prodotto",
	"product.message.template.product.not.saved": "Impossibile creare un nuovo prodotto",
	"product.most.used.values": "Valori più utilizzati",
	"product.no.original.value": "Nessun valore originario",
	"product.not.exist": "Questo prodotto non esiste",
	"product.original.value": "Valore originario",
	"product.other.values": "Altri valori esistenti",
	"product.pc.label.max": "Massimo",
	"product.pc.label.min": "Minimo",
	"product.pc.label.unit": "Unità",
	"product.product.submitted": "Prodotto inoltrato",
	"product.quality.dashboard": "Dashboard qualità del prodotto",
	"product.save.template.product": "Salva come nuova specifica",
	"product.save.template.product.and.add.to.cart": "Salva e aggiungi al carrello",
	"product.table.header.add": "Aggiungi",
	"product.table.header.view": "Visualizza",
	"product.template": "Modello prodotto",
	"product.template.isbeingsimulated": "Convalida della nuova specifica in corso...",
	"product.title.group.certificate": "Certificato",
	"product.title.group.coating": "Rivestimento",
	"product.title.group.dimensions": "Dimensions",
	"product.title.group.insulationResistanceTest": "Test di resistenza dell'isolamento",
	"product.title.group.labelling": "Etichettatura",
	"product.title.group.management": "Gestione",
	"product.title.group.packing": "Imballaggio",
	"product.title.group.productionProcess": "Processo produttivo",
	"product.title.group.specifications": "Specifiche",
	"product.title.group.stamping": "Punzonatura",
	"product.title.group.surface": "Superficie",
	"product.title.group.surfaceTreatment": "Trattamento superficiale",
	"product.title.group.use": "Uso",
	"product.title.group.weightDiameter": "Peso / diametro",
	"product.title.group.welds": "Saldature",
	"product.title.section.bottom": "Fondo",
	"product.title.section.bundleHeight": "Altezza del carico",
	"product.title.section.bundleWeight": "Peso del carico",
	"product.title.section.coilWeight": "Peso bobina",
	"product.title.section.customerArticle": "Articolo cliente",
	"product.title.section.diameter": "Diametro",
	"product.title.section.edge": "Bordo",
	"product.title.section.insideDiameter": "Diametro interno",
	"product.title.section.numberSheetsPerBundle": "Numero di fogli per carico",
	"product.title.section.numberSlitCoilsPerPackage": "Numero di bobine di laminati per pacco",
	"product.title.section.outsideDiameter": "Diametro esterno",
	"product.title.section.packageHeight": "Altezza del imballo",
	"product.title.section.packageHeightWithPalet": "Altezza dell'imballo pallet incluso",
	"product.title.section.packageWeight": "Peso dell'imballo (più di una bobina per imballo)",
	"product.title.section.removableProtectiveFilm": "Pellicola protettiva rimovibile",
	"product.title.section.slabWeightInTon": "Peso della lastra in tonnellate",
	"product.title.section.specificWeight": "Peso specifico",
	"product.title.section.thickness": "Spessore",
	"product.title.section.top": "Superiore",
	"product.title.section.weight": "Peso",
	"product.title.section.width": "Larghezza",
	"profile.no.access": "Per favore, verifica di disporre di un accesso ad internet ed accedi all'applicazione per vedere il profilo.",
	"profile.select": "Profilo - Seleziona",
	"profile.select.visibility": "Seleziona un'azienda/visibilità",
	"profile.visibility.all": "Tutto",
	"progress.message": "La tua transazione è in corso",
	"progress.message.fastlane": "Your transaction is in progress",
	"promote.user.message": "Utente da promuovere:",
	"prototype-card": "Scheda prototipo",
	"prototype-card-details.proposed-price": "Prezzo proposto",
	"prototype-card-details.proposed-price.na": "N/D",
	"prototype-card.data-not-found": "Il prototipo non exist",
	"prototype.card.deliveryweek": "Delivery week",
	"prototype.card.product.source": "source",
	"prototype.card.proposal": "Proposta",
	"prototype.card.proposal.deliveries": "Consegne proposte",
	"prototype.card.proposal.product.information": "Prodotto proposto",
	"prototype.card.proposed.quantities": "Quantità proposta",
	"prototype.card.proposed.readyForDispatch": "Ready for dispatch at PO receipt",
	"prototype.card.request.deliveries": "Consegne richieste",
	"prototype.card.request.information": "Prodotto richiesto",
	"prototype.card.request.quantities": "Quantità richieste",
	"prototype.card.sheetweight": "Peso foglio",
	"prototype.card.status.accepted": "Accettato",
	"prototype.card.status.materialnotfound": "Materiale non disponibile",
	"prototype.card.status.notavailable": "Not available",
	"prototype.card.status.refusedbycustomer": "Rifiutato dal cliente",
	"prototype.card.status.requested": "Richiesta",
	"prototype.production-po-reception-date": "Data di ricezione dell'OP",
	"prototype.production.po-delivery": "Consegna",
	"prototype.production.po.order": "Ordine",
	"prototype.status.accepted": "Accettato",
	"prototype.status.closed": "Closed",
	"prototype.status.confirmed": "Confirmed",
	"prototype.status.decision": "Decisione",
	"prototype.status.proposal": "Proposta",
	"prototype.status.refused": "Rifiutata",
	"prototype.tracker.status": "Stato del prototipo",
	"qty-by-family.title.note": "Si prega di fornire le quantità relative ai periodi di riferimento per questa famiglia",
	"quality.feedback.card.closed.issues": "Problemi risolti",
	"quality.feedback.card.closed.paid": "Pagato",
	"quality.feedback.card.closed.rejected": "Respinto",
	"quality.feedback.card.details": "Mostra dettagli",
	"quality.feedback.card.open.issues": "Questioni aperte",
	"quality.feedback.card.subtitle": "Dettagli reclami chiusi",
	"quality.feedback.card.title": "Feedback sulla qualità",
	"quality.first.selected.batch": "Lotti spediti o pronti alla spedizione dell'ordine",
	"quality.guarantee.request": "Richiesta di garanzia",
	"quality.information": "Informazioni di qualità",
	"quality.issue.save.failed": "Invio problema qualità fallito.",
	"quality.issues.draft.edit": "Può modificarlo nella bozza di follow-up.",
	"quality.issues.draft.saved.successfully": "La bozza è stata salvata",
	"quality.issues.followup": "Potrà visualizzarla nel follow-up di I miei problemi di qualità.",
	"quality.issues.save.failed.message": "Riprovare più tardi oppure contattare ebusiness.support@arcelormittal.com",
	"quality.issues.submitted.successfully": "La sua richiesta su un problema di qualità è stata inviata con successo.",
	"quality.max.selected.batch": "Lotti selezionati (6 lotti al massimo)",
	"quapp.action.add.attach": "Aggiungi un allegato",
	"quapp.action.add.attach.progress": "Aggiunta in corso",
	"quapp.action.cancel": "Annulla problema di qualità",
	"quapp.action.change": "Cambia",
	"quapp.action.delete": "Cancella",
	"quapp.action.edit": "Modifica",
	"quapp.action.go.back": "Indietro",
	"quapp.action.save": "Salva",
	"quapp.action.select.file": "Seleziona il tuo file",
	"quapp.action.send": "Invia",
	"quapp.action.view": "Vedi",
	"quapp.actor.am": "ArcelorMittal",
	"quapp.actor.customer": "Cliente",
	"quapp.alert": "Avviso",
	"quapp.attach.audio": "Audio",
	"quapp.attach.file": "File (PDF, excel...)",
	"quapp.attach.picture": "Foto",
	"quapp.attach.record.sound": "Registra suono",
	"quapp.attach.record.video": "Registra un video",
	"quapp.attach.take.picture": "Scatta una foto",
	"quapp.attach.video": "Video",
	"quapp.detector": "Rilevatore",
	"quapp.error": "Errore",
	"quapp.loading": "Caricamento in corso",
	"quapp.logout.warning1": "Avvertimento!",
	"quapp.logout.warning2": "Disconnettendoti dall'applicazione, perderai tutti i problemi non sincronizzati!",
	"quapp.logout.warning3": "Al momento hai {{value}} azione(i) non sincronizzata(e).",
	"quapp.logout.warning4": "Vuoi davvero disconnetterti?",
	"quapp.notif.claim.cancelled": "{{value}} è stato annullato",
	"quapp.notif.claim.comment": "Commento: {{comment}}",
	"quapp.notif.claim.paid": "{{value}} è stato pagato ({{amount}} {{currency}}, {{quantity}} {{unit}})",
	"quapp.notif.claim.refused": "{{value}} è stato rifiutato",
	"quapp.notif.claim.warning": "{{value}} è stato registrato come avvertimento",
	"quapp.notif.label": "Reclamo aggiornato:",
	"quapp.notif.title": "SteelUser",
	"quapp.notification": "Notifica",
	"quapp.page.not.found": "Pagina non trovata",
	"quapp.process.closed": "Accettato o rifiutato",
	"quapp.process.closed.paid": "Pagato",
	"quapp.process.closed.refused": "Rifiutato",
	"quapp.process.closed.warning": "Registrato come Avvertimento",
	"quapp.process.create": "In attesa di connessione",
	"quapp.process.inprogress": "In corso di elaborazione da parte di ArcelorMittal",
	"quapp.process.push": "Inviato in push a ArcelorMittal",
	"quapp.process.push-cancel": "Annullamento inviato in push a ArcelorMittal",
	"quapp.process.push-update": "Modifica inviata in push ad ArcelorMittal",
	"quapp.process.registered": "Registrato da ArcelorMittal",
	"quapp.reader": "Lettore",
	"quapp.validator": "Validatore",
	"quapp.warning": "Avvertimento",
	"readonly.user.error": "Non ha ancora il consenso per intraprendere azioni in modalità di simulazione, può soltanto consultare la vista cliente",
	"remove.notification": "Rimuovi notifica",
	"remove.unrecognized.batch": "non è un lotto riconosciuto. Selezionare un lotto valido.",
	"request-feasibility": "Request feasibility",
	"request.card.information": "Informazioni sulla richiesta",
	"reset.order": "Ripristino dell'ordine in corso",
	"reset.order.confirmation": "Procedere comunque?",
	"reset.order.warning.add.product.another.family": "Attenzione: Nel carrello sono già presenti uno o più prodotti di un'altra famiglia. L'aggiunta di questo prodotto reimposterà il carrello corrente (tutti i prodotti selezionati).",
	"reset.order.warning.customer.change": "Attenzione: cambiando il cliente di un ordine verrà reimpostato il carrello attuale (tutti i prodotti selezionati).",
	"saBusinessStatus.closed": "Closed",
	"saBusinessStatus.high.risk.external": "High Risk External",
	"saBusinessStatus.high.risk.internal": "High Risk Internal",
	"saBusinessStatus.high.runner": "High runner",
	"saBusinessStatus.low.runner": "Low runner",
	"saBusinessStatus.on.hold": "In attesa",
	"saBusinessStatus.running": "Running",
	"saBusinessStatus.running.out": "Running-out",
	"saBusinessStatus.start.up": "Start-up",
	"sb.Cancel": "Annulla",
	"sb.Download": "Download",
	"sb.choose.options": "Scegli opzioni",
	"sb.detailed.report": "Report dettagliato",
	"sb.period": "Periodo",
	"sb.type": "Tipo",
	"scan.barcode": "Codice a barre",
	"scan.batch.choose": "Scegli questo",
	"scan.browser.title": "Riconoscimento batch",
	"scan.customer": "Cliente",
	"scan.dimensions": "Dimensioni",
	"scan.get.closer": "Avvicinati all'etichetta",
	"scan.go-batch-card": "Vai al display batch",
	"scan.invoiced": "Fatturato",
	"scan.looking.batch.data": "Ricerca dei dati del Lotto in corso...",
	"scan.looking.multi.batch.data": "Ricerca di lotti correlati",
	"scan.material-scan": "Scansione materiale",
	"scan.mill.order": "Ordine stabilimento",
	"scan.quantity": "Quantità",
	"scan.quantity.optional": "Quantità (opzionale)",
	"scan.quantity.placeholder": "Digita quantità spedita",
	"scan.select.batch": "Seleziona il tuo lotto",
	"scan.serial.number": "Numero seriale",
	"scan.serial.number.placeholder": "Digita numero seriale",
	"scan.supplier.order": "Ordine fornitore",
	"scan.tip.disable-tips": "Disabilita consigli",
	"scan.tip.message": "Non riesci a scansionare un codice a barre? Verifica le impostazioni (tasto in alto a destra) per controllare di aver abilitato la modalità di scansione corretta tuo codice a barre.",
	"scan.tip.ok": "Ok",
	"scan.tip.title": "Tip",
	"scan.title": "Scandisci le etichette",
	"scan.weight": "Peso",
	"schedule-business-order-card.commercial-documents": "Documenti commerciali",
	"schedule-business-order-filter.customer-article-reference": "Riferimento articolo cliente",
	"schedule-business-order-filter.thickness": "Spessore",
	"schedule-business-order-filter.width": "Larghezza",
	"schedule-business-order.SA-unit": "Unità SA",
	"schedule-business-order.card": "Scheda dell'ordine SA",
	"schedule-business-order.cem-partner": "Partner CEM",
	"schedule-business-order.certificate": "Certificato",
	"schedule-business-order.choice": "Scelta",
	"schedule-business-order.country-of-scf": "Paese di SCF",
	"schedule-business-order.customer-expected-cumul": "Cliente atteso cumul.",
	"schedule-business-order.customer-realized-cumul": "Cliente concluso cumul.",
	"schedule-business-order.customer.article.reference": "Riferimento articolo cliente",
	"schedule-business-order.customer.order.number": "Numero d’ordine cliente",
	"schedule-business-order.delivery": "Consegna",
	"schedule-business-order.delivery.address": "Indirizzo di consegna",
	"schedule-business-order.delivery.mode": "Modalità di consegna",
	"schedule-business-order.final-use": "Uso finale",
	"schedule-business-order.form": "Modulo",
	"schedule-business-order.icon": "icona",
	"schedule-business-order.in-transit-stock": "Stock in transito",
	"schedule-business-order.incoterm": "Incoterm",
	"schedule-business-order.internal-diameter": "Diametro interno (mm)",
	"schedule-business-order.interpretation-delivery-date": "Interpretazione data di consegna",
	"schedule-business-order.lead-delay": "Anticipo/Ritardo",
	"schedule-business-order.needs": "Bisogni",
	"schedule-business-order.oil-reference": "Riferimento olio",
	"schedule-business-order.order-follow-up-schedule": "Programma di follow-up dell'ordine",
	"schedule-business-order.order-reason": "Motivo dell'ordine",
	"schedule-business-order.packing": "Imballaggio",
	"schedule-business-order.pds-instruction": "Istruzioni PDS",
	"schedule-business-order.plant-stock": "Stock impianto",
	"schedule-business-order.product": "Informazioni sul prodotto",
	"schedule-business-order.product.category": "Categoria prodotto",
	"schedule-business-order.protection": "Protezione",
	"schedule-business-order.realized-cumul": "Conclusi cumul.",
	"schedule-business-order.reference-of-alignment": "Riferimento dell'allineamento",
	"schedule-business-order.sa-business-status": "Stato aziendale SA",
	"schedule-business-order.sfc-country": "Paese SFC",
	"schedule-business-order.shortdescription": "Descrizione breve",
	"schedule-business-order.situation-overview": "Panoramica della situazione",
	"schedule-business-order.standard": "Standard",
	"schedule-business-order.standard.steelgrade": "Grado di acciaio standard",
	"schedule-business-order.stock": "Stock",
	"schedule-business-order.stock-blocked": "Stock bloccato",
	"schedule-business-order.stock-partner": "Stock partner",
	"schedule-business-order.supplier.order.number": "Numero d’ordine fornitore",
	"schedule-business-order.surface-aspect": "Aspetto superficiale",
	"schedule-business-order.time-of-alignment": "Tempo di allineamento",
	"schedule-business-order.transport-mode": "Modalità di trasporto",
	"schedule-business-order.wip": "WIP",
	"search.batches": "Batch",
	"search.by": "cercato da",
	"search.certificates": "Certificati",
	"search.claim": "Reclami",
	"search.count.batches": "Batch {{valore}}",
	"search.count.closed": "{{value}} Problemas de calidad completados",
	"search.count.drafts": "{{value}} Borradores",
	"search.count.orders": "ordini {{valore}}",
	"search.count.pending": "{{value}} Problemas de calidad pendientes",
	"search.dispatch.advices": "Avvisi di spedizione",
	"search.display": "Schermo",
	"search.guarantees": "Garanzie",
	"search.invoices": "Fatture",
	"search.order.acknowledgments": "Conferme d’ordine",
	"search.placeholder": "Cerca...",
	"search.see.result": "Vedi risultato",
	"search.see.results": "Vedi i risultati {{value}}",
	"search.shipment": "Spedizione",
	"search.shipments": "Spedizioni",
	"section.filters": "Filtri",
	"see.all.batches": "See all batches",
	"see.all.documents": "See all documents",
	"select.auction.title": "Seleziona l'asta",
	"select.new.administrator": "La rimozione di questo utente richiederà la selezione di un nuovo amministratore per questa organizzazione:",
	"select.product.spec": "Filtra il tuo catalogo prodotti",
	"sent.closed.no.issue": "Nessun problema chiuso",
	"sent.hide.process": "Nascondi Processo",
	"sent.issue": "Problema di qualità",
	"sent.pending.no.issue": "Nessun problema in sospeso",
	"sent.search.issues": "Cerca problemi",
	"sent.show.process": "Mostra Processo",
	"sent.since": "Da {{value}}",
	"sent.status": "STATO",
	"service.parameters.value": "Valore",
	"services.Back": "TORNA ALL'AGGIUNTA DI UN SERVIZIO",
	"services.management": "Gestione servizi",
	"services.settings": "Impostazioni",
	"settings.account": "Il Mio Account",
	"settings.actions": "Azioni",
	"settings.activity": "Attività",
	"settings.activity-desc": "Ultima attività",
	"settings.add-all-services": "Aggiungi tutti i servizi",
	"settings.all-services-added": "Tutti i servizi aggiunti all'utente",
	"settings.any": "Qualunque",
	"settings.boolean.off": "Off",
	"settings.boolean.on": "On",
	"settings.business-id": "Id azienda",
	"settings.change-simulated-user": "Modifica utente simulato",
	"settings.city": "Città",
	"settings.company": "Società",
	"settings.date-format-dd/mm/yyyy": "gg/mm/aaaa",
	"settings.date-format-mm/dd/yyyy": "mm/gg/aaaa",
	"settings.delegation.changement": "Cambio del mio delegato di organizzazione",
	"settings.download.aggregated": "Aggregato",
	"settings.download.duplicate": "Duplicato",
	"settings.drag-drop-services-here": "Trascina e lascia i servizi da aggiungere qui",
	"settings.drag-services-here": "Trascina i servizi qui per rimuoverli dall'utente",
	"settings.email": "E-mail",
	"settings.faq": "Domande frequenti",
	"settings.firstname": "Nome",
	"settings.gender": "Genere",
	"settings.general": "Impostazioni generali",
	"settings.general.date-format": "Formato data",
	"settings.general.helper": "Impostazioni per le applicazioni del cellulare e parti del web",
	"settings.general.time-format": "Formato ora",
	"settings.generalSalesCondition": "Condizioni Generali di Vendita",
	"settings.identity": "Identità",
	"settings.identity.desc": "Dati personali dell utente",
	"settings.informational-visibilities": "Visibilità informative",
	"settings.last-connection-date": "Ultima data di collegamento",
	"settings.lastname": "Cognome",
	"settings.legal-information": "Note legali",
	"settings.legal-information.property": "La App SteelUser è di proprietà di ArcelorMittal FCE SA, con sede legale in 24-26 Boulevard d'Avranches L-1160 Lussemburgo, Lussemburgo. ",
	"settings.legal-information.questions": "Rivolgi qualsiasi domanda o commento sulla App al nostro team di servizi elettronici:",
	"settings.legal-information.require-registration": "L’utilizzo della app è soggetto a registrazione",
	"settings.login": "Accesso",
	"settings.logout": "Disconnettiti",
	"settings.manage-info-visibilities": "Gestione visibilità informazioni",
	"settings.manage-services": "Gestione servizi",
	"settings.name": "Cognome",
	"settings.order.customer": "Numero ordine cliente",
	"settings.order.number": "Numero ordine",
	"settings.order.supplier": "Numero ordine fornitore",
	"settings.order.tracking": "Tracciamento ordine",
	"settings.ordertracking.sorting.list": "Classificazione elenco automatica",
	"settings.organisation": "Organizzazione",
	"settings.organizations": "Organizzazioni",
	"settings.organizations.desc": "Utenti appartenenti ad una organizzazione",
	"settings.organizations.name": "Nome",
	"settings.organizations.role": "Ruolo",
	"settings.organizations.visibilities.address": "Indirizzo",
	"settings.organizations.visibilities.name": "Nome/Città",
	"settings.other": "Altre impostazioni",
	"settings.password-doesn't-match-rules": "La password non corrisponde alle regole sotto",
	"settings.password-updated-successfully": "Password aggiornata con successo",
	"settings.phone": "Cellulare",
	"settings.phone-number": "Numero di telefono",
	"settings.privacy-policy": "Informativa sulla Privacy",
	"settings.privacypolicy.ContactUs": "Vuoi contattarci?",
	"settings.privacypolicy.ContactUsAddress": "Arcelormital FCE SA, 24-26 boulevard D’avranches L-1160 Luxembourg, Luxembourg",
	"settings.privacypolicy.ContactUsByEmail": "o via email a",
	"settings.privacypolicy.ContactUsPlease": "Invia tutte le domande o i commenti relativi a questa Informativa sulla Privacy a:",
	"settings.privacypolicy.GeneralInformation": "Informazioni Generali",
	"settings.privacypolicy.GeneralInformationProperty": "SteelUser è proprietà di ArcelorMittal France. ArcelorMittal France, società francese registrata nel Registro Commerciale delle Imprese di Bobigny con il n. 562 094 425, avente la propria sede centrale a Immeuble Le Cézanne, 6, rue André Campra, F-93200 Saint-Denis, Francia, ospita il sito SteelUser.com, coordina la manutenzione del sito e gestisce le funzioni di integrazione. Registrandoti come membro di  SteelUser puoi eseguire  transazioni (acquistare, follow up di un ordine online, accedere a documenti di vendita, ecc.) su Internet in totale sicurezza e riservatezza.",
	"settings.privacypolicy.GeneralInformationWebservices": "La piattaforma SteelUser offre ai clienti di ArcelorMittal servizi web avanzati come follow-up di un ordine online, consultazione di documenti commerciali, aste di materiali non-prime, inserimento di ordini web e consultazione di dati tecnici. Semplifica e velocizza i rapporti tra acquirenti di acciaio e ArcelorMittal.",
	"settings.privacypolicy.HypertextLinksContent": "I link utilizzati sulla piattaforma SteelUser che conducono ad altre risorse esistenti su Internet, in particolare ai propri partner, sono stati precedentemente ed espressamente autorizzati per iscritto Gli utenti di SteelUser possono impostare un link a questo sito senza la previa ed espressa autorizzazione di ArcelorMittall.",
	"settings.privacypolicy.PersonalInformation": "Informazioni personali che scegli di fornire",
	"settings.privacypolicy.PersonalInformationContent": "Lo scopo della piattaforma SteelUser è quello di supportare alcuni processi aziendali tra ArcelorMittal, nello specifico gestione degli ordini, follow-up delle controversie, aste, distribuzione di documentazione commerciale e tecnica relativa ai prodotti di ArcelorMittal. Queste funzioni aziendali comportano la gestione delle azioni degli utenti in qualità di rappresentanti dei clienti di ArcelorMittal. Perciò, il modulo di registrazione di SteelUser ti richiede di fornire i tuoi riferimenti (nome del cliente, cognome e nome, informazioni dei contatti e funzione). Se non fornisci le informazioni personali obbligatorie relativamente ad una particolare attività, non potrai impegnarti in questa attività.",
	"settings.privacypolicy.PrivacyPolicy": "Informativa sulla Privacy",
	"settings.privacypolicy.PrivacyPolicyContent": "Per noi è importare proteggere la tua privacy e i tuoi dati personali. ArcelorMittal ha adottato una procedura per la protezione dei dati (“Regole Aziendali Vincolanti”). Questa procedura fornisce una base legale semplificata e globale per tutti gli archivi e le applicazioni che condividono dati personali con il gruppo. La procedura di protezione dei dati di ArcelorMittal è una procedura a livello di gruppo che garantisce uno standard minimo di protezione per i dati personali condivisi a livello globale, simile alla protezione offerta dalle normative UE. La procedura per la protezione dei dati di ArcelorMittal (“Regole Aziendali Vincolanti”), insieme alle policy principali, è pubblicata su",
	"settings.privacypolicy.Property": "Proprietà industriale e intellettuale",
	"settings.privacypolicy.PropertyContent": "Il contenuto della piattaforma SteelUser (inclusi, senza limitazione di caratteri, testo, immagini grafiche, file audio / video, codice HTML, pulsanti, marchi commerciali, software, emblemi) è di proprietà di ArcelorMittal, se non diversamente indicato. Rispetta i diritti relativi a terze parti. Il contenuto non può essere commercializzato, distribuito, trasmesso, copiato, modificato in alcun modo senza il previo consenso scritto di ArcelorMittal. L'uso non autorizzato del contenuto della piattaforma SteelUser è severamente proibito. Farlo costituisce una violazione della legislazione, compresi proprietà intellettuale, proprietà commerciale, nomi commerciali o qualsiasi altro tipo di diritti della proprietà industriale. Gli utenti potranno scaricare, visualizzare o stampare una copia di questa pagina su un personal computer esclusivamente per uso personale e privato.",
	"settings.privacypolicy.Protection": "Protezione dei dati personali",
	"settings.privacypolicy.Protection2years": "In caso di inattività dell'utente per 2 anni, l'accesso SteelUser verrà automaticamente rimosso. Le informazioni personali che non sono più necessarie per soddisfare gli scopi identificati vengono distrutte, cancellate o rese anonime. ArcelorMittal ha sviluppato linee guida e implementato procedure per gestire la distruzione delle informazioni personali.",
	"settings.privacypolicy.ProtectionAbuse": "Per quanto riguarda i dati nominativi a cui possono accedere in qualsiasi archivio, gli utenti devono astenersi da abusi di qualsiasi tipo e da ogni atto che possa compromettere la vita privata o la reputazione delle persone.",
	"settings.privacypolicy.ProtectionCommunication": "ArcelorMittal comunica agli utenti che i loro dati personali non saranno trasmessi a terzi. Ove necessario, verrà richiesta l'autorizzazione illustrando i motivi e le attività per le quali verranno utilizzate le informazioni una volta, e se, concessa l'autorizzazione. I loro dati saranno trattati con assoluta riservatezza. Il consenso dell'utente al trattamento e alla cessione dei propri dati può essere revocato per qualsiasi motivo contattando l'indirizzo di riferimento indicato alla fine di questa sezione. Quando vengono richieste informazioni, si intende che l'utente accetta (i) che ArcelorMittal possa condividere le proprie informazioni all'interno delle proprie sussidiarie (le società sono indicate nella pagina Web www.arcelormittal.com) e (ii) consente ad ArcelorMittal di utilizzare queste informazioni in futuro per informare l'utente su domande o questioni di suo interesse relative ad ArcelorMittal e ai suoi prodotti.",
	"settings.privacypolicy.ProtectionResponsible": "Laddove abbiamo fornito all'utente (o laddove l'utente abbia scelto) una password che consenta all'utente di accedere ad alcune parti del sito SteelUser, l'utente ha la responsabilità di mantenere questa password riservata. Chiediamo all'utente di non condividere una password con nessuno. L'utente si impegna a (a) avvisarci immediatamente di qualsiasi utilizzo non autorizzato della propria password o account o di qualsiasi altra violazione della sicurezza e (b) assicurarsi di uscire dal proprio account al termine di ogni sessione. È responsabilità dell'utente controllare la diffusione e l'uso della propria password, controllare l'accesso al proprio account e il suo uso, e avvisarci quando desidera cancellare il proprio account su questo sito. Non siamo responsabili per eventuali perdite o danni derivanti dal mancato rispetto di questa disposizione.",
	"settings.privacypolicy.ProtectionSecrecy": "ArcelorMittal si impegna ad adempiere al proprio obbligo di segretezza delle informazioni personali. È suo dovere trattarli con riservatezza e adottare le necessarie misure di sicurezza di natura tecnica e organizzativa per evitare l'alterazione, la perdita o l'accesso non autorizzato a tali informazioni.",
	"settings.privacypolicy.ResponsabilitiesContent": "ArcelorMittal implementa la piattaforma SteelUser per offrire agli utenti dati e/o strumenti disponibili e verificati, ma ArcelorMittal non è responsabile per errori, mancanza di disponibilità dei dati e/o presenza di virus su SteelUser.",
	"settings.privacypolicy.UseCookiesInstalled": "Visitando SteelUser, l'utente accetta che sul proprio software di navigazione possano essere installati dei cookie. I cookie consentono di salvare informazioni rilevanti per la navigazione dell'utente sul sito. Vengono utilizzati da SteelUser solo per garantire il corretto funzionamento delle sezioni private del sito.",
	"settings.privacypolicy.UseCookiesNavigation": "I parametri del software di navigazione consentono all'utente di essere consapevole della presenza del cookie e, ove lo desideri, di rifiutarlo nel modo seguente:",
	"settings.privacypolicy.UseCookiesRefusing": " Tuttavia, l'utente viene informato che il rifiuto dei cookie gli renderà impossibile accedere alle sezioni private del sito, in particolare, che non sarà in grado di condurre transazioni online.",
	"settings.privacypolicy.UseDataProvidedConsultrectify": "Alcuni utenti assumeranno il ruolo di amministratore e gestiranno i profili dei membri per la loro azienda. Gli amministratori devono informare questi utenti del loro diritto di accedere, modificare e sopprimere i profili che li riguardano. Ogni utente di SteelUser ha il diritto di consultare e rettificare i propri dati nominativi, diritto che può esercitare scrivendo al seguente indirizzo: Arcelormital FCE SA, 24-26 boulevard D'avranches L-1160 Luxembourg, Luxembourg o via e-mail all'indirizzo",
	"settings.privacypolicy.UseDataProvidedResponses": "Si informa l'utente che le risposte inserite in SteelUser, in particolare quelle richieste per accedere come membro alle sezioni private di detto sito, possono essere utilizzate da ArcelorMittal e trasferite ai servizi incaricati delle operazioni industriali e commerciali, che sono essenziali per la considerazione e l'elaborazione delle transazioni.",
	"settings.privacypolicy.UseGoogleAnalytics": "Uso di Google Analytics",
	"settings.privacypolicy.UseGoogleAnalyticsContent": "I cookie di Google Analytics vengono utilizzati per raccogliere informazioni anonime su come i visitatori utilizzano il nostro sito Web. Utilizziamo le informazioni per compilare resoconti e per aiutarci a migliorare il sito.  I cookie raccolgono le informazioni in forma anonima e includono il numero di visitatori del sito, da dove provengono e le pagine che hanno visitato. Per ottenere informazioni su come Google utilizza i dati, consultare il seguente URL:",
	"settings.privacypolicy.Worldwidetransfer": "Trasferimento dati personali a livello mondiale",
	"settings.privacypolicy.amwebsite": "Sito Web di ArcelorMittal",
	"settings.privacypolicy.creditsforpictures": "Crediti per le immagini",
	"settings.privacypolicy.hypertextlinks": "Link Ipertestuali",
	"settings.privacypolicy.ifyouareusing": "Se stai usando",
	"settings.privacypolicy.responsabilities": "Resposabilità",
	"settings.privacypolicy.tableofcontent": "Indice dei contenuti",
	"settings.privacypolicy.usecookies": "Utilizzo di cookies",
	"settings.privacypolicy.usedataprovided": "Utilizzo dei dati forniti",
	"settings.privacypolicy.worldwidetransfercontent": "Possono accedere a SteelUser le entità di ArcelorMittal in tutto il mondo. I dati personali verranno utilizzati solo per le finalità descritte nella presente Informativa sulla Privacy. Deve essere garantito un livello adeguato di protezione e devono essere adottate misure di sicurezza appropriate al fine di proteggere tali dati personali da distruzione accidentale o illecita o perdita accidentale, alterazione, divulgazione o accesso non autorizzati. Utilizzando SteelUser acconsenti ad ogni trasferimento di questo tipo.",
	"settings.product": "Prodotto",
	"settings.product.article": "Riferimento articolo cliente",
	"settings.product.standard.dimension": "Grado di acciaio standard + Dimensioni",
	"settings.product.steelgrade": "Grado di acciaio",
	"settings.profile": "Profilo",
	"settings.remove-service": "Rimuovi servizio",
	"settings.remove-service-confirmation": "Vuoi davvero eliminare questo servizio?",
	"settings.requested.email": "Requested Email",
	"settings.sales.framework": "Quadro di riferimento per le vendite",
	"settings.save-changes": "Salva modifiche",
	"settings.scan": "Scansiona",
	"settings.scan.beep": "Bip",
	"settings.scan.display-tip": "Visualizza consiglio",
	"settings.scan.mode": "Modalità scansione",
	"settings.scan.mode.laser": "Modalità laser / valore singolo",
	"settings.scan.mode.matrix": "Zone matrice / multiple",
	"settings.select.download-type": "Scegli come scaricare i dati:",
	"settings.select.language": "Seleziona la lingua:",
	"settings.select.order.number": "Seleziona come vuoi visualizzare i riferimenti ordine:",
	"settings.select.ordertracking.sortlist": "Seleziona come vuoi classificare l’elenco nel tracciamento ordini:",
	"settings.select.product": "Seleziona come vuoi visualizzare il prodotto:",
	"settings.select.scan.beep": "Vuoi avvertire un bip a ogni riconoscimento del valore:",
	"settings.select.scan.mode": "Seleziona in quale modalità vuoi eseguire la scansione:",
	"settings.select.weight": "Seleziona come vuoi visualizzare il peso:",
	"settings.services-mangement": "Gestione servizi",
	"settings.snackbar.downloadType": "Ora il tuo tipo di download è {{downloadType}}.",
	"settings.snackbar.language": "La vostra lingua è ora l'italiano.",
	"settings.snackbar.order": "Ora il tuo riferimento ordina visualizzato è",
	"settings.snackbar.product": "Ora il tuo prodotto visualizzato è",
	"settings.snackbar.visibility": "Ora puoi vedere dati per il fornitore",
	"settings.snackbar.weight": "Ora il tuo peso visualizzato é",
	"settings.supplier": "Fornitore",
	"settings.survey.wot.overview": "la nuova pagina di riepilogo degli ordini e delle consegne",
	"settings.terms.of.use": "Termini d'uso",
	"settings.time-format-12:00": "12:00",
	"settings.time-format-24:00": "24:00",
	"settings.update.validate": "Conferma",
	"settings.user-update-error": "Si è verificato un errore durante l'aggiornamento dell'utente, le modifiche non verranno salvate.",
	"settings.visibility": "Visibilità",
	"settings.visibility.changeimpact": "La modifica di questo valore influirà su altri sistemi Steeluser",
	"settings.visibility.data": "Attualmente vedo dati per organizzazione - Fornitore",
	"settings.visibility.helper": "Scegli il tuo perimetro per l'applicazione del cellulare e del web",
	"settings.visibility.info": "La visibilità è condivisa tra tutta la piattaforma Steeluser (cellulare e web)",
	"settings.weight": "Peso",
	"settings.weight.gross": "Lordo",
	"settings.weight.net": "Netto",
	"share.view.share": "Condividi",
	"shareview.success.message": "Condiviso con successo",
	"shipment-card.data-not-found": "Shipment data not found",
	"shipment.card": "Scheda spedizione",
	"shipment.card.information": "Informazioni sulla spedizione",
	"shipment.dispatch-advice": "Avvisi di spedizione",
	"shipment.dispatch-advice-date": "Data dell´avvisi di spedizione",
	"shipment.dispatch-advice-number": "Numero avvisi di spedizione",
	"shipment.dispatch-date": "Data di spedizione",
	"shipment.filter.batch-number": "Numero del lotto",
	"shipment.filter.customer": "Cliente",
	"shipment.filter.customer-article-reference": "Riferimento articolo cliente",
	"shipment.filter.customer-order-number": "Numero ordine cliente",
	"shipment.filter.dispatch-advice-date": "Data avvisi di spedizione",
	"shipment.filter.dispatch-advice-number": "Numero avvisi di spedizione",
	"shipment.filter.dispatch-date": "Data di spedizione",
	"shipment.filter.mill": "Stabilimento",
	"shipment.filter.ship-to": "Spedire a",
	"shipment.filter.sold-to": "Venduto a",
	"shipment.filter.standard-steelgrade": "Acciaio standard",
	"shipment.filter.supplier-order-number": "Numero d'ordine del fornitore",
	"shipment.filter.thickness": "Spessore",
	"shipment.filter.transport-mode": "Modalità di trasporto",
	"shipment.filter.transport-reference": "Riferimento trasporto",
	"shipment.filter.width": "Larghezza",
	"shipment.first": "Primo",
	"shipment.last": "Ultimo",
	"shipment.shipped-qty-gross": "Quantità spedita lorda (t)",
	"shipment.step": "Passaggio",
	"shipment.tmode.byairplane": "per via aerea",
	"shipment.tmode.byinlandwaterways": "per via fluviale",
	"shipment.tmode.byrail": "tramite ferrovia",
	"shipment.tmode.byrail.feve": "tramite ferrovia (FEVE)",
	"shipment.tmode.byrailroad": "tramite ferrovia e su strada",
	"shipment.tmode.byroad": "Su strada",
	"shipment.tmode.bysea": "marittimo",
	"shipment.tmode.bytrain": "treno",
	"shipment.tmode.notspecified": "non specificato",
	"shipment.to": "Spedizione a",
	"shipment.transport-reference": "Riferimento trasporto",
	"simulated.customer.updated": "La simulazione cliente è stata aggiornata.",
	"snackbar.add.existing.user.validation.mail-external": "User has been correctly created.",
	"snackbar.add.user.validation.mail-external": "User has been correctly created. An email has been sent to the new user to activate the account.",
	"snackbar.add.user.validation.mail-internal": "User has been correctly created. An email has been sent to the admin for validation.",
	"snackbar.offline": "Devi essere collegato per modificare un’impostazione",
	"snackbar.survey": "Grazie per il tuo tempo, il tuo feedback è molto importante per noi.",
	"sortby.cdd.asc": "CDD asc",
	"sortby.cdd.desc": "CDD disc",
	"sortby.order.asc": "Ordine asc",
	"sortby.order.desc": "Ordine disc",
	"sortby.product.asc": "Prodotto asc",
	"sortby.product.desc": "Prodotto disc",
	"srvmg.requestor.description": "Agire in qualità di richiedente SOX",
	"srvmg.requestor.label": "Richiedente",
	"srvmg.validator.description": "Agire come validatore SOX",
	"srvmg.validator.label": "Validatore",
	"standard-steelgrade": "Standard steelgrade",
	"start.date": "Data inizio",
	"status-group.blocked": "Blocked",
	"status-group.in-consignment": "Available - In consignment",
	"status-group.in-prod": "In Production",
	"status-group.in-transit": "In transito dal cliente",
	"status-group.rtt": "Pronto alla Spedizione",
	"steelgrade-feasibility": "Steelgrade",
	"stock-alert.green": "Green",
	"stock-alert.orange": "Orange",
	"stock-alert.red": "Red",
	"submit.guarantee.request": "Invia la tua richiesta di garanzia",
	"supplier.comment": "Commento fornitore",
	"suppliergroup.amds": "ArcelorMittal Distribution Solutions",
	"suppliergroup.aperam": "Aperam",
	"suppliergroup.fce": "ArcelorMittal FCE",
	"survey.agree": "aono d'accordo",
	"survey.amount.of.time": "tempo che ho impiegato per trovare informazioni",
	"survey.answer.dialog.title": "Ti preghiamo di valutare l'usabilità di",
	"survey.clarity.information": "chiarezza delle informazioni",
	"survey.disagree": "non sono d'accordo",
	"survey.ease.find.information": "facilità di ricerca delle informazioni",
	"survey.evaluate.statement": "Valuta le 3 seguenti affermazioni",
	"survey.header.title": "Aiutaci a migliorare",
	"survey.statements": "Sono soddisfatto del",
	"survey.strongly": "Molto",
	"table.no.results": "nessun risultato",
	"table.results": "{{value}} risultati",
	"term.policy": "Termini e politiche",
	"title.product.catalogue": "Aggiungi un nuovo prodotto al catalogo",
	"title.product.order": "Scegli il prodotto da ordinare",
	"tmode.byair": "In aereo",
	"tmode.bysea": "Marittimo",
	"tmode.default": "_Predefinito",
	"tmode.inlandwaterway": "Fluviale",
	"tmode.lorry": "Camion",
	"tmode.lorryrailway": "Camion + Ferrovia",
	"tmode.othertospecify": "Altro (da precisare)",
	"tmode.rail": "Ferroviario",
	"tmode.railwaylorry": "Ferrovia + camion",
	"total.quantity.period": "Quantità totale per il periodo",
	"transport.mode": "Modalità di trasporto",
	"transport.mode.boat": "Nave",
	"transport.mode.plane": "Aereo",
	"transport.mode.train": "Treno",
	"transport.mode.truck": "Camion",
	"transversal.dashboard": "Pannello di controllo",
	"transversal.dashboard.plural": "Dashboard",
	"transversal.data-administration": "Amministrazione",
	"transversal.data-center": "Data center",
	"transversal.data-center-batches": "Lotti",
	"transversal.data-center-documents": "Documenti commerciali",
	"transversal.data-center-order": "Ordini",
	"transversal.data-center.batches": "Data center: Lotti",
	"transversal.data-center.plural": "Centri elaborazione dei dati",
	"transversal.data-center.prototype": "Prototypes",
	"transversal.data-center.users": "Utenti",
	"transversal.delegated-to": "Delegato a",
	"transversal.eoffer": "eOffer",
	"transversal.equality": "eQuality",
	"transversal.go-back-to-old-steeluser": "Vai al sistema legacy",
	"transversal.guarantee-documents": "Documenti di garanzia",
	"transversal.home": "Home",
	"transversal.in-a-delegation": "(en una delega)",
	"transversal.lastbatches": "Ultimi lotti",
	"transversal.legal": "Note legali",
	"transversal.order-tracking": "Tracking dell'ordine",
	"transversal.order.delivery": "Ordine e consegna",
	"transversal.quality": "Qualità",
	"transversal.schedule-busiess-order": "Pianifica ordini commerciali",
	"transversal.services": "Servizi",
	"transversal.shipments": "Spedizioni",
	"transversal.simulation-of": "Simulazione di",
	"transversal.steeluser": "SteelUser",
	"unit.kg": "kg",
	"unit.m2": "m²",
	"unit.pc": "Pezzi",
	"unit.to": "Tonnellata",
	"unrecognized.batch": "Lotto non riconosciuto",
	"upload.file.count.error.message": "-max-count- files maximum per item",
	"upload.file.error.message": "An error occured during uploading process",
	"upload.file.maxitem.error.message": "3 files maximum per item",
	"upload.file.mime.type.error.message": "PDF, DOC, XLS, PPT or images only allowed. Upload type is MIME--TYPE",
	"upload.file.name.error.message": "Invalid file name - Use alphanumeric, hyphens, spaces, underscores and at least 5 characters",
	"upload.file.size.error.message": "Max file size is 20MB",
	"upload.file.space.error.message": "Sorry: not enough space to add automatically template file as attachment",
	"upload.or": "or",
	"user.belong.to": "Appartengo a",
	"user.card.about-cookies": "I cookie sono piccoli file di testo che possono essere usati dai siti web per rendere l'esperienza utente più efficiente. La legge prevede che possiamo salvare i cookie sui dispositivi dei visitatori soltanto se strettamente necessairo ai fini del funzionamento del sito. Per qualunque altro tipo di cookie, abbiamo bisogno del suo permesso. Questo sito utilizza diversi tipi di cookie. Alcuni cookie sono salvati da parte di servizi di terza parte che appaiono sulle nostre pagine. Lei può modificare in qualunque momento il consenso oppure revocarlo quando vede apparire l'informativa sulla gestione dei cookie sul nostro sito web. Per ulteriori informazioni su chi siamo, può contattarci, invece per gestire i dati personali la preghiamo di consultare la nostra Politica sulla privacy.",
	"user.card.about-cookies.title": "Informazioni sui cookie",
	"user.card.accept": "Accetta",
	"user.card.account-info": "Informazioni del conto",
	"user.card.allowed": "Consentiti",
	"user.card.apply": "Applica",
	"user.card.audience-measurement-cookies": "Utilizziamo cookie di misurazione dell'audience, il cui scopo è limitato alla sola misurazione della performance dell'audience del sito web o dell'applicazione, il rilevamento di problemi di navigazione, l'ottimizzazione delle prestazioni tecniche o dell'ergonomia, la stima della potenza dei server necessari, l'analisi del contenuto costruito esclusivamente per conto di Arcelor Mittal",
	"user.card.audience-measurement-cookies.title": "Cookie di misurazione dell'audience",
	"user.card.cookies-exempt-from-consents.one": "I cookie che mantengono la scelta espressa dagli utenti sulla repository di tracciamento.",
	"user.card.cookies-exempt-from-consents.three": "I cookie per la personalizzazione dell'interfaccia utente (ad es. la scelta della lingua o la presentazione di un servizio), dove tale personalizzazione è un elemento intrinseco e atteso del servizio.",
	"user.card.cookies-exempt-from-consents.title": "Cookie che non necessitano del consenso",
	"user.card.cookies-exempt-from-consents.two": "I cookie necessari per l'autenticazione per un servizio, compresi quelli atti a garantire la sicurezza del meccanismo di autenticazione, ad esempio limitando i tentativi di accesso indesiderati o da robot.",
	"user.card.details": "Dettagli",
	"user.card.not-allowed": "Non consentito",
	"user.card.notifications": "Notifiche",
	"user.card.notifications.no-data": "Non hai notifiche",
	"user.card.notifications.tab.description": "Descrizione",
	"user.card.notifications.tab.details": "Dettagli",
	"user.card.notifications.tab.frequency": "Frequenza",
	"user.card.notifications.tab.service": "Servizio",
	"user.card.notifications.tab.subscription": "Sottoscrizione",
	"user.card.notifications.title": "Notifiche",
	"user.card.notifications.title.desc": "Elenco di avvisi per questo utente",
	"user.card.personalcard": "Carta personale",
	"user.card.personalize-privacy-settings.title": "Personalizza le impostazioni della privacy",
	"user.card.privacy-settings": "Impostazioni privacy",
	"user.card.reject": "Rifiuta",
	"user.card.security": "Sicurezza",
	"user.card.security.1-lowercase-letter-rule": "1 lettera minuscola (a, b, c, d, e)",
	"user.card.security.1-number-rule": "1 numero (1, 2, 3, 4)",
	"user.card.security.1-special-character-rule": "1 carattere speciale (:, /, !, _, -, #, @)",
	"user.card.security.1-uppercase-letter-rule": "1 lettera maiuscola (A, B, C, D, E)",
	"user.card.security.15-character-rule": "Minimo 15 caratteri",
	"user.card.security.change-login-title": "Change your login",
	"user.card.security.change-password-title": "Cambia la password",
	"user.card.security.confirm-password-match": "La conferma della password deve corrispondere alla nuova password",
	"user.card.security.password-must-contain-title": "Per essere valida, la password deve contenere almeno:",
	"user.card.security.username-error": "Please enter valid username",
	"user.card.security.your-current-password": "La tua password attuale",
	"user.card.security.your-login": "Your login",
	"user.card.security.your-new-password": "La tua nuova password",
	"user.card.security.your-repeat-new-password": "Ripeti la tua nuova password",
	"user.card.services": "Servizi",
	"user.card.services.no-data": "Non hai alcun servizio",
	"user.card.services.tab.desc": "Descrizione",
	"user.card.services.tab.name": "Nome",
	"user.card.services.tab.settings": "Impostazioni",
	"user.card.services.title": "Lista dei servizi",
	"user.card.services.title.desc": "Elenco di tutti i servizi disponibili per questo utente nel contesto del relativo fornitore",
	"user.card.settings": "Parametri",
	"user.expired": "Expired",
	"user.expiryDate": "Expiry date",
	"user.gender.mr": "Sig.",
	"user.gender.mrs": "Sig.ra",
	"user.gender.ms": "Sig.na",
	"user.language": "Lingua",
	"user.need.connection": "L’accesso alla sezione esige l’autentificazione.",
	"user.no.connection": "Devi disporre di una connessione valida per accedere a questa sezione.",
	"user.no.role": "Il tuo profilo non gestisce problemi di qualità. Contatta il tuo relè SteelUser per accedere senza limiti al servizio Quality App.",
	"user.no.service": "Il tuo profilo non può gestire un problema di qualità. Ti invitiamo a contattare il tuo Relay SteelUser per ottenere l'accesso al servizio di Quality App.",
	"user.notifications.add.subscription": "Aggiungi",
	"user.notifications.btn.add.subscription": "Aggiungi sottoscrizione",
	"user.notifications.dialog.subscription": "Aggiungi una sottoscrizione",
	"user.notifications.dropdown.frequency": "Frequenza",
	"user.notifications.dropdown.services": "Servizi",
	"user.notifications.dropdown.subscription": "Abbonamento",
	"user.notifications.select.frequency": "Seleziona una frequenza",
	"user.notifications.select.service": "Seleziona un servizio",
	"user.notifications.select.subscription": "Seleziona un abbonamento",
	"user.see.data": "Attualmente visualizzo i dati per",
	"user.supplier": "Il mio fornitore",
	"user.user": "Utente",
	"user.validation": "L'utente è richiesto",
	"user.validationDaysLeft": "ValidationDaysLeft",
	"userServiceInfo.services.management": "Servizi attivi",
	"userServiceInfo.services.settings": "Impostazioni",
	"users.details-card.actions": "Azioni",
	"users.list": "Elenco utenti",
	"view.shared.success": "Vuoi davvero eliminare questa bozza {{value}}?",
	"view.validation": "L'opinione è obbligatoria",
	"viewby.cdd.asc": "CDD (data di consegna contrattuale) asc",
	"viewby.cdd.desc": "CDD disc",
	"viewby.mill.asc": "Acciaieria asc",
	"viewby.mill.desc": "Acciaieria disc",
	"viewby.product.asc": "Prodotto asc",
	"viewby.product.desc": "Prodotto disc",
	"viewby.step": "Passaggio",
	"wait.message": "Ti preghiamo di NON CLICCARE il pulsante Indietro o il pulsante Aggiorna nel browser",
	"wait.message.fastlane": "Please DO NOT PRESS back button or refresh button in your browser",
	"wait.user.validation": "Waiting for user validation",
	"want.to.cancel.issue": "Do you really want to cancel this issue",
	"want.to.close": "Sei sicuro di voler chiudere?",
	"want.to.delete.draft": "Vuoi davvero eliminare questa bozza",
	"want.to.delete.notification": "Vuoi davvero eliminare questa notifica?",
	"warning-product-category": "Please select a product category.",
	"warning-standard-steelgrade": "Please select a standard steelgrade.",
	"warning-steelgrade": "Please select a steelgrade.",
	"warning-sub-category": "Please select a sub category.",
	"warning-thickness": "Please enter thickness.",
	"warning-width": "Please enter width.",
	"warning.closed.orders": "You are writing a comment on a closed order",
	"warning.maximum.1000": "Impossibile scaricare più di 1000 record per volta",
	"warning.maximum.30": "Impossibile scaricare più di 30 record per volta",
	"woe.noitems": "Nessuna Posizione",
	"workflow-steps.next.error": "Qualcosa è andato storto, contattare l'amministratore SteelUser",
	"xcarb-document.card": "XCarb® Document",
	"xcarb.label": "XCarb®"
};
